<template>
  <div>
    <div v-show="!cooperate">
      <!--创建合同-->
      <div>
        <div class="info-all" v-if="nextstep">
          <!--左侧-->
          <el-aside width="3.2rem" class="aside-left" :style="{ height: boxHeight }">
            <p class="page-total">
              <span class="tit">签署文件列表</span>
              <span>（共{{ fileList.length }}个）</span>
            </p>
            <div class="aside-left_flex">
              <div class="page-con" :style="{ height: leftCSideHeight }">
                <template v-for="(file, i) in fileList">
                  <div
                    :key="i"
                    @click="chooseFile(file, i)"
                    :class="checkAct === i ? 'active' : ''"
                    class="list"
                  >
                    <el-tooltip effect="light" placement="right-start">
                      <div slot="content">此文件设置有签署位置</div>
                      <i v-show="filePage(file)" class="icon icon-status_sign"></i>
                    </el-tooltip>
                    <span
                      class="tpl-icon tpl-posi"
                      style="z-index: 1"
                      v-show="
                        beWord(file.fileName) ||
                        (file.useTo && file.useTo === 1)
                      "
                      @click="InOnlyOffice(file, i)"
                    >编辑</span>
                    <div class="bx">
                      <img :src="fileIcon(file)" />
                    </div>
                    <p class="title" :title="file.fileName">{{ file.fileName }}</p>
                  </div>
                </template>
              </div>
              <div>
                <!--                <div-->
                <!--                  v-if="fileImgName"-->
                <!--                  class="file-img-btn"-->
                <!--                  @click="fileImgShow = !fileImgShow"-->
                <!--                >-->
                <!--                  {{ fileImgName || "" }}-->
                <!--                  <strong-->
                <!--                    class="file-arrow"-->
                <!--                    :class="-->
                <!--                fileImgShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'-->
                <!--              "-->
                <!--                  ></strong>-->
                <!--                </div>-->
                <transition name="el-zoom-in-top">
                  <div class="list-pages" :style="{ height: leftCSideHeight }">
                    <template v-for="i in contractInfoTemporary.items">
                      <div
                        @click="getContractDetailByNum(i)"
                        :class="currentInfo.page === i ? 'active' : ''"
                        :key="i"
                        class="listDetail"
                      >
                        <!--                        <img-->
                        <!--                          v-if="contractList[i] && contractList[i].url"-->
                        <!--                          :src="contractList[i].url"-->
                        <!--                        />-->
                        <!--                        <img v-else src="/images/contr_default.jpg" alt="" />-->
                        <img :src="imgShowFn(i)" />
                        <span>{{ i }}</span>
                        <el-tooltip effect="light" placement="right-start">
                          <div slot="content">此页面设置有签署位置</div>
                          <i v-show="fixedFilePage(i)" class="icon icon-status_sign"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </div>
                </transition>
              </div>
            </div>
          </el-aside>
          <transition name="el-fade-in">
            <div class="aside" :style="{ height: boxHeight }" v-show="drawerShow"></div>
          </transition>
          <transition name="my">
            <div class="aside-content" :style="{ height: boxHeight }" v-show="drawerShow">
              <div class="aside-top">
                仅供参与方查阅，不用于签署（共
                {{ this.enclosureFilesList.length }} 份）
                <span
                  class="el-icon-error"
                  @click="drawerShow = false"
                ></span>
              </div>
              <div class="aside-box" :style="{ height: windowHeight - 120 + 'px' }">
                <div class="enclosure-box">
                  <div
                    class="enclosure-item"
                    v-for="(item, index) in enclosureFilesList"
                    :key="index"
                  >
                    <!--预览-->
                    <div class="li-preview">
                      <!--图片和video预览-->
                      <span
                        class="el-icon-view"
                        title="预览"
                        v-if="isImg(item) || isVideo(item)"
                        @click="previewVideOrImg(item)"
                      ></span>
                      <!-- 文档预览-->
                      <span
                        class="el-icon-view"
                        title="预览"
                        v-if="isDoc(item)"
                        @click="previewDoc(item)"
                      ></span>
                      <a :href="downloadAttatchFile(item)" target="_blank">
                        <span class="el-icon-download" title="下载"></span>
                      </a>
                    </div>
                    <div class="li-con">
                      <div class="t-do">{{ getEnclosureSuffix(item) }}</div>
                      <h1 :title="item.fileName">{{ item.fileName }}</h1>
                    </div>
                  </div>
                </div>
                <no-data v-if="enclosureFilesList.length === 0" text="暂无数据" slot="empty" />
              </div>
            </div>
          </transition>
          <div class="aside-tab" :class="drawerShow ? 'open' : 'close'">
            <div class="tab" @click="openTab" :class="drawerShow ? 'active' : ''">
              <i class="el-icon-circle-plus"></i>
              <span class="word">附属材料&nbsp;&nbsp;</span>
              <i
                :class="
                  drawerShow ? 'el-icon-arrow-left' : 'el-icon-arrow-right'
                "
              ></i>
            </div>
          </div>
          <!--合同显示详情-->
          <el-main class="main-content" :style="{ height: boxHeight }">
            <contract-view
              ref="contractView"
              :contract-info.sync="currentInfo"
              :chapter-list.sync="chapteJson"
              :items="contractInfoTemporary.items"
              :page="currentInfo.page"
              :scaleValue.sync="scaleValue"
              :targetId="contractInfoTemporary.targetId"
              :show-chapter="true"
              :qifengChapList="qifengChapList"
              :signatory-json="signatoryJson"
              :hideSignDate="contractInfo.hideSignDate"
              @updateQifeng="updateQifeng"
              @delQifeng="delQifeng"
              @del-chapte="delChapteByCindex($event)"
              @pre-page="getContractDetailByNum($event)"
              @next-page="getContractDetailByNum($event)"
              @changeSmallMap="changeSmallMap"
              @toCurrentPage="toCurrentPage"
            />
            <div class="contract-bottom">
              <template
                v-if="
                  contractInfoTemporary &&
                  contractInfoTemporary.items &&
                  contractInfoTemporary.items > 1
                "
              >
                <p
                  style="font-weight: bold; text-align: center"
                >{{ currentInfo.page }}/{{ contractInfoTemporary.items }}</p>
                <!-- checkAct: -1, // 当前显示合同选中文件 -->
                <el-tooltip effect="light" placement="left-start">
                  <div slot="content">回到首页</div>
                  <span class="jumpFirst" @click="goPageAndFixed(1)">
                    <img src="../../assets/images/btn-down.png" />
                  </span>
                </el-tooltip>
                <el-tooltip effect="light" placement="left">
                  <div slot="content">上一页</div>
                  <span
                    @click="
                      goPageAndFixed(
                        currentInfo.page > 1 ? currentInfo.page - 1 : 1
                      )
                    "
                    class="el-icon-arrow-up prev_next_span"
                  ></span>
                </el-tooltip>
                <el-tooltip effect="light" placement="left">
                  <div slot="content">下一页</div>
                  <span
                    @click="
                      goPageAndFixed(
                        contractInfoTemporary.items > currentInfo.page
                          ? currentInfo.page + 1
                          : contractInfoTemporary.items
                      )
                    "
                    class="el-icon-arrow-down prev_next_span"
                  ></span>
                </el-tooltip>
                <el-tooltip effect="light" placement="left-end">
                  <div slot="content">回到尾页</div>
                  <span class="jumpLast" @click="goPageAndFixed(contractInfoTemporary.items)">
                    <img src="../../assets/images/btn-down.png" />
                  </span>
                </el-tooltip>
              </template>
              <el-tooltip effect="light" placement="left-start">
                <div slot="content">编辑</div>
                <span
                  class="jump-edit"
                  v-show="
                    (beWord(fileList[checkAct].fileName) ||
                      (fileList[checkAct].useTo &&
                        fileList[checkAct].useTo === 1)) &&
                    !$route.query.multiFileKey
                  "
                  @click="InOnlyOffice(fileList[checkAct], checkAct)"
                >
                  <i class="el-icon-edit-outline" style="font-size: 20px; color: #ec1c1c"></i>
                </span>
              </el-tooltip>
              <el-tooltip effect="light" placement="left-start">
                <div slot="content">设置骑缝章</div>
                <span
                  class="jump-qifeng"
                  v-show="
                    contractInfoTemporary &&
                    contractInfoTemporary.items &&
                    contractInfoTemporary.items > 1 &&
                    qifengChapList.length
                  "
                  @click="settingQIFENG()"
                >
                  <i class="el-icon-s-check" style="font-size: 20px; color: #ec1c1c"></i>
                </span>
              </el-tooltip>
            </div>
            <!--关闭页码跳转-->
            <div class="page-number" v-if="false">
              <input
                v-model="goPageNum"
                placeholder="输入页码"
                type="number"
                @keyup.enter="handleContractPageClick"
              />
              <a class="inp-in" @click="handleContractPageClick">GO</a>
            </div>
          </el-main>
          <!--右侧-->
          <el-aside width="2.80rem" class="aside-right" :style="{ height: boxHeight }">
            <div class="sign-position-sty pointer">
              <p class="page-total">
                设置签章位置
                <el-tooltip effect="light" placement="bottom-end">
                  <div slot="content">”每一份文件”至少设置一个签章位置，“每个签署方”至少设置一个签署位置</div>
                  <i class="el-icon-question" style="margin-left: 4px"></i>
                </el-tooltip>
              </p>
            </div>

            <!--签署方列表-->
            <div class="list-signers">
              <template v-if="newSignJson">
                <div v-for="(item, index) in newSignJson" :key="index">
                  <!-- 批量签署方 -->
                  <template v-if="item.signOwner === '批量签署方'">
                    <div
                      :class="[
                        'qz-new',
                        { enterprise_qz_new: item.signatoryUserType },
                      ]"
                      :key="index"
                      draggable="true"
                      @dragend="dragQZEnd($event, item)"
                    >
                      <div draggable="true" @click="handleAddChapter(item, index)">
                        <!--                        <h1>{{ item.signOwner }}</h1>-->
                        <h1>签署方</h1>
                        <div class="point-num">
                          <el-tooltip effect="light" placement="bottom-end">
                            <div slot="content">表示该签署方在“当前文件”中设置的“签章位置”数量</div>
                            <span class="n">
                              {{
                              signOwnerLen(item.signOwner)
                              }}
                            </span>
                          </el-tooltip>
                          <el-tooltip effect="light" placement="bottom-end">
                            <div slot="content">表示该签署方在“所有文件”中设置的“签章位置”数量</div>
                            <span class="l">
                              {{
                              signOwnerAll(item.signOwner)
                              }}
                            </span>
                          </el-tooltip>
                        </div>
                        <div class="con con1">在各自收到的文件中，独自签署</div>
                        <img src="../../assets/images/move-icon.png" />
                        <span v-if="contractInfo.hideSignDate" class="time">日期：XXXX</span>
                      </div>
                    </div>
                  </template>
                  <!-- 普通签署方 -->
                  <template v-else>
                    <div
                      :class="[
                        'qz-new',
                        { enterprise_qz_new: item.signatoryUserType === 1 },
                      ]"
                      :style="{
                        width: item.signatoryUserType === 1 ? 208 : 115,
                        height:
                          parseInt(item.signatoryUserType === 1 ? 230 : 101) -
                          parseInt(contractInfo.hideSignDate ? 22 : 0),
                      }"
                      :key="index"
                      draggable="true"
                      ref="step1"
                      id="step1"
                      @dragend="dragQZEnd($event, item, index)"
                    >
                      <!--
                :style="{width:item.signatoryUserType ? 208 : 115,height:item.signatoryUserType ? 230 : 79}"
                -parseInt(!contractInfo.hideSignDate ? 22 : 0) // 显示的时间印章高度
                盖章位置用的实际数据
                      -->
                      <div draggable="true" @click="handleAddChapter(item, index)">
                        <!--                        <h1>{{ item.signOwner }}</h1>-->
                        <h1>签署方</h1>
                        <div class="point-num">
                          <el-tooltip effect="light" placement="bottom-end">
                            <div slot="content">表示该签署方在“当前文件”中设置的“签章位置”数量</div>
                            <span class="n" ref="step2" id="step2">
                              {{
                              signOwnerLen(item.signOwner)
                              }}
                            </span>
                          </el-tooltip>
                          <el-tooltip effect="light" placement="bottom-end">
                            <div slot="content">表示该签署方在“所有文件”中设置的“签章位置”数量</div>
                            <span class="l" ref="step3" id="step3">
                              {{
                              signOwnerAll(item.signOwner)
                              }}
                            </span>
                          </el-tooltip>
                        </div>
                        <div
                          :class="[
                            'con',
                            {
                              enterprise_con: item.signatoryUserType === 1,
                            },
                          ]"
                          :style="{ paddingTop: item.forge ? '2px' : '18px' }"
                        >
                          <p :class="{ line_clamp2: item.forge }">
                            {{
                            (`${item.forge ? "经办人-" : ""} ` + item.name)
                            | eclipse
                            }}
                          </p>
                        </div>
                        <img src="../../assets/images/move-icon.png" />
                        <span v-if="contractInfo.hideSignDate" class="time">日期：XXXX</span>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
            <div class="right-bottom">
              <el-button
                @click="sendContractToCreateNow(false)"
                type="danger"
                :disabled="isSaveDisable"
                :class="{ 'g-save-disable': isSaveDisable }"
                size="mini"
              >立即发起</el-button>
              <!--              <el-button-->
              <!--                @click="saveAsDraft(true)"-->
              <!--                :disabled="isSaveDisable"-->
              <!--                :class="{ 'g-save-disable': isSaveDisable }"-->
              <!--                size="mini"-->
              <!--                >存为草稿</el-button-->
              <!--              >-->
              <el-button @click="backStep" size="mini">上一步</el-button>
            </div>
          </el-aside>
          <!--签署指引-->
          <div v-if="guideStep && false" class="apply-guide">
            <div class="box" ref="guideBox">
              <div v-if="guideStep !== 'step4'" class="tooltip tooltip-bottom" ref="tooltip">
                <div v-show="guideStep === 'step1'">
                  <div class="tooltip-text">
                    <span>1</span>拖动签署方至左侧预览内容中，指定该签署方在文件中签章的位置
                  </div>
                  <div class="tooltiop-btns">
                    <a @click="guideApplyCancel" href="javascript:void (0)">关闭引导</a>
                    <a @click="guideApply('step2')" href="javascript:void (0)">signatoryJson</a>
                  </div>
                  <div class="tooltip-arrow" style="left: 65%"></div>
                </div>
                <template v-if="guideStep === 'step2'">
                  <div class="tooltip-text">
                    <span>2</span>表示该签署方在 “ 当前 ” 文件中设置的 “
                    签章位置 ” 数量
                  </div>
                  <div class="tooltiop-btns">
                    <a @click="guideApply('step1')" href="javascript:void (0)">上一步</a>
                    <a @click="guideApply('step3')" href="javascript:void (0)">下一步</a>
                  </div>
                  <div class="tooltip-arrow" style="left: 92%"></div>
                </template>
                <template v-if="guideStep === 'step3'">
                  <div class="tooltip-text">
                    <span>3</span>表示该签署方在 “ 所有 ” 文件中设置的 “
                    签章位置 ” 数量
                  </div>
                  <div class="tooltiop-btns">
                    <a @click="guideApply('step2')" href="javascript:void (0)">上一步</a>
                    <a @click="guideApplyCancel" href="javascript:void (0)">知道了</a>
                  </div>
                  <div class="tooltip-arrow" style="left: 75%"></div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <el-container class="to-create">
          <el-main v-loading="batchLoading" v-show="!nextstep" class="cont-info-form">
            <!--签署指引-->
            <div v-if="guideSignStep && false" class="apply-sign-guide"></div>
            <div class="apply-sign-guide-box" ref="guideBox">
              <div v-if="guideSignStep !== 'signStep6'">
                <template v-if="guideSignStep === 'signStep1'">
                  <div class="tooltip tooltip-bottom tool">
                    <div class="tooltip-text">
                      <span>1</span>确认发起主体是否正确
                    </div>
                    <div class="tooltiop-btns">
                      <a @click="guideSignApplyCancel" href="javascript:void (0)">关闭引导</a>
                      <!-- @click="guideSignApply('signStep2')" -->
                      <a @click="guideSignApply('signStep3')" href="javascript:void (0)">下一步</a>
                    </div>
                    <div class="tooltip-arrow" style="left: 45%"></div>
                  </div>
                </template>
                <!-- <template v-if="guideSignStep === 'signStep2'">
              <div class="tooltip tooltip-bottom tool">
                <div class="tooltip-text">
                  <span>2</span>输入签署业务主题名称
                </div>
                <div class="tooltiop-btns">
                  <a
                    @click="guideSignApply('signStep1')"
                    href="javascript:void (0)"
                    >上一步</a
                  >
                  <a
                    @click="guideSignApply('signStep3')"
                    href="javascript:void (0)"
                    >下一步</a
                  >
                </div>
                <div class="tooltip-arrow" style="left: 62%"></div>
              </div>
                </template>-->
                <template v-if="guideSignStep === 'signStep3'">
                  <div class="tooltip tooltip-bottom1 tool">
                    <div class="tooltip-text">
                      <span>2</span>上传签署文件
                    </div>
                    <div class="tooltiop-btns">
                      <a @click="guideSignApply('signStep1')" href="javascript:void (0)">上一步</a>
                      <a @click="guideSignApply('signStep4')" href="javascript:void (0)">下一步</a>
                    </div>
                    <div class="tooltip-arrow" style="left: 62%"></div>
                  </div>
                </template>
                <template v-if="guideSignStep === 'signStep4'">
                  <div class="tooltip tooltip-bottom tool">
                    <div class="tooltip-text">
                      <span>3</span>添加文件签署（接收）方信息
                    </div>
                    <div class="tooltiop-btns">
                      <a @click="guideSignApply('signStep3')" href="javascript:void (0)">上一步</a>
                      <a @click="guideSignApplyCancel" href="javascript:void (0)">知道了</a>
                      <!--                      <a-->
                      <!--                        @click="guideSignApply('signStep5')"-->
                      <!--                        href="javascript:void (0)"-->
                      <!--                        >下一步</a-->
                      <!--                      >-->
                    </div>
                    <div class="tooltip-arrow" style="left: 92%"></div>
                  </div>
                </template>
                <template v-if="guideSignStep === 'signStep5'">
                  <div class="tooltip tooltip-top tool">
                    <div class="tooltip-text">
                      <span>4</span>设置文件签署位置
                    </div>
                    <div class="tooltiop-btns">
                      <a @click="guideSignApply('signStep4')" href="javascript:void (0)">上一步</a>
                      <a @click="guideSignApplyCancel" href="javascript:void (0)">知道了</a>
                    </div>
                    <div class="tooltip-arrow" style="left: 75%"></div>
                  </div>
                </template>
              </div>
            </div>
            <!-- 发起合同文件上传页面 -->
            <!--主体切换-->
            <div class="tabs-card">
              <div class="tabs-wrap" ref="tab">
                <ul ref="tabitem">
                  <li
                    v-for="(user, index) in totalAccountList"
                    :key="index"
                    ref="signStep1"
                    id="signStep1"
                    :title="user.corpName || user.name || user.username"
                    @click="changeAccount(user, $event)"
                    v-show="
                      user.userStemFrom !== -16 || totalAccountList.length === 1
                    "
                    :class="
                      currentUser && currentUser.corpUserId === user.corpUserId
                        ? 'current'
                        : ''
                    "
                  >
                    <img
                      src="/images/icon/dingIcon.png"
                      alt="钉钉"
                      width="20px"
                      v-if="user.userStemFrom === -16 && !isInDingTalk"
                    />
                    {{ user.corpName || user.name || user.username }}
                  </li>
                  <router-link to="/viewIndex">
                    <li v-if="isInDingTalk">返回首页</li>
                  </router-link>
                </ul>
              </div>
              <div class="more-bg" v-show="totalAccountList.length > 5">
                <div class="more-down" @click="showMoreUser">
                  <span
                    :style="{ color: showAllUser ? '#ec1c1c' : '#000000' }"
                  >{{ showAllUser ? "收起" : "更多" }}</span>
                  <i
                    :class="
                      showAllUser ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
                    "
                  ></i>
                </div>
              </div>
              <div class="pad-bom"></div>
              <goto-auth :authDialog.sync="authDialog"></goto-auth>
            </div>
            <el-collapse-transition>
              <div v-show="showAllUser">
                <div class="card">
                  <div class="card-tit">选择发起主体</div>
                  <div class="card-box">
                    <div class="user-list">
                      <div
                        class="user"
                        v-for="(user, index) in totalAccountList"
                        v-show="
                          user.userStemFrom !== -16 ||
                          totalAccountList.length === 1
                        "
                        :key="index"
                        :class="
                          $store.getters.currentAuthUser &&
                          $store.getters.currentAuthUser.corpUserId ===
                            user.corpUserId
                            ? 'current'
                            : ''
                        "
                        @click="changeAccount(user, $event)"
                      >
                        <img
                          src="/images/icon/dingIcon.png"
                          alt="钉钉"
                          width="20px"
                          v-if="user.userStemFrom === -16 && !isInDingTalk"
                        />
                        {{
                        user.corpName ||
                        user.signatoryFullName ||
                        user.username
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
            <el-form
              size="small"
              ref="contForm"
              :model="contractInfo"
              class="cont-form"
              :label-position="'left'"
              :rules="contractNameRules"
            >
              <!-- 多文件上传 -->
              <div class="card">
                <div class="card-tit">
                  待审阅的文件&nbsp;&nbsp;
                  <span>
                    <el-tooltip effect="light" placement="bottom-end">
                      <div slot="content">
                        电子签名不适用文件:
                        <br />1.涉及婚姻、收养、继承等人身关系的；
                        <br />2.涉及停止供水、供热、供气等公用事业服务的；
                        <br />3.法律、行政法规规定的不适用电子文书的其他情形。
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </span>
                  <span style="font-size: 12px; margin-left: 12px">{{ fileList.length }}/30</span>
<!--                  <div class="right-content">-->
<!--                    <span>需要与外国企业或个人签约？-->
<!--                      <span style="color:#ec1c1c;cursor: pointer;" @click='linkFairsign'>点击前往国际站</span>-->
<!--                    </span>-->
<!--                  </div>-->
                </div>
                <div class="card-box">
                  <div class="file-list">
                    <draggable
                      class="file-draggable"
                      element="ul"
                      :list="fileList"
                      @start="dragging = true"
                      @end="dragging = false"
                      :options="{
                        handle: '.icon-move_box',
                        animation: 200,
                        ghostClass: 'ghost',
                      }"
                      :move="draggingMove"
                      filter=".upload-btn"
                    >
                      <!-- 文件上传 -->
                      <div
                        class="upload-btn"
                        ref="signStep3"
                        id="signStep3"
                        title="小于60M的doc、docx文件"
                        v-show="$route.query.multiFileKey ? false : true"
                      >
                        <el-upload
                          action="#"
                          accept=".doc, .docx"
                          multiple
                          :limit="30"
                          :before-upload="fileOnBeforeUpload"
                          :on-exceed="fileHandleExceed"
                          :show-file-list="false"
                          :file-list="fileList"
                          :on-error="fileOnError"
                          :on-success="fileOnSuccess"
                        >
                          <slot>
                            <div class="upload-content">
                              <span class="el-icon-plus"></span>
                              <p class="tip">上传文件</p>
                            </div>
                          </slot>
                        </el-upload>
                      </div>
                      <!-- 文件列表 -->
                      <template v-for="(file, index) in fileList">
                        <transition-group type="transition" :key="index">
                          <li class="upload-file" :key="index">
                            <div class="bx">
                              <img :src="fileIcon(file)" />
                              <!--蒙层-->
                              <div class="msk">
                                <div class="msk-icon">
                                  <el-tooltip effect="dark" content="预览" placement="bottom-start">
                                    <i
                                      class="el-icon-view pointer"
                                      v-show="!file.isTpl"
                                      @click="previewDoc(file)"
                                    ></i>
                                  </el-tooltip>
                                  <el-tooltip effect="dark" content="编辑" placement="bottom-start">
                                    <i
                                      class="el-icon-edit pointer"
                                      v-show="
                                        (beWord(file.fileName) ||
                                          (file.useTo && file.useTo === 1)) &&
                                        !$route.query.multiFileKey
                                      "
                                      @click="InOnlyOffice(file, index)"
                                    ></i>
                                  </el-tooltip>
                                  <el-tooltip effect="dark" content="删除" placement="bottom-start">
                                    <i
                                      class="el-icon-delete-solid pointer"
                                      @click="removeFile(index, file)"
                                    ></i>
                                  </el-tooltip>
                                </div>
                              </div>
                            </div>
                            <p
                              class="title"
                              :title="file.fileName"
                            >{{ file.fileName || file.tplName + "模板" }}</p>
                            <!--                            <span class="tpl-icon tpl-posi" v-show="file.isTpl"-->
                            <!--                              >模板</span-->
                            <!--                            >-->
                            <!-- 拖动功能拖动之后无法做其他操作 ；先禁用 -->
                            <!-- <div class="icon-move_box"><i></i></div> -->
                          </li>
                        </transition-group>
                      </template>
                    </draggable>
                  </div>
                  <!-- 1125 将附属材料放在了这里 -->
                  <div class="card-box">
                    <div class="enclosureFiles">
                      附属材料&nbsp;&nbsp;
                      <span>
                        <el-tooltip effect="light" placement="bottom-end">
                          <div slot="content">附属材料仅供参与方查阅，不用于签署</div>
                          <i
                            class="el-icon-question"
                            style="
                              display: inline-block;
                              font-size: 16px;
                              cursor: pointer;
                              color: #a1a1a1;
                            "
                          ></i>
                        </el-tooltip>
                      </span>
                      <span
                        style="font-size: 12px; margin: 0 12px"
                      >{{ enclosureFilesList.length }}/30</span>
                      <el-upload
                        action="#"
                        multiple
                        :show-file-list="false"
                        :file-list="enclosureFilesList"
                        :before-upload="enclosureFilesBeforeUpload"
                        :limit="30"
                        :on-exceed="enclosureFilesHandleExceed"
                        :on-error="enclosureFilesError"
                      >
                        <el-button icon="el-icon-plus" size="small"></el-button>
                        <!-- <slot>
                        <div class="box">
                          <span class="el-icon-paperclip"></span>
                          添加附属材料
                        </div>
                        </slot>-->
                      </el-upload>
                      <div
                        class="enclosureFiles-item"
                        v-for="(item, index) in enclosureFilesList"
                        :key="index"
                      >
                        <div class="desc">{{ item.fileName }}</div>
                        <span class="el-icon-error del-btn" @click="delEnclosureFiles(index)"></span>
                      </div>
                    </div>
                  </div>
                  <!-- 1125 原其他设置放在这里 -->
                  <div class="otherSet" v-show="fileList.length > 0 && !collaborationType">
                    <el-form-item
                      label="文件主题名称"
                      label-width="100px"
                      style="margin-right: 40px; display: inline-block"
                    >
                      <el-input
                        style="width: 317px"
                        ref="signStep2"
                        id="signStep2"
                        v-model="contractInfo.contractName"
                        placeholder="请输入主题名称"
                        @blur="validContractName"
                      ></el-input>
                    </el-form-item>
                    <!-- 签署截至 -->
                    <el-form-item
                      :label-width="labelWidth"
                      style="display: inline-block; margin-right: 40px"
                    >
                      <div slot="label">
                        <span>签署链接有效期 &nbsp;</span>
                        <el-tooltip effect="light" placement="bottom-end">
                          <div slot="content">
                            在指定日期之后，签署方若未完成文件签署，
                            <br />签署方接收到的签署 “ 短信/邮件 ” 链接
                            <br />将失效
                          </div>
                          <i
                            class="el-icon-question"
                            style="
                              font-size: 16px;
                              cursor: pointer;
                              color: #a1a1a1;
                            "
                          ></i>
                        </el-tooltip>
                      </div>

                      <el-date-picker
                        class="datep"
                        v-model="signlinktime"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="pickTime"
                        :clearable="clearable"
                        placeholder="选择日期"
                        style="
                          width: 317px;
                          margin-left: -25px;
                          text-align: center;
                        "
                      ></el-date-picker>
                    </el-form-item>
                    <!-- 水印 -->
                    <!--                    <el-form-item-->
                    <!--                      :label-width="labelWidth"-->
                    <!--                      style="display: inline-block; margin-right: 40px"-->
                    <!--                    >-->
                    <!--                      <div slot="label">-->
                    <!--                        <span-->
                    <!--                          >文件水印：{{-->
                    <!--                            waterConfig.switch ? "已打开" : "已关闭"-->
                    <!--                          }}</span-->
                    <!--                        >-->
                    <!--                        <el-tooltip effect="light" placement="bottom-end">-->
                    <!--                          <div slot="content">-->
                    <!--                            水印会在合同发起后添加在所有已上传的签署文件中-->
                    <!--                          </div>-->
                    <!--                          <i-->
                    <!--                            class="el-icon-question"-->
                    <!--                            style="-->
                    <!--                              font-size: 16px;-->
                    <!--                              cursor: pointer;-->
                    <!--                              color: #a1a1a1;-->
                    <!--                            "-->
                    <!--                          ></i>-->
                    <!--                        </el-tooltip>-->
                    <!--                      </div>-->
                    <!--                      <el-button-->
                    <!--                        size="small"-->
                    <!--                        @click="setWatermarkVisible = true"-->
                    <!--                        style="margin-left: -10px"-->
                    <!--                        >设置</el-button-->
                    <!--                      >-->
                    <!--                    </el-form-item>-->

                    <!-- 自定义select 重构  false隐藏 -->
                    <el-form-item v-if="!isGroup && false" label="支付方式" class="bow">
                      <el-select v-model="contractInfo.consumMode" placeholder="请选择">
                        <el-option label="发起方支付全部费用" :value="0"></el-option>
                        <el-option label="各方各自支付自己的费用" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <template v-if="!collaborationType">
                <!-- 签署设置 -->
                <div class="f-center">
                  <el-form-item>
                    <div class="h4">
                      <i></i>签署设置
                      <div class="wp">
                        <div class="radio">
                          <div @click="showMoreSet = !showMoreSet" class="more-set">
                            <!--<span :class="showMoreSet ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right'"></span>-->
                            {{ showMoreSet ? "收起&lt;&lt;" : "我的偏好>>" }}
                          </div>
                          <div v-show="showMoreSet">
                            <el-tooltip effect="light" placement="bottom-end">
                              <div slot="content">
                                测试签约流程时，可关闭数字证书，正式签<br />
                                署时带数字证书可进一步保障签约有效性。
                              </div>
                              <el-checkbox
                                v-show="activeTabsName != signTypes[2]"
                                v-model="contractInfo.serverCa"
                                @change="handleChangeCa"
                                :disabled="contractInfo.consumMode == 1"
                                :true-label="1"
                                :false-label="0"
                              >
                                数字证书
                                <i
                                  class="el-icon-question"
                                  style="
                                  font-size: 16px;
                                  margin-left: 10px;
                                  color: #a1a1a1;
                                "
                                ></i>
                              </el-checkbox>
                            </el-tooltip>
                            <el-checkbox
                              v-show="activeTabsName != signTypes[2]"
                              v-model="contractInfo.needPresSign"
                              :true-label="1"
                              :false-label="0"
                            >保全章</el-checkbox>
                            <el-checkbox
                              v-model="qiFengSign.enterpriseSign"
                              :true-label="1"
                              :false-label="0"
                            >企业骑缝章</el-checkbox>
                            <el-checkbox
                              v-model="qiFengSign.personSign"
                              :true-label="1"
                              :false-label="0"
                            >个人骑缝章</el-checkbox>
                            <!-- 个人图形章 -->
                            <el-checkbox
                              v-model="personImgSign"
                              :true-label="1"
                              :false-label="0"
                            >个人仅可使用图形章</el-checkbox>
                            <!-- 签章时间 -->
                            <el-checkbox
                              v-model="contractInfo.hideSignDate"
                              :true-label="1"
                              :false-label="0"
                            >签章时间</el-checkbox>
                            <el-checkbox v-model="waterConfig.switch">文件水印&nbsp;</el-checkbox>
                            <i
                              class="el-icon-setting"
                              style="cursor: pointer;"
                              @click="setWatermarkVisible = true"
                            ></i>
                            <div style="display: inline-block; line-height: 20px; border: 1px solid #888888; border-radius: 4px; padding: 4px 10px;" v-if="!isInDingTalk" class="prtf-sty" @click="turnPref">偏好设置</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 导入批量签署人文件 -->
                    <input
                      style="
                      display: none;
                      width: 0;
                      height: 0;
                      visibility: hidden;
                    "
                      ref="importBatchFile"
                      type="file"
                      @change="batchFileChange()"
                    />
                  </el-form-item>
                  <el-form-item>
                    <!-- 钉钉微应用（钉钉环境隐藏 快捷签 视频签 tabs） -->
                    <el-tabs
                      :stretch="true"
                      v-model="activeTabsName"
                      v-if="!isInDingTalk"
                      :before-leave="tabHandleBefore"
                      @tab-click="handleTabsClick"
                    >
                      <!-- <el-tab-pane label="标准签" name="signStandard"></el-tab-pane> -->
                      <el-tab-pane label="快捷签" :name="signTypes[0]"></el-tab-pane>
                      <el-tab-pane label="视频签" :name="signTypes[1]"></el-tab-pane>
                      <!-- <el-tab-pane
                        label="国际签"
                        :name="signTypes[2]"
                      ></el-tab-pane> -->
                    </el-tabs>
                  </el-form-item>
                  <el-form-item>
                    <div class="tab">
                      <p class="tips-lab-sty" v-show="activeTabsName === signTypes[2]">
                        <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
                        为适配全球多法域合规要求，保障签署文件的跨境法律效力，国际签采用 SES 形式进行操作，如签署方所在地有法律法规要求，需要使用AES/QES，请联系客服或商务
                      </p>
                      <!-- <div
                        class="face_tips"
                        v-show="activeTabsName === signTypes[0]"
                      >
                        签署时需进行活体人脸识别，人脸识别视频文件将作为签署证据存放至证据包中。
                      </div> -->
                      <div class="tab-top">
                        <div class="top-left" v-show="activeTabsName != signTypes[1]">
                          <el-checkbox v-model="contractInfo.ifOrder">
                            <b>按顺序签署</b>
                            <!--                      <small>/各方按顺序完成签署</small>-->
                          </el-checkbox>
                          <div class="flow-box" @click="visibleSigningFlow = true">
                            <img src="/images/icon/icon-box.png" alt />
                            <span>签署流程图</span>
                          </div>
                        </div>
                        <div class="top-left" v-show="activeTabsName == signTypes[1]">
                          <!--                    签署时需与签署方进行视频通话，可将签署时的视频通话文件作为签署证据存放至证据包中。-->
                        </div>
                        <div class="top-right">
                          <el-checkbox-button
                            v-model="checkedBatch"
                            v-show="activeTabsName != signTypes[1]"
                            :true-label="11"
                            :false-label="null"
                            style="
                            position: relative;
                            margin-bottom: 2px;
                            width: 80px;
                            text-align: center;
                          "
                          >
                            批量添加
                            <img
                              v-show="checkedBatch"
                              src="/images/selected.png"
                              alt
                              class="check-act"
                            />
                          </el-checkbox-button>

                          <!--                    <el-checkbox-->
                          <!--                      v-model="checkedBatch"-->
                          <!--                      :disabled="checkedBatch"-->
                          <!--                      v-show="activeTabsName != signTypes[1]"-->
                          <!--                    >-->
                          <!--                      <b>批量签署方</b>-->
                          <!--                    </el-checkbox>-->
                          <el-tooltip
                            effect="light"
                            placement="bottom-end"
                            v-show="activeTabsName != signTypes[1]"
                          >
                            <div slot="content">
                              将相同内容的文件（如：学校放假通知
                              <br />书、安全告知函等）同时发给不同签署
                              <br />方，各个签署方分别各自签署。
                            </div>
                            <i
                              class="el-icon-question"
                              style="
                              font-size: 16px;
                              cursor: pointer;
                              margin: 0 10px 0 10px;
                              color: #a1a1a1;
                            "
                            ></i>
                          </el-tooltip>
                          <template>
                            <el-popover
                              placement="right"
                              width="200"
                              v-if="
                              regularList.length > 0 &&
                              this.signatoryJson.length < 10
                            "
                            >
                              <div class="popover-style">
                                <el-button size="small" @click="regularlistPush(1)">固定签署方</el-button>
                                <el-button size="small" @click="addSignerList">自定义签署方</el-button>
                              </div>
                              <div slot="reference" class="temone add">
                                <el-button
                                  type="danger"
                                  ref="signStep4"
                                  id="signStep4"
                                  size="small"
                                  style="
                                  width: 80px;
                                  text-align: center;
                                  padding: 9px 0;
                                "
                                >添加签署方</el-button>
                              </div>
                            </el-popover>
                            <el-button
                              v-else
                              type="danger"
                              ref="signStep4"
                              id="signStep4"
                              size="small"
                              @click="addSignerList"
                              style="
                              width: 80px;
                              text-align: center;
                              padding: 9px 0;
                            "
                            >添加签署方</el-button>
                            <span
                              style="color: #888888; font-size: 12px; margin-left: 12px"
                            >{{ signatoryJson.length }}/10</span>
                          </template>
                        </div>
                      </div>
                      <div v-if="signatoryJson && signatoryJson.length" class="list-box">
                        <draggable
                          :list="signatoryJson"
                          @start="dragging = true"
                          @end="dragging = false"
                          :options="{
                          handle: '.icon-move_box',
                          animation: 200,
                          ghostClass: 'ghost',
                        }"
                          :move="
                          () => {
                            return this.contractInfo.ifOrder;
                          }
                        "
                        >
                          <transition-group type="transition">
                            <template v-for="(item, i) in signatoryJson">
                              <!-- 批量签署方 -->
                              <li v-if="item.signOwner === '批量签署方'" :key="i">
                                <!-- 1px solid #fce7e7; -->
                                <div class="batch-sign-box">
                                  <div class="sign-item batch-sign">
                                    <div>
                                      <div v-show="contractInfo.ifOrder" class="icon-move_box">
                                        <i></i>
                                      </div>
                                      <div
                                        v-show="contractInfo.ifOrder"
                                        style="width: 26px; text-align: right"
                                      >{{ i + 1 }}</div>
                                    </div>
                                    <span class="user-type">
                                    批量签署方
                                    <span
                                      style="
                                        color: rgba(0, 0, 0, 0.45);
                                        font-size: 12px;
                                        margin-left: 5px;
                                      "
                                    >{{ batchArray.length }}/100</span>
                                  </span>
                                    <div style="float: right">
                                      <el-button @click="batchClearAll()" size="mini">清空签署方</el-button>
                                      <el-button @click="batchAdd()" size="mini">添加签署方</el-button>
                                    </div>
                                  </div>
                                  <div class="col" style="width: 31px">
                                    <p
                                      style="
                                      display: inline-block;
                                      width: 16px;
                                      margin-left: 24px;
                                    "
                                    >
                                    <span
                                      class="el-icon-delete"
                                      @click="delSignList(item)"
                                      v-if="signatoryJson.length > 1"
                                    ></span>
                                    </p>
                                  </div>
                                </div>
                                <!-- 批量签署方列表 -->
                                <!-- ref="contractListTab" 这是填充批量的 不然数组下标对不上就会报错 -->
                                <el-row ref="contractListTab">
                                  <div class="contractList-box">
                                    <template v-if="batchArray.length === 0">
                                      <div class="empty-box">
                                        <div class="btn-box">
                                          <div @click="downloadTemplate()" class="btn">
                                            <i class="el-icon-folder"></i>下载批量模板
                                          </div>
                                          <div @click="batchImport()" class="btn">
                                            <i class="el-icon-folder"></i>导入签署方
                                          </div>
                                        </div>
                                        <p>
                                          下载导入模板》按模板要求填入需要导入的签署方信息
                                          》选择导入签署方
                                        </p>
                                        <p
                                          style="color: #666666"
                                        >此处添加的签署方，会按“签署方”生成对应套数的文件（即在各自收到的文件中独立签署互不干扰），只是这些签署方在文件中签章的位置相同</p>
                                      </div>
                                    </template>
                                    <template v-for="(t, m) in batchArray">
                                      <el-form
                                        :key="m"
                                        :model="t"
                                        size="small"
                                        ref="contractBatchListTab"
                                      >
                                        <div
                                          :class="{
                                          item: true,
                                          'sign-item': true,
                                          'i-drag': contractInfo.ifOrder,
                                        }"
                                          style="padding-left: 10px"
                                        >
                                          <div>
                                            <div class="col" style="width: 70px">
                                              <el-form-item>
                                                <el-select
                                                  @change="
                                                  handleSignBatchUserType(t, m)
                                                "
                                                  v-model="t.signatoryUserType"
                                                  size="small"
                                                  class="select"
                                                  style="width: 70px"
                                                >
                                                  <el-option :value="0" label="个人" />
                                                  <el-option :value="1" label="企业" />
                                                </el-select>
                                              </el-form-item>
                                            </div>
                                            <div class="col" style="width: 230px">
                                              <el-form-item
                                                prop="account"
                                                :rules="
                                                t.signatoryUserType == 1
                                                  ? rulesTab.account
                                                  : rulesTab.mobile
                                              "
                                              >
                                                <el-input
                                                  ref="batchInputEmailOrPhone"
                                                  style="width: 230px"
                                                  @blur="
                                                  getBatchUserInfoBySelectTargetId(
                                                    t.account,
                                                    m
                                                  )
                                                "
                                                  v-model="t.account"
                                                  :placeholder="
                                                  t.signatoryUserType == 1
                                                    ? '签署方接收通知的手机/邮箱'
                                                    : '签署方接收通知的手机号'
                                                "
                                                />
                                              </el-form-item>
                                            </div>

                                            <div class="col" style="width: 230px">
                                              <!-- 下拉选择框 -->
                                              <template
                                                v-if="
                                                t.canSelectArray &&
                                                t.canSelectArray.length > 1
                                              "
                                              >
                                                <el-form-item>
                                                  <el-select
                                                    @change="
                                                    handleSelectCorpAccount(
                                                      $event,
                                                      t
                                                    )
                                                  "
                                                    v-model="
                                                    t.canSelectArrayIndex
                                                  "
                                                    style="width: 230px"
                                                    size="small"
                                                    class="select"
                                                  >
                                                    <el-option
                                                      v-for="(
                                                      v2, vi2
                                                    ) in t.canSelectArray"
                                                      :key="vi2"
                                                      :value="vi2"
                                                      :label="v2.name"
                                                    >
                                                      <div>
                                                        <img
                                                          src="/images/icon/dingIcon.png"
                                                          alt="钉钉"
                                                          width="20px"
                                                          v-if="
                                                          v2.fromDingTalk &&
                                                          v2.fromDingTalk === 1 && !isInDingTalk
                                                        "
                                                        />
                                                        <span
                                                          style="
                                                          color: #8492a6;
                                                          font-size: 13px;
                                                        "
                                                        >{{ v2.name }}</span>
                                                      </div>
                                                    </el-option>
                                                  </el-select>
                                                </el-form-item>
                                              </template>
                                              <template v-else>
                                                <el-form-item
                                                  prop="name"
                                                  :rules="rulesTab.name"
                                                  :show-message="
                                                  t.disabled !== 'disabled'
                                                "
                                                >
                                                  <el-input
                                                    v-model="t.name"
                                                    :disabled="
                                                    t.disabled === 'disabled'
                                                  "
                                                    style="width: 230px"
                                                    placeholder="请输入签署方名称"
                                                  />
                                                </el-form-item>
                                              </template>
                                            </div>

                                            <!-- 身份证 和 营业执照号 -->
                                            <div class="col">
                                              <!-- 身份证 -->
                                              <el-form-item
                                                v-if="t.signatoryUserType === 0"
                                                :rules="
                                                t.disabled !== 'disabled'
                                                  ? rulesTab.identityNo
                                                  : {}
                                              "
                                                :show-message="
                                                t.disabled !== 'disabled'
                                              "
                                                style="position: relative"
                                                prop="identityNo"
                                              >
                                                <el-input
                                                  v-model="t.identityNo"
                                                  :disabled="
                                                  t.disabled === 'disabled'
                                                "
                                                  :class="{
                                                  'no-padding': t.disabled
                                                    ? true
                                                    : false,
                                                }"
                                                  placeholder="请输入中国大陆18位身份证号码"
                                                  style="width: 230px"
                                                />
                                                <!-- <a @click="handleTargetIdChange(t)" v-if="t.ischange === 1" href="javascript:void (0)"
                                                class="color-success amend-signator amend-tab__form">修改</a>-->
                                              </el-form-item>
                                              <!-- 营业执照 -->
                                              <el-form-item
                                                v-if="t.signatoryUserType === 1"
                                                prop="identityNo"
                                                :rules="
                                                t.disabled !== 'disabled'
                                                  ? rulesTab.businessLicense
                                                  : {}
                                              "
                                                style="position: relative"
                                              >
                                                <el-input
                                                  v-model="t.identityNo"
                                                  :disabled="
                                                  t.disabled === 'disabled'
                                                "
                                                  :class="{
                                                  'no-padding': t.disabled
                                                    ? true
                                                    : false,
                                                }"
                                                  placeholder="请输入统一社会编码"
                                                  style="width: 230px"
                                                />
                                              </el-form-item>
                                            </div>

                                            <div class="col" style="width: 150px">
                                              <el-button
                                                icon="el-icon-plus"
                                                v-if="
                                                t.isNoticePhone &&
                                                !t.showNoticePhone
                                              "
                                                @click="
                                                changBatchUserShowNoticePhone(m)
                                              "
                                              ></el-button>
                                              <el-form-item
                                                :rules="rulesTab.mobile"
                                                v-if="
                                                t.signatoryUserType === 1 &&
                                                t.showNoticePhone
                                              "
                                              >
                                                <el-input v-model="t.mobile" placeholder="请输入通知手机号" />
                                                <!-- style="width:178px" -->
                                                <span
                                                  class="g-icon-close"
                                                  @click="
                                                  changBatchUserShowNoticePhone(
                                                    m
                                                  )
                                                "
                                                >
                                                <i class="el-icon-error"></i>
                                              </span>
                                              </el-form-item>
                                            </div>
                                          </div>
                                          <div
                                            :span="
                                            t.signatoryUserType === 0 ? 3 : 7
                                          "
                                            class="col"
                                            style="flex: none"
                                          >
                                            <el-form-item
                                              style="
                                              text-align: right;
                                              line-height: 50px;
                                            "
                                            >
                                              <el-button @click="batchClear(m)">删除</el-button>
                                            </el-form-item>
                                          </div>
                                        </div>
                                      </el-form>
                                    </template>
                                  </div>
                                </el-row>
                              </li>

                              <!-- 正常签署方 -->
                              <li v-else :key="i">
                                <el-form
                                  :model="item"
                                  size="small"
                                  ref="contractListTab"
                                  :key="i"
                                  :data-signOwner="item.signOwner"
                                  class="contract-lit__tab"
                                >
                                  <div
                                    :class="{
                                    item: true,
                                    'sign-item': true,
                                    'i-drag': contractInfo.ifOrder,
                                  }"
                                  >
                                    <div>
                                      <div v-show="contractInfo.ifOrder" class="icon-move_box">
                                        <i></i>
                                      </div>
                                      <div
                                        v-show="contractInfo.ifOrder"
                                        style="width: 26px; text-align: right"
                                      >{{ i + 1 }}</div>
                                    </div>
                                    <div class="user-type">
                                      <!--                                    <p>{{ item.signOwner }}</p>-->
                                      <p>签署方</p>
                                    </div>
                                    <div class="col" style="width: 110px">
                                      <el-form-item>
                                        <el-select
                                          @change="handleSignUserType(item, i)"
                                          v-model="item.signatoryUserType"
                                          size="small"
                                          class="select"
                                          style="width: 110px"
                                        >
                                          <el-option :value="0" label="个人" />
                                          <el-option :value="1" label="企业" />
                                          <el-option
                                            v-show="activeTabsName === signTypes[0]"
                                            :value="2"
                                            label="港澳台个人"
                                          />
                                        </el-select>
                                      </el-form-item>
                                    </div>

                                    <div class="col" style="width: 230px">
                                      <!-- 国内个人 -->
                                      <template v-if="[0,1].includes(item.signatoryUserType)">
                                        <el-form-item
                                          prop="account"
                                          :rules="
                                        [1,2].includes(item.signatoryUserType)
                                          ? rulesTab.account
                                          : rulesTab.mobile
                                      "
                                        >
                                          <el-input
                                            @blur="
                                          () => {
                                            (item.account = $utils.trim(
                                              item.account
                                            )),
                                              (item.corpUser = ''),
                                              getUserInfoBySelectTargetId({
                                                account: item.account,
                                                selectIndex: i,
                                                type: false,
                                              });
                                          }
                                        "
                                            style="width: 230px"
                                            v-model="item.account"
                                            :placeholder="'签署方接收通知的' + (item.signatoryUserType == 1 ? '手机/邮箱' : item.signatoryUserType == 2 ? '邮箱' : '手机号')"
                                          >
                                            <i
                                              class="icon icon-btn_tels"
                                              style="
                                            background-size: contain;
                                            cursor: pointer;
                                          "
                                              slot="suffix"
                                              @click="handleTelsClickOther(item, i)"
                                            ></i>
                                          </el-input>
                                        </el-form-item>
                                      </template>
                                      <!-- 港澳台个人 -->
                                      <template v-else>
                                        <el-form-item prop="account" :rules="rulesTab.email">
                                          <el-input
                                            @blur="
                                          () => {
                                            (item.account = $utils.trim(
                                              item.account
                                            )),
                                              (item.corpUser = ''),
                                              getUserInfoBySelectTargetId({
                                                account: item.account,
                                                selectIndex: i,
                                                type: false,
                                              });
                                          }
                                        "
                                            style="width: 230px"
                                            v-model="item.account"
                                            placeholder="签署方接收通知的邮箱"
                                          >
                                            <i
                                              class="icon icon-btn_tels"
                                              style="
                                            background-size: contain;
                                            cursor: pointer;
                                          "
                                              slot="suffix"
                                              @click="handleTelsClickOther(item, i)"
                                            ></i>
                                          </el-input>
                                        </el-form-item>
                                      </template>
                                    </div>

                                    <div class="col" style="width: 230px">
                                      <!-- 下拉选择框 -->
                                      <!--企业的时候才有手动输入，个人的时候是个人的修改方式-->
                                      <template
                                        v-if="
                                        item.canSelectArray &&
                                        ((+item.signatoryUserType === 1 &&
                                          item.canSelectArray.length > 0 &&
                                          !item.ManualInput) ||
                                          (+item.signatoryUserType === 0 &&
                                            item.canSelectArray.length > 1))
                                      "
                                      >
                                        <el-form-item>
                                          <el-select
                                            @change="
                                            handleSelectCorpAccount(
                                              $event,
                                              item
                                            )
                                          "
                                            v-model="item.canSelectArrayIndex"
                                            size="small"
                                            class="select"
                                            style="width: 230px"
                                          >
                                            <el-option
                                              v-for="(
                                              v, vi
                                            ) in item.canSelectArray"
                                              :key="vi"
                                              :value="vi"
                                              :label="v.name"
                                            >
                                              <div>
                                                <img
                                                  src="/images/icon/dingIcon.png"
                                                  alt="钉钉"
                                                  width="20px"
                                                  v-if="
                                                  v.fromDingTalk &&
                                                  v.fromDingTalk === 1 && !isInDingTalk
                                                "
                                                />
                                                <span
                                                  style="
                                                  color: #8492a6;
                                                  font-size: 13px;
                                                "
                                                >{{ v.name }}</span>
                                              </div>
                                            </el-option>

                                            <!--手动输入，选择此项显示输入框，手动输入-->
                                            <el-option
                                              v-if="item.signatoryUserType === 1"
                                              value="ManualInput"
                                              label="手动输入"
                                            />
                                          </el-select>
                                        </el-form-item>
                                      </template>
                                      <template v-else>
                                        <el-form-item
                                          prop="name"
                                          :rules="rulesTab.name"
                                          :show-message="
                                          item.disabled !== 'disabled'
                                        "
                                        >
                                          <el-input
                                            :value="item.name"
                                            @input="
                                            (val) => {
                                              item.name = val.trim();
                                              changeQSNameInQZ(
                                                item.signOwner,
                                                val
                                              );
                                            }
                                          "
                                            :disabled="
                                            item.disabled === 'disabled'
                                          "
                                            style="width: 230px"
                                            :placeholder="
                                          [0,2].includes(item.signatoryUserType)
                                              ? '请输入签署方姓名'
                                              : '请输入签署方公司名称'
                                          "
                                          />
                                        </el-form-item>
                                      </template>
                                    </div>
                                    <!-- 身份证 和 营业执照号 -->
                                    <div
                                      v-if="item.signatoryUserType === 0"
                                      class="col"
                                      style="width: 190px"
                                    >
                                      <div
                                        style="
                                        display: flex;
                                        justify-content: flex-start;
                                        align-items: center;
                                      "
                                      >
                                        <!-- 身份证 -->
                                        <!-- [1363] 需求 不强制输入身份证号码 【1434】 && item.identityNo -->
                                        <el-button
                                          style="margin: 0"
                                          icon="el-icon-plus"
                                          v-if="
                                          item.signatoryUserType === 0 &&
                                          !item.idCardNoShow
                                        "
                                          @click="idCardNoShowFn(item)"
                                        ></el-button>
                                        <el-form-item
                                          v-if="
                                          item.signatoryUserType === 0 &&
                                          item.idCardNoShow
                                        "
                                          :rules="
                                          item.disabled !== 'disabled'
                                            ? rulesTab.identityNo
                                            : {}
                                        "
                                          :show-message="
                                          item.disabled !== 'disabled'
                                        "
                                          style="position: relative"
                                        >
                                          <el-input
                                            v-model="item.identityNo"
                                            :disabled="
                                            item.disabled === 'disabled'
                                          "
                                            :class="{
                                            'no-padding': item.disabled
                                              ? true
                                              : false,
                                          }"
                                            placeholder="请输入中国大陆18位身份证号码"
                                            style="width: 230px"
                                          />
                                          <a
                                            style="right: 13px; font-size: 12px"
                                            v-if="item.ischange === 1"
                                            href="javascript:void (0)"
                                            class="color-success amend-signator amend-tab__form"
                                          >已实名</a>
                                        </el-form-item>
                                      </div>
                                    </div>
                                    <!-- 通知手机号 -->
                                    <div
                                      class="col"
                                      style="width: 190px"
                                      v-if="item.signatoryUserType === 1"
                                    >
                                      <el-button
                                        icon="el-icon-plus"
                                        v-if="isShow('btn', item)"
                                        @click="changShowNoticePhone(i)"
                                      ></el-button>
                                      <el-form-item
                                        :rules="rulesTab.mobile"
                                        v-if="isShow('input', item)"
                                      >
                                        <el-input
                                          v-model="item.mobile"
                                          placeholder="请输入通知手机号"
                                          style="width: 230px"
                                        />
                                        <span
                                          class="g-icon-close"
                                          v-show="
                                          activeTabsName == signTypes[1] &&
                                          !happy.email.test(item.account)
                                        "
                                          @click="changShowNoticePhone(i)"
                                        >
                                        <i class="el-icon-error"></i>
                                      </span>
                                      </el-form-item>
                                    </div>
                                    <!-- 非中国内陆签署方证件号 -->
                                    <div
                                      class="col"
                                      style="width: 190px"
                                      v-if="item.signatoryUserType === 2"
                                    >
                                      <el-form-item prop="identityNo" :rules="rulesTab.identityNo">
                                        <el-input
                                          v-model="item.identityNo"
                                          :maxlength="50"
                                          placeholder="请输入签署方证件号码"
                                          style="width: 230px"
                                        />
                                        <el-tooltip
                                          effect="dark"
                                          content="仅支持港澳居民来往内地通行证、台湾居民来往内地通行证及护照，发起时请与签约方确认好证件类型及号码。"
                                          placement="top"
                                        >
                                          <i
                                            class="el-icon-question"
                                            style="font-size: 20px;margin-left: 10px;color: #a1a1a1;"
                                          ></i>
                                        </el-tooltip>
                                      </el-form-item>
                                    </div>
                                    <div class="col" style="padding-right: 0; margin-right: 6px;">
                                      <div class="check-box">
                                        <el-checkbox-button
                                          style="
                                          position: relative;
                                          margin-right: 20px;
                                        "
                                          :value="!!item.needRead"
                                          @change="checkChange($event, item, i)"
                                        >
                                          强制阅读
                                          <img
                                            v-if="item.needRead"
                                            src="/images/selected.png"
                                            alt
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      <!-- 选择类型 -->
                                      <!-- 人脸识别 item.authLevel !== 12 -->
                                      <div class="check-box" v-if="item.signatoryUserType !== 2">
                                        <el-checkbox-button
                                          v-if="activeTabsName === signTypes[0]"
                                          v-model="item.authLevel"
                                          :true-label="11"
                                          :false-label="null"
                                          :checked="
                                          item.signatoryUserType === 0 &&
                                          activeTabsName === signTypes[0] &&
                                          item.authLevel == 11
                                        "
                                          style="
                                          margin-right: 20px;
                                          position: relative;
                                        "
                                        >
                                          人脸识别
                                          <img
                                            v-show="item.authLevel == 11"
                                            src="/images/selected.png"
                                            alt
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      <!-- 短信验证 item.authLevel == 12 -->
                                      <div class="check-box" v-if="item.signatoryUserType == 0">
                                        <el-checkbox-button
                                          v-if="activeTabsName === signTypes[0]"
                                          v-model="item.authLevel"
                                          :true-label="12"
                                          :false-label="null"
                                          style="
                                          margin-right: 20px;
                                          position: relative;
                                        "
                                        >
                                          短信验证
                                          <img
                                            v-show="item.authLevel == 12"
                                            src="/images/selected.png"
                                            alt
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      <!-- 经办人签字 item.authLevel == 12 -->
                                      <div class="check-box" v-if="item.signatoryUserType == 1">
                                        <el-checkbox-button
                                          v-if="activeTabsName === signTypes[0]"
                                          v-model="item.extraHandSign"
                                          :true-label="1"
                                          :false-label="null"
                                          style="
                                          margin-right: 20px;
                                          position: relative;
                                        "
                                        >
                                          经办人签字
                                          <img
                                            v-show="item.extraHandSign == 1"
                                            src="/images/selected.png"
                                            alt
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      <!-- 视频通话 -->
                                      <div class="check-box" v-if="activeTabsName === signTypes[1]">
                                        <el-tooltip
                                          effect="light"
                                          placement="top"
                                          content="选中需参与视频通话，最多同时支持四人参加视频通话。"
                                          v-if="activeTabsName === signTypes[1]"
                                        >
                                          <el-checkbox-button
                                            v-model="item.faceOrVideo"
                                            border
                                            :true-label="1"
                                            :disabled="disOption(item)"
                                            :checked="item.faceOrVideo == 1"
                                            @change="videoPartIn($event, item)"
                                            style="
                                            position: relative;
                                            margin-right: 20px;
                                          "
                                          >
                                            <span>视频通话</span>
                                            <img
                                              v-show="item.faceOrVideo == 1"
                                              src="/images/selected.png"
                                              alt
                                              class="check-act"
                                            />
                                          </el-checkbox-button>
                                        </el-tooltip>
                                      </div>
                                      <div class="check-box" v-if="activeTabsName === signTypes[2]">
                                        <!-- 校验码 -->
                                        <el-checkbox-button
                                          :checked="item.accessCode"
                                          style="
                                          margin-right: 20px;
                                          position: relative;
                                        "
                                          @change="checkCodeChange($event, item, i)"
                                        >
                                          校验码
                                          <img
                                            v-show="item.accessCode"
                                            src="/images/selected.png"
                                            alt
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      <!-- <div class="check-box">

                                      </div>-->
                                      <!-- <el-tooltip
                                      effect="light"
                                      placement="top"
                                      content="仅主持人可以发起/结束视频通话。"
                                    >
                                      <div
                                        class="check-box"
                                        v-show="activeTabsName == signTypes[1]"
                                      >
                                        <el-checkbox-button
                                          :key="i + new Date() + '_2'"
                                          border
                                          :checked="item.videoSignUserType == 2"
                                          :disabled="logicOfDisabled(item, 2)"
                                          @change="typeChange($event, item, 2)"
                                          style="position: relative;"
                                        >
                                          <span>视频主持人</span>
                                          <img
                                            v-show="item.videoSignUserType == 2"
                                            src="/images/selected.png"
                                            alt=""
                                            class="check-act"
                                          />
                                        </el-checkbox-button>
                                      </div>
                                      </el-tooltip>-->
                                      <!-- <div class="settings-sty"> -->
                                      <!-- <span class="more_text" v-show="item.signatoryUserType == 1" @click="moreSettingUp(item, i)">更多</span> -->
                                      <p
                                        style="
                                          display: inline-block;
                                          width: 16px;
                                          margin-left: 23px;
                                        "
                                      >
                                        <span v-show="signatoryJson.length > 1" class="el-icon-delete" @click="delSignList(item)"></span>
                                      </p>
                                      <!-- </div> -->
                                    </div>
                                  </div>
                                </el-form>
                              </li>
                            </template>
                          </transition-group>
                        </draggable>
                      </div>
                      <el-dialog title="提示" :visible.sync="authLevelShow" width="20%">
                      <span
                        style="display: inline-block; text-align: center"
                      >是否取消该签署方的人脸识别？取消人脸识别，将不能把该签署方的人脸视频文件作为签署证据。</span>
                        <span slot="footer" class="dialog-footer">
                        <el-button @click="authLevelShow = false">取 消</el-button>
                        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                      </span>
                      </el-dialog>
                    </div>
                  </el-form-item>
                </div>
                <!-- 视频通话设置 -->
                <div style="margin-bottom: 10px" class="card" v-show="activeTabsName == signTypes[1]">
                  <div class="card-tit">
                    <i></i>视频通话设置
                  </div>
                  <div class="card-box" style="padding-bottom: 0">
                    <el-form :inline="true">
                      <el-form-item label="视频通话主持人" style="margin-right: 35px">
                        <template>
                          <el-tooltip effect="light" placement="top" content="仅主持人可以发起/结束视频通话。">
                            <i
                              class="el-icon-question"
                              style="
                              font-size: 16px;
                              cursor: pointer;
                              margin: 0 10px 0 1px;
                              color: #a1a1a1;
                            "
                            ></i>
                          </el-tooltip>
                          <el-select
                            v-model="videoAnchor"
                            placeholder="请选择视频通话主持人"
                            @change="hostChange"
                          >
                            <el-option
                              v-for="(signer, i) in signerList"
                              :key="i"
                              :label="signer.name"
                              :value="signer.signOwner"
                            ></el-option>
                          </el-select>
                        </template>
                      </el-form-item>
                      <el-form-item label="通话时长" style="margin-right: 35px">
                        <p>5分钟</p>
                        <!--                <el-input value="5分钟" readonly style="width:207px" />-->
                      </el-form-item>
                      <el-form-item label="开始时间" style="margin-right: 35px">
                        <el-date-picker
                          class="start-time"
                          v-model="contractInfo.videoSignStartTime"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :picker-options="videoPickerOptions"
                          @change="pickTime"
                          :clearable="clearable"
                          placeholder="选择日期"
                          style="width: 207px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <!-- 钉钉环境下审批流设置 -->
                <div class="f-center2" v-if="!checkedBatch">
                  <el-form-item>
                    <el-tabs :stretch="true" v-if="isInDingTalk" v-model="flowType">
                      <!-- <el-tab-pane label="标准签" name="signStandard"></el-tab-pane> -->
                      <el-tab-pane label="选择审批流程" :name="flowTypes[0]" style="padding: 20px">
                        <flow-path @flowSelectChange="flowSelectChange"></flow-path>
                      </el-tab-pane>
                      <el-tab-pane label="自主选择审批人" :name="flowTypes[1]" style="padding: 20px">
                        <self-selection
                          :menbers="menbers"
                          @chooseMenber="chooseMenber"
                          @delUser="delUser"
                          @delLeven="delLeven"
                          @addLeven="addLeven"
                        ></self-selection>
                      </el-tab-pane>
                    </el-tabs>
                  </el-form-item>
                </div>
                <!-- 集团账户设置了审批流 （web端） -->
                <div class="f-center2" v-if="isGroup && !checkedBatch && hasApplyApproval === true">
                  <el-form-item>
                    <h4
                      style="display: inline-block; margin-right: 15px"
                      :style="{ display: isInDingTalk ? 'none' : '' }"
                    >
                      <i></i>其他设置
                      <!-- 文件审批及抄送 -->
                    </h4>
                    <div class="bow" v-if="!isInDingTalk">
                      <el-form-item label-width="100px">
                        <span slot="label" style="color: #000000">选择审批流程</span>
                        <el-select
                          v-model="approvalFlowSelect"
                          size="mini"
                          placeholder="请选择审批流程"
                          @change="handleChangeApprovalFlow"
                        >
                          <el-option
                            v-for="(v, index) in approvalFlowList"
                            :key="index"
                            :value="v.flowId"
                            :label="v.flowName"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <div
                        v-if="flows.length > 0"
                        style="
                        border: 1px solid rgba(229, 229, 229, 1);
                        border-radius: 4px;
                        margin-top: 12px;
                      "
                      >
                        <div style="display: inline-block; position: relative">
                          <flow
                            v-for="(v, index) in flows"
                            :model="v"
                            :hiddenArrow="v.hiddenArrow"
                            :hiddenRemove="false"
                            :key="index"
                          >
                            <div slot="username">
                            <span style="color: #aaaaaa">
                              {{
                              v.partyName
                              }}
                            </span>
                            </div>
                          </flow>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <div class="f-center2" v-if="isGroup && !checkedBatch">
                  <!-- 抄送设置 -->
                  <el-form-item class="bow">
                    <p class="cc_title">文件抄送人</p>
                    <div
                      style="
                      border: 1px solid rgba(229, 229, 229, 1);
                      border-radius: 4px;
                      overflow: hidden;
                      padding: 8px 0;
                    "
                    >
                      <div class="audit-flex">
                        <div v-for="(item, index) in arrayCopior" :key="index" class="audit-box">
                          <i class="icon icon-audit-touxiang66"></i>
                          <!-- <i class="icon icon-audit-touxiang66dark"></i> -->
                          <div class="auditor">
                            {{
                            item.userName || item.partyName || item.corpUserName
                            }}
                          </div>
                          <i
                            v-show="!item.hideRemove"
                            @click="handleClickRemoveArrayCopior(index)"
                            class="icon icon-audit-cuowu17 size17"
                          ></i>
                        </div>
                        <!-- 添加按钮 -->
                        <div class="audit-add" @click="clickHandleAddAuditorOrCopyer()">
                          <i class="icon icon-audit-add-2x"></i>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </div>
                <!-- 签署方和发起方是同一人，展示选择签章 -->
                <div class="bow" v-if="isMine()">
                  <el-form-item>
                    <p class="cc_title">选择签章</p>
                    <template>
                      <div class="temone-box" v-if="chapterList.length">
                        <template v-for="(item, index) in chapterList">
                          <div
                            class="temone-chap"
                            :class="{
                            'select-border': chapterCheck.includes(
                              item.corpSealId
                            )
                              ? true
                              : false,
                          }"
                            :key="index"
                            @click="selectChap(item)"
                          >
                            <img class="select_img" src="/images/selected.png" alt />
                            <div class="info_box">
                              <el-popover placement="top-start" trigger="hover">
                                <div
                                  style="padding: 10px; font-weight: bold"
                                  v-if="
                                  (!isInDingTalk && item.flowDetail) ||
                                  (isInDingTalk && item.dingTalkFlow)
                                "
                                >
                                  <p>
                                    {{
                                    !isInDingTalk
                                    ? item.flowDetail &&
                                    item.flowDetail.flowName
                                    : isInDingTalk && item.dingTalkFlow
                                    ? item.dingTalkFlow.flowName
                                    : ""
                                    }}
                                  </p>
                                  <div style="height: 125px; overflow: auto">
                                    <approval-process
                                      :flowInfo="
                                      computeInfo(
                                        isInDingTalk
                                          ? item.dingTalkFlow
                                          : item.flowDetail
                                      )
                                    "
                                      :orderFlag="
                                      isInDingTalk
                                        ? item.dingTalkFlow.flowType
                                        : item.flowDetail.orderFlag
                                    "
                                    ></approval-process>
                                  </div>
                                </div>
                                <div v-else>
                                  <p
                                    style="
                                    padding: 20px;
                                    color: #606266;
                                    font-weight: bold;
                                  "
                                  >无审批流程</p>
                                </div>
                                <div slot="reference">
                                  <div class="t-box">
                                    <img class="y-img" :src="item.signUrl" :title="item.sealName" />
                                  </div>
                                  <p :title="`${item.sealName}`">{{ `${item.sealName}` }}</p>
                                </div>
                              </el-popover>
                            </div>
                          </div>
                        </template>
                      </div>
                      <p v-else style="color: #ec1c1e">您还没有获得企业印章的使用授权，可继续发起合同，请在签署前联系管理员给您进行印章授权！</p>
                    </template>
                  </el-form-item>
                </div>
              </template>
<!--       邀请协作人/ 协同审阅       -->
              <div class="card" style="background-color: #ffffff" v-if="collaborationType">
                <div class="card-tit">
                  协作人
                </div>
                <div style="padding: 10px">
                  <!-- 已邀请的协作人 -->
                  <el-form
                    v-if="darfPhoneList.length !== 0"
                    style="margin-top: 10px"
                    :model="dynamicValidateForm"
                    ref="dynamicValidateFormRef"
                    label-width="100px"
                    size="small"
                  >
                    <el-form-item
                      v-for="(item, i) of darfPhoneList"
                      :label="`协作人${i + 1}:`"
                      :key="item.i"
                      label-width="100px"
                      size="small"
                    >
                      <div class="item-sty">
                        <el-input
                          :value="item.mobilePhone"
                          readonly
                          :style="{ 'margin-right': '10px', width: inputWidth }"
                        ></el-input>
                        <el-input
                          :value="item.userName"
                          readonly
                          :style="{ width: inputWidth }"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-form>
                  <!--  -->
                  <el-form
                    style="margin-top: 10px"
                    :model="dynamicValidateForm"
                    ref="dynamicValidateFormRef"
                    label-width="100px"
                    size="small"
                  >
                    <el-form-item
                      v-for="(domain, index) in dynamicValidateForm.domains"
                      :label="'协作人' + (Number(darfPhoneList.length) + index + 1)"
                      :key="domain.key"
                      :prop="'domains.' + index + '.mobile'"
                      :rules="domain.r_mobile"
                    >
                      <div class="item-sty">
                        <el-input
                          v-model="domain.mobile"
                          placeholder="协作人手机号"
                          :style="{ 'margin-right': '10px', width: inputWidth }"
                        ></el-input>
                        <el-input
                          v-model="domain.name"
                          placeholder="协作人名称"
                          :style="{ width: inputWidth }"
                        ></el-input>
                        <i class="el-icon-circle-plus-outline" style="margin: 0 10px" @click="addDomain"></i>
                        <i
                          class="el-icon-delete"
                          v-show="dynamicValidateForm.domains.length > 1"
                          @click="removeDomain(domain)"
                        ></i>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <el-form-item
                class="text-center"
                :style="{
                  'margin-top': '10px',
                }"
              >
                <!--批量签署方不存为草稿-->
                <template v-if="!collaborationType">
                  <el-button
                    v-if="!$route.query.multiFileKey"
                    @click="saveAsDraft(true)"
                    :disabled="isSaveDisable"
                    :class="{ 'g-save-disable': isSaveDisable }"
                  >存为草稿</el-button>
                  <el-button ref="signStep5" id="signStep5" type="danger" @click="handleTPL">下一步</el-button>
                </template>
                <el-button v-else ref="signStep5" id="signStep5" type="danger" @click="submitForm('dynamicValidateFormRef')">发起协同</el-button>
              </el-form-item>
            </el-form>
          </el-main>
          <!--pdf文件预览-->
          <ViewFilesToDoc
            :visibleShow="visibleShowEnclosureDoc"
            :enclosurePreviewNumItem="enclosurePreviewNumItem"
            @setViewFilesToDocDialogData="onSetViewFilesToDocDialogData"
          />
          <!--图片及视频预览-->
          <ViewFilesToImg
            :visibleShow="visibleShowEnclosure"
            :isRefresh="isRefresh"
            :enclosurePreviewNumItem="enclosurePreviewNumItem"
            :imgList="getEnclosureImgList"
            @setViewFilesToImgDialogData="onSetViewFilesToImgDialogData"
          />
          <!--审批人/抄送人-->
          <el-dialog :title="auditAndCopyTitle" :visible.sync="visibleAuditAndCopy" width="50%">
            <el-row class="tel-search">
              <el-col :span="20">
                <el-row>
                  <el-col :span="8" style="padding: 0 10px">
                    <el-input
                      clearable
                      v-model="myCorpModel.keyword"
                      @keyup.enter.native="clickHandleMyCorpSearch()"
                      size="small"
                      placeholder="邮箱/手机号"
                    />
                  </el-col>
                  <el-col :span="8" style="padding: 0 10px">
                    <el-input
                      clearable
                      v-model="myCorpModel.corpUserName"
                      size="small"
                      :placeholder="
                        auditAndCopyTitle === '添加抄送人'
                          ? '名称'
                          : '签署方名称'
                      "
                    ></el-input>
                  </el-col>
                  <el-col :span="8" style="padding: 0 10px">
                    <el-select v-model="myCorpModel.corpGroupId" placeholder="请选择部门" size="small">
                      <el-option label="全部" value></el-option>
                      <el-option
                        v-for="(item, i) in department"
                        :key="i"
                        :label="item.groupName"
                        :value="item.corpGroupId"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="3" :offset="1">
                <el-button @click="queryToolMyCorp()" size="small" class="btn">查询</el-button>
              </el-col>
            </el-row>

            <div class="tel-box" style="height: 415px; overflow: auto">
              <el-table
                ref="multipleTable"
                v-loading="myCorpModel.loading"
                row-key="corpUserId"
                :empty-text="myCorpModel.emptyText"
                @row-click="handleRowClickAuditAndCopy"
                :reserve-selection="true"
                :data="tableListMyCorp"
                style="width: 100%"
                tooltip-effect="dark"
                highlight-selection-row
                stripe
                :cell-style="{ cursor: 'pointer' }"
                :header-cell-style="{
                  background: '#f9f9f9',
                  color: '#333333',
                  fontWeight: '500',
                }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
                <el-table-column label="邮箱/手机号" prop="targetId" />
                <el-table-column
                  :label="
                    auditAndCopyTitle === '添加抄送人' ? '名称' : '签署方名称'
                  "
                  prop="userName"
                />
                <el-table-column label="部门" prop="groupNames" />
              </el-table>
            </div>
            <br />
            <el-pagination
              @size-change="handleSizeChangeQueryToolMyCorp"
              @current-change="handleCurrentChangeQueryToolMyCorp"
              :current-page="myCorpModel.itemPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="myCorpModel.pageSize"
              layout="sizes, prev, pager, next, jumper, total"
              :total="myCorpModel.total"
              style="text-align: right"
            />
            <p slot="footer" class="dialog-footer">
              <el-button
                @click="
                  (tableAuditAndCopySelectRows = []),
                    (visibleAuditAndCopy = false)
                "
                size="small"
                class="btn"
              >取消</el-button>
              <el-button
                @click="clickHandleAddAuditorOrCopyerSubmit()"
                type="danger"
                size="small"
                class="btn"
              >添加</el-button>
            </p>
          </el-dialog>
          <!--签署流程图-->
          <el-dialog :title="'签署流程示意图'" :visible.sync="visibleSigningFlow" width="900px">
            <div class="signingFlow-box">
              <div class="signingFlow-tit">
                <!--$store.getters.currentAuthUser-->
                <img
                  class="photo"
                  :src="
                    currentUser.imgPath
                      ? fileOperShow(currentUser.imgPath)
                      : '/images/web/p-default.png'
                  "
                />
                <p>
                  {{
                  currentUser.corpName ||
                  currentUser.signatoryFullName ||
                  currentUser.username
                  }}
                </p>
              </div>
              <h4>发起方</h4>
              <div class="arr-down">
                <i class="el-icon-arrow-down"></i>
              </div>
              <div class="signingFlow">
                <div
                  class="signingFlow-item"
                  :class="contractInfo.ifOrder ? 'orderLi' : ''"
                  v-for="(item, index) in signatoryJson"
                  :key="index"
                >
                  <div class="signing-flow-tit" v-if="item.hasOwnProperty('name')">
                    <img class="photo" src="/images/web/p-default.png" />
                    <el-tooltip effect="light" placement="bottom-end">
                      <div slot="content">
                        证件号：{{ item.identityNo }}
                        <br />
                        接收手机或邮箱：{{ item.account }}
                      </div>
                      <p>{{ item.name || "签署方名称" }}</p>
                    </el-tooltip>
                  </div>
                  <div class="signing-flow-tit" v-else>
                    <img class="photo" src="/images/web/p-default.png" />
                    <p>批量签署方</p>
                  </div>
                  <h4>签署方</h4>
                </div>
              </div>
              <div class="arr-down">
                <i class="el-icon-arrow-down"></i>
              </div>
              <h3>{{ contractInfo.ifOrder ? "顺序签署" : "无顺序签署" }}</h3>
            </div>
            <p slot="footer" class="dialog-footer">
              <el-button @click="visibleSigningFlow = false" size="small" class="btn">确定</el-button>
            </p>
          </el-dialog>
          <!--消费弹窗-->
          <el-dialog
            :visible.sync="priseVisibleDialog"
            @closed="handleDelSendContract"
            title="温馨提示"
            :show-close="false"
            width="400px"
            class="prise-dialog"
          >
            <div class="box-dashed text-center" style="margin-top: 10px; padding-bottom: 5px">
              <img src="/images/icon_signed.png" style="height: 80px" />
              <template v-if="priseInfo.mealInfo">
                <h4>
                  本次共花费：
                  <span class="color-danger">{{ priseInfo.mealInfo }}</span>
                </h4>
                <h4 v-if="priseInfo.point && !$route.query.multiFileKey">
                  另需要支付
                  <span class="color-danger">{{ priseInfo.point }}积分</span>
                </h4>
              </template>
              <h4 v-else-if="!$route.query.multiFileKey" style="font-weight: bold">
                本次共花费：
                <span class="color-danger">{{ priseInfo.point }}积分</span>
              </h4>
              <p style="text-align: start; margin-left: 8px">
                <i class="el-icon-info"></i>
                发起后，签署方将收到签署短信/邮件通知，该通知{{dateTimeFn}}小时有效，请尽快完成签署！
              </p>
            </div>
            <div slot="footer" class="text-center">
              <el-button
                @click="toPay(priseInfo.cashierUrl)"
                type="danger"
                size="small"
                class="footer-btn"
                :disabled="payDisabled"
              >确定</el-button>
            </div>
          </el-dialog>
          <!--通讯簿列表-->
          <el-dialog
            title="选择签署方"
            :visible.sync="showTel"
            :before-close="
              () => {
                this.restCorp(), (this.showTel = false);
              }
            "
            lock-scroll
            width="749px"
          >
            <!-- tabs -->
            <el-tabs v-model="activeTabSigner" @tab-click="tabClick">
              <!-- 我的通讯录 -->
              <el-tab-pane label="常用签署方" name="default">
                <el-row class="tel-search" :gutter="10">
                  <el-col :span="6">
                    <el-input
                      v-model="telPageInfo.accountNo"
                      @keyup.enter.native="getTelList()"
                      size="small"
                      placeholder="接收手机号"
                    />
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      v-model="telPageInfo.name"
                      @keyup.enter.native="getTelList()"
                      size="small"
                      placeholder="签署方名称"
                    />
                  </el-col>
                  <el-col :span="6">
                    <el-input
                      v-model="telPageInfo.idNo"
                      @keyup.enter.native="getTelList()"
                      size="small"
                      placeholder="证件号"
                    />
                  </el-col>
                  <el-col :span="2">
                    <el-button @click="getTelList" size="small" class="btn">查询</el-button>
                  </el-col>
                  <el-col :span="2">
                    <el-button @click="reset" size="small" class="btn">重置</el-button>
                  </el-col>
                </el-row>
                <div class="tel-box" style="max-height: 340px; overflow: auto; min-width: 749px">
                  <el-table
                    @row-click="handleTelRowClickSelectRow"
                    :data="telList"
                    style="width: 100%"
                    highlight-current-row
                    tooltip-effect="dark"
                    stripe
                    :cell-style="{ cursor: 'pointer' }"
                    :header-cell-style="{
                      background: '#f9f9f9',
                      color: '#333333',
                      fontWeight: '500',
                    }"
                  >
                    <el-table-column label="签署方名称" prop="enterpriseName" />
                    <el-table-column label="证件号" prop="businessLicense" />
                    <el-table-column label="接收手机号" prop="mobileOrChild" />
                  </el-table>
                </div>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="telPageInfo.itemPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="telPageInfo.pageSize"
                  layout="sizes, prev, pager, next, jumper, total"
                  :total="telPageInfo.total"
                  style="text-align: right; margin-top: 10px"
                />
              </el-tab-pane>
              <!-- 我的组织 -->
              <template v-for="(item, index) in totalAccountListNews">
                <template
                  v-if="
                    (item && item.userStemFrom !== -16 && !isInDingTalk) ||
                    (totalAccountListNews.length === 1 && !isInDingTalk) ||
                    isInDingTalk
                  "
                >
                  <!--  v-if="isGroup" 以前的条件-->
                  <el-tab-pane :key="index" :label="item.corpName" :name="item.corpUserId + ''">
                    <el-row class="tel-search">
                      <el-col :span="18">
                        <el-row>
                          <el-col :span="8" style="padding: 0 10px">
                            <el-input
                              clearable
                              v-model="myCorpModel.keyword"
                              @keyup.enter.native="clickHandleMyCorpSearch()"
                              size="small"
                              placeholder="邮箱/手机号"
                            />
                          </el-col>
                          <el-col :span="8" style="padding: 0 10px">
                            <el-input
                              clearable
                              v-model="myCorpModel.corpUserName"
                              size="small"
                              placeholder="签署方名称"
                            ></el-input>
                          </el-col>
                          <el-col :span="8" style="padding: 0 10px">
                            <el-select
                              v-model="myCorpModel.corpGroupId"
                              placeholder="请选择部门"
                              size="small"
                            >
                              <el-option label="全部" value></el-option>
                              <el-option
                                v-for="(item, i) in department"
                                :key="i"
                                :label="item.groupName"
                                :value="item.corpGroupId"
                              ></el-option>
                            </el-select>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="5" :offset="1">
                        <el-button @click="clickHandleMyCorpSearch()" size="small" class="btn">查询</el-button>
                        <el-button
                          @click="restCorp(), clickHandleMyCorpSearch()"
                          size="small"
                          class="btn"
                        >重置</el-button>
                      </el-col>
                    </el-row>
                    <div class="tel-box" style="height: 415px; overflow: auto">
                      <el-table
                        v-loading="myCorpModel.loading"
                        :empty-text="myCorpModel.emptyText"
                        @row-click="handleRowClickMyCorp"
                        :data="tableListMyCorp"
                        style="width: 100%"
                        highlight-current-row
                        tooltip-effect="dark"
                        stripe
                        :cell-style="{ cursor: 'pointer' }"
                        :header-cell-style="{
                          background: '#f9f9f9',
                          color: '#333333',
                          fontWeight: '500',
                        }"
                      >
                        <el-table-column label="邮箱/手机号" prop="targetId" />
                        <el-table-column label="签署方名称" prop="userName" />
                        <el-table-column label="部门" prop="groupNames" />
                      </el-table>
                    </div>
                    <br />
                    <el-pagination
                      @size-change="handleSizeChangeQueryToolMyCorp"
                      @current-change="handleCurrentChangeQueryToolMyCorp"
                      :current-page="myCorpModel.itemPage"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="myCorpModel.pageSize"
                      layout="sizes, prev, pager, next, jumper, total"
                      :total="myCorpModel.total"
                      style="text-align: right"
                    />
                  </el-tab-pane>
                </template>
              </template>
            </el-tabs>
            <p slot="footer" class="dialog-footer">
              <el-button
                @click="handleClickSelectSignorOk()"
                type="danger"
                size="small"
                class="btn"
              >确定</el-button>
            </p>
          </el-dialog>
          <!--1.填写企业证件号，2.对填写的姓名身份证号进行二要素验证错误-->
          <sign-info-tips-dialog
            :show.sync="visibleCredit"
            :entCreditArr="entCreditArr"
            :entCreditJson="entCreditJson"
            :userIdentityInfoArr="userIdentityInfoArr"
            @continue="addContractById"
            @cancel="handleDelSendContract"
          />
        </el-container>
        <!--  设置水印 setWatermarkVisible -->
        <el-dialog title="添加水印" width="60%" :visible.sync="setWatermarkVisible">
          <waterMark :visible.sync="setWatermarkVisible" :waterConfig.sync="waterConfig" />
        </el-dialog>
        <!-- 模板发起 - 选择模板 -->
        <dialog-pup
          :templateUpVisi.sync="templateUpVisi"
          @activeTplItem="activeTplItem"
          @officePDFInfo="officePDFInfo"
          :fileList="fileList"
        ></dialog-pup>
        <!-- 模板设置变量组件 -->
        <tpl-setting
          v-if="setTempVariable"
          :fileList="fileList"
          :setTempVariable.sync="setTempVariable"
          @replaceFiles="replaceFiles"
        ></tpl-setting>
        <!-- 签署方更多设置窗口 -->
        <more-setting
          :signSetVisi.sync="signSetVisi"
          :formInItem.sync="formInItem"
          :activeTabsName="activeTabsName"
          :signatoryJson="signatoryJson"
          @PupConfirm="PupConfirm"
          @videoPartIn="videoPartIn"
        ></more-setting>
        <!-- 校验码设置窗口 -->
        <access-pup
          :signSetVisi.sync="accessSetVisi"
          @PupConfirm="PupConfirm"
        ></access-pup>

        <!-- 添加固定签署方 -->
        <regular-pup
          :regularVisi.sync="regularVisi"
          :regularList="regularList"
          @regularAdd="regularAdd"
        ></regular-pup>
        <!-- onlyOffice -->
        <editor-pup
          :showofficeEditor.sync="showofficeEditor"
          :editor="editor"
          @saveLoading="saveLoading"
          @editedFile="editedFile"
        ></editor-pup>
        <!-- 邀请他人审阅弹窗 -->
        <cooper-pup :cooperVisi.sync="cooperVisi" @saveAndJump="saveAndJump"></cooper-pup>
      </div>
    </div>
    <div v-if="cooperate">
      <to-create :cooperateInfo="cooperateInfo" @finishCooperate="finishCooperate"></to-create>
    </div>
    <!-- 强制阅读设置弹窗 -->
    <ReadPup :visi="readPupVisi" @PupConfirm="PupConfirm"></ReadPup>
  </div>
</template>

<script>
// API
import {
  postMultipleCreateApply,
  postFindByEmailOrMphon,
  postTelFindByPagedEnterpriseList,
  postFileTempUpload,
  ApiMethods,
  convertDetailToShow,
  fileOperShow,
  queryCreditCodeByEntName,
  queryUserValidateByNameIDnum,
  uploadFileAndConvertInfo,
  getFindFileDownload,
  tempConvertToContract,
  getMultipleCorpDraftInfoByApplyId,
  getMultipleDraftInfoByApplyId
} from "../../assets/js/http-serve/http-methods";
import {
  mobileOrEmail,
  identityNo,
  businessVal,
  personalName,
  chTest,
  mobile,
  happy,
  email
} from "../../assets/js/lib/valid-methods";
import VideoSign from "../../assets/js/http-serve/video-sign";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import {
  loginOrRefresh,
  setCurrentUser,
  changeLgAccount
} from "@/assets/js/http-serve/corp/common";
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";

// tool
import GlobalConfig from "@/assets/js/config/global";
import moment from "moment";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import * as dd from "dingtalk-jsapi/entry/union";
// components
import ReadPup from "./components/readPup";
import Flow from "../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../components/singer-form";
import ToolTip from "../../components/tool-tip";
import ContractView from "../../components/contract-view/index";
import SignInfoTipsDialog from "../../components/contract/signInfoTipsDialog";
import ViewFilesToDoc from "@/components/viewFiles/ViewFilesToDoc";
import ViewFilesToImg from "@/components/viewFiles/ViewFilesToImg";
import waterMark from "@/components/waterMark/index";
import dialogPup from "./components/dialogPup.vue";
import tplSetting from "./components/tplSetting.vue";
import moreSetting from "./components/moreSetting.vue";
import accessPup from "./components/accessPup.vue";
import regularPup from "./components/regularPup.vue";
import editorPup from "../../components/onlyOffice/editorPup.vue";
import flowPath from "./components/dingTalkuse/flowPath.vue";
import selfSelection from "./components/dingTalkuse/selfSelection.vue";
import cooperPup from "./components/cooperateWith/cooperPup.vue";
import toCreate from "./components/cooperateWith/toCreateNew.vue";
import approvalProcess from "@/components/approval-process/index";
import { signerDataList } from "./common"
import { NonChinaLand } from '@/assets/js/utils/typesTool.js'

export default {
  data () {
    return {
      collaborationType: true,
      inputWidth: '173px',
      dynamicValidateForm: {
        domains: [
          {
            key: Date.now(),
            mobile: "",
            name: '',
            r_mobile: [{ validator: mobile, trigger: "change" }]
          }
        ]
      },
      readPupVisi: false, // 强制阅读弹窗
      qifengChapList: [], // 已设置骑缝章列表
      chapterList: [], // 授权给我的签章列表
      chapterCheck: [], // 选择的签章
      enterpriseTabChange: false,
      darfPhoneList: [], // 受邀协同人列表
      isSaveAsDraft: false, // 通过点击保存草稿
      cooperateInfo: {
        draftCoEditingSec: null
      }, // 协同编辑使用的数据
      cooperate: false, // 是否打开协同编辑页面
      cooperVisi: false, // 邀请审阅弹窗
      textcontent:
        "将合同链接通过短信发送受邀人，受邀人可修订合同内容，修订历史实时同步到您的草稿箱（仅支持doc、docx格式的文件修改）",
      // 钉钉环境使用变量 start
      isInDingTalk,
      flowTypes: ["flow_path", "self_selection"], // 钉钉环境下审批类型列表
      flowType: "flow_path", // 钉钉环境下选择的审批类型
      flowList: [], // 审批列表
      menbers: [{ appleven: 1, menber: [] }], // 审批自选
      flowSelect: [], // 审批流程shen
      // 钉钉环境使用变量 end
      showofficeEditor: false,
      editor: {},
      templateAPI: ApiMethods.templateAPI,
      contractBackUrl: "", // api发起合同页面跳转
      regularVisi: false, // 选择固定签署方显示控制
      regularList: [], // 模板发起选择的模板中的固定签署方
      personImgSign: 0, // 是否使用个人图形章
      //  newSignJson 因为经办人签字需要一个新的签章，原签章列表是根据签署方列表字段 signatoryJson 展示，为了数据不冲突将签章列表新建一个字段
      newSignJson: [],
      videoAnchor: "", // 视频主持人defaultAuthenticationType
      formInItem: {
        authLevel: null,
        needRead: false,
        readTime: 5,
        faceOrVideo: false,
        userType: 1,
        extraHandSign: null,
        signLevel: null // 签字设置 (图形章，手写签字)
      }, // 签署设置窗口表单
      setIndex: null, // 某个签署方更多设置下标
      signSetVisi: false, // 签署设置窗口
      accessSetVisi: false, // 访问码设置窗口
      setTempVariable: false, // 模板设置变量页面控制
      templateUpVisi: false,
      signTypes: ["faceSign", "videoSign",'InternationalVisa'],
      // attestTypes: [
      //   { label: "人脸识别", value: 11 },
      //   { label: "视频通话", value: 1 }
      //   // { label: "无认证方式", value: 0 }
      // ], // 认证类型
      // Integral: "", // 积分余额
      happy, // 正则
      /** 用来确定骑缝章的值 needQifengSign */
      qiFengSign: {
        personSign: 0,
        enterpriseSign: 1,
      },
      labelWidth: "150px",
      //tab切换
      activeTabsName: "faceSign",
      isSaveDisable: true, //禁用保存按钮
      goPageNum: null, // 前往多少页
      payInfoData: {},
      showMoreSet: false,
      // 雷云风新的需求，发起审批新流程
      flows: [],
      hasApplyApproval: false,
      approvalFlowList: [],
      approvalFlowSelect: undefined,
      showAllUser: false, //显示所有用户主体
      batchLoading: false,
      // 批量签署方 array
      batchArray: [],
      // 批量签署方 checkbox
      checkedBatch: null,
      // 支付方式select 展开关闭状态
      visibleChangeSelectStatus: false,
      // 是否是集团账户
      isGroup: false,
      // 添加审批人/抄送人Dialog
      visibleAuditAndCopy: false,
      auditAndCopyTitle: "",
      auditAndCopyModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0
      },
      tableListAuditAndCopy: [], // 审批人 抄送人列表

      arrayCopior: [], // 抄送人数组
      tableAuditAndCopySelectRows: [],
      // 我的组织 选择签署人
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 名称
        corpGroupId: "" // 部门ID
      },
      tableListMyCorp: [],
      tableSignorSelectRow: undefined,
      tableSignorSelectRowTargetID: undefined,

      // 签署方 tabs
      activeTabSigner: "default", // 我的通讯录 default , 我的组织 organization
      activeTabOrganizationName: "我的组织",
      // select index
      selectIndex: 0,
      apiMethods: ApiMethods,
      contractNameRules: {
        contractName: [
          // {validator: this.$validator.specialValContractName, trigger: 'change', message: '文件名称不能包含特殊字符'},
        ]
      },
      // 合同信息
      contractInfo: {
        //判断是否是草稿箱回来
        applyIdSec: "",
        //批量签署方 批量发起签署顺序1-n ,当前批量的签署顺序,顺序签
        batchSignOrder: 0,
        //主题名称
        contractName: "",
        // 批量签署方信息
        batchSigners: [],
        //自定义抄送，高级版才有
        carbonCopy: [],
        //付费方式
        consumMode: 0,
        //上传的文件和附件集合
        files: [],
        //审批流程ID，高级版才有
        flowId: 0,
        // 顺序签
        ifOrder: false,
        /**
         * 是否使用骑缝章
         * @value 0 不要企业和个人骑缝章（两个都不打钩）
         * @value 1 企业和个人都有骑缝章（两个都打钩）
         * @value 2 企业打钩个人不打钩
         * @value 3 企业不打钩个人打钩
         * */
        needQifengSign: 2,
        // 保全章
        needPresSign: 1,
        //是否使用视频签署 1使用
        needVideoSign: 0,
        //合同截止时间
        overDate: "",
        //是否支付,1是支付，其他查询消耗的积分数
        pay: 0,
        //是否保存到草稿
        saveToDraftBox: false,
        //是否云证书
        serverCa: 1,
        //签字链接有效期
        signExpire: "",
        // 正常签署方
        signers: [],
        draftChapteJson: [],
        // 视频签署
        newNeedVideoSign: "", // 是否使用视频签署
        videoSignStartTime: "", // 开始时间
        hideSignDate: 0, // 签章不显示时间
      },
      // 临时展示合同信息
      contractInfoTemporary: {},
      // 合同列表临时保存当前合同信息
      contractList: {},
      rulesTab: {
        email: [{ validator: email, trigger: "change" }],
        account: [{ validator: mobileOrEmail, trigger: "change" }],
        mobile: [{ validator: mobile, trigger: "change" }],
        name: [{ validator: personalName, trigger: "blur" }],
        // identityNo: [{ validator: identityNo, trigger: "blur" }],
        identityNo: [{ required: true, message: '请输入签署方证件号码', trigger: 'blur' }],
        businessLicense: [{ validator: businessVal, trigger: "blur" }]
      },
      host: [], // 视频主持人
      signatoryJson: [
        {
          faceOrVideo: null, // 用户是否选中视频通话
          // 签署方信息邮箱或者电话
          account: "",
          authLevel: null,
          userType: 0,
          // 签章位置
          chapteJson: [],
          // 身份信息或者企业id
          identityNo: "",
          mobile: "",
          // 签章等级
          signLevel: null,
          // 签署方名称
          name: "",
          corpUser: "",
          videoSignUserType: "", // 视频签署，签署方类型，1: 参与者，2: 主持者
          readTime: null, // 强制阅读
          businessLicense: "",
          // 辅助变量
          // 新增集团账户 数组
          corpUserStatus: false,
          canSelectArray: [],
          canSelectArrayIndex: 0,
          signatoryUserType: 0,
          ischange: 0,
          signOwner: "签署方一",
          disabled: "",
          openUserTab: false,
          isEncrypt: false,
          isNoticePhone: false,
          showNoticePhone: false,
          idCardNoShow: false,
          extraHandSign: null, // 经办人签字
        }
      ],
      isSaveToDraftBox: false, // 合同是否保存到草稿箱
      // 企业名称和企业证件号，key(signatoryJson中的signatoryFullName签署方名称)=>value(signatoryJson中的signatoryIdentityCard证件号) 只能是企业类型的用户
      // 签署方身份信息验证相关 start
      //..... 验证用户输入的企业是否存在 start.....
      entCreditJson: null,
      entCreditArr: [],
      entNameArr: [],
      visibleCredit: false,
      //..... 验证用户输入的企业是否存在 end.....
      userIdentityInfoArr: [], // 存放需要进行姓名身份证二要素的数组
      // 签署方身份信息验证相关 end
      // 签章参数 {page: 0合同第几页, chaptes:[签章位置{offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}]}
      chapteJson: [],
      // 联系人相关通讯录
      telList: [],
      telPageInfo: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      },
      showTel: false,
      boxHeight: "1170px",
      windowHeight: 798,
      leftCSideHeight: 0,
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      accessoryShow: false,
      timer: null,
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      // 是否有视频签署套餐
      hasVideoPackage: false,
      loading: null,
      dragging: false,
      guideStep: null,
      guideSignStep: null,
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      // 签署方相对坐标, 甲,乙,丙....
      // relativeCoordinate: {
      //   签署方一: { x: 0.2, y: 0.2 },
      //   签署方二: { x: 0.2, y: 0.22 },
      //   签署方三: { x: 0.2, y: 0.24 },
      //   签署方四: { x: 0.2, y: 0.26 },
      //   签署方五: { x: 0.2, y: 0.28 },
      //   签署方六: { x: 0.2, y: 0.3 },
      //   签署方七: { x: 0.2, y: 0.31 },
      //   签署方八: { x: 0.2, y: 0.32 },
      //   签署方九: { x: 0.2, y: 0.34 },
      //   签署方十: { x: 0.2, y: 0.36 },
      //   批量签署方: { x: 0.2, y: 0.38 }
      // },
      authLevelShow: false,
      payDisabled: false,
      gifClick: false,
      // 合同缩放比例
      scaleValue: 100,
      chap: [], //未设签章数组
      signDialog: false, //未设签章弹窗
      department: [], // 部门列表
      signlinktime: "", //签署链接时效
      clearable: false,
      pickerOptions: {
        disabledDate (time) {
          const one = 15 * 24 * 3600 * 1000;
          const minTime = new Date().getTime();
          const maxTime = new Date().getTime() + one;
          return time ? (time.getTime() < minTime || time.getTime() > maxTime) : false;
        }
      },
      videoPickerOptions: {
        disabledDate (time) {
          // 只能选择当天及往后
          const one = 24 * 3600 * 1000,
            minTime = new Date().getTime() - one,
            maxTime = new Date().getTime();
          return time ? time.getTime() < minTime : false;
        }
      },
      // 903需求新增变量
      nextstep: false,
      accountNameTab: "",
      authDialog: false, //是否实名认证弹窗
      // 上传附件数组
      enclosureFilesList: [],
      // 文件上传列表
      fileList: [],
      // copy 文件上传列表 （含有模板发起步骤，点击上一步做数据回显)
      copyTemp: [],
      //图片转换接口
      fileOperShow: fileOperShow,
      // pdf 预览
      visibleShowEnclosureDoc: false,
      //其他 文件预览
      visibleShowEnclosure: false,
      enclosurePreviewNumItem: {}, // 当前预览项
      visibleSigningFlow: false, //签署流程图
      checkAct: -1, // 当前显示合同选中文件
      isRefresh: true, // 预览附件时，强制刷新
      drawerShow: false, //侧边展示
      fileImgName: "",
      fileImgShow: true,
      setWatermarkVisible: false, //  水印弹窗
      waterConfig: {}, //水印内容
      PDFImg: require("../../static/images/advancedVersion/pdf.png"),
      JPGImg: require("../../static/images/advancedVersion/JPG.png"),
      XLSImg: require("../../static/images/advancedVersion/xlsx.png"),
      DOCImg: require("../../static/images/advancedVersion/word.png"),
      WPSImg: require("../../static/images/advancedVersion/WPS.png"),
      TPLImg: require("../../static/images/advancedVersion/pdf_1.png"),
      docTpl: require("../../static/images/advancedVersion/file_1.png"),
    };
  },
  computed: {
    dateTimeFn () {
      let ts2 = new Date(this.signlinktime).getTime();
      let ts1 = new Date().getTime();
      // 计算时间差（毫秒）
      const timeDiff = Math.abs(ts2 - ts1);
      // 转换为小时（1小时 = 3600000毫秒）
      const hours = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return hours * 24
    },
    // 返回已添加的签署人列表
    signerList () {
      // 过滤出参与视频通话的签署方
      const list = this.signatoryJson.filter(
        item => item.faceOrVideo == 1 && item.name
      ),
        anchor = this.videoAnchor;
      if (anchor) {
        // 当前选中的视频通话主持人中是否还参与视频通话
        const have = list.some(item => item.signOwner === anchor);
        // 如果当前视频通话主持人不参与通话，就清空
        if (!have) this.videoAnchor = "";
      }
      return list;
    },
    // 返回模板列表
    tempList () {
      const filterList = this.fileList.filter(item =>
        item.hasOwnProperty("tplName")
      );
      let temps = [];
      temps = this.copyTemp.length > 0 ? this.copyTemp : filterList;
      return temps;
    },
    // 判断预览列表中的是否存在签章位置
    fixedFilePage () {
      return function (index) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(
            v => v.targetId === this.contractInfoTemporary.targetId
          );
          return arr.findIndex(i => i.page === index - 1) !== -1 ? true : false;
        }
      };
    },
    filePage () {
      return function (file) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(v => {
            const VO = file.fileOperVO;
            v.targetId === VO ? VO.targetId : file.targetId;
          });
          return arr.length > 0 ? true : false;
        }
      };
    },
    // 当前签署方在当前文件设置的数量
    signOwnerLen () {
      return function (signOwner) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(
            item => item.targetId === this.contractInfoTemporary.targetId
          );
          let list = arr.filter(val => val.signOwner === signOwner);
          return list.length;
        } else {
          return 0;
        }
      };
    },
    //   签署方在所有文件中的设置数量
    signOwnerAll () {
      return function (signOwner) {
        if (this.chapteJson.length > 0) {
          let list = this.chapteJson.filter(val => val.signOwner === signOwner);
          return list.length;
        } else {
          return 0;
        }
      };
    },
    totalAccountListNews () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      let arr = this.$store.getters.allAuthUser.bindCorpUsers;
      if (isInDingTalk) {
        arr = arr.filter(user => {
          if (info.jzqCorpId === user.corpId) {
            this.codeAccount(user);
          }
          return info.jzqCorpId === user.corpId;
        });
      }
      console.log(arr, '======-***--')
      return arr;
    },
    totalAccountList () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      let arr = [this.$store.getters.allAuthUser.accountInfoVO];
      if (this.$store.getters.allAuthUser.bindCorpUsers) arr = this.$store.getters.allAuthUser.bindCorpUsers.concat(arr);
      if (isInDingTalk) {
        arr = arr.filter(user => {
          if (info.jzqCorpId === user.corpId) {
            this.codeAccount(user);
          }
          return info.jzqCorpId === user.corpId;
        });
      } else {
        arr = arr.filter((item) => {
          return item.userStemFrom && item.userStemFrom !== -16
        })
      }
      // bug编号【7624】，进入发起页不进行默认选中，以当前主体为发起方
      // this.chooseEnterpriseFn(arr[0]);
      return arr;
    },
    currentUser () {
      return this.$store.getters.currentAuthUser;
    },
    bindCorpList () {
      return this.$store.getters.allAuthUser.bindCorpUsers
    },
    // 获取附件中的图片列表，用于预览
    getEnclosureImgList () {
      const arr = [];
      const list = this.enclosureFilesList.filter(item => {
        return this.isImg(item) || this.isVideo(item);
      });
      list.forEach(val => {
        const info = {
          id: val.fileOperVO.targetId,
          file: {
            ...val.fileOperVO,
            fileSize: val.fileOperVO.fileSize,
            fileName: val.fileName
          }
        };
        arr.push(info);
      });
      return arr;
    }
  },
  created () {
    let {
      applyId,
      auditId,
      contractDraftId,
      multiFileKey,
      multiSignatoryKey,
      tplId,
      contractName,
      drafts,
      draftCoEditingSec
    } = this.$route.query;
    if (drafts) {
      // 草稿箱点击协同过来的
      this.cooperateInfo.draftCoEditingSec = draftCoEditingSec
      this.cooperate = true
    }
    if (applyId) {
      this.getDraftContractInfoByApplyId(applyId);
    } else {
      const user = this.totalAccountList[0];
      if (user)
        this.accountNameTab = user.corpName || user.name || user.username;
    }
    //*  22/10/21  如果是合同审核页面过来发起.获取到合同文件信息再需要获取到PDF文件数据
    if (auditId) this.auditIdInfo(auditId)
    //* 22/10/21 如果是合同起草页面发起，需要获取到PDF文件数据
    if (contractDraftId) this.darfInfo({ contractDraftId, contractName })
    //*  23/05/15  如果存在 【 multiFileKey 】字段需要获取到合同文件信息再需要获取到 PDF文件数据
    //*  23/07/27  如果存在 【 multiSignatoryKey 】字段需要获取到合同文件的签署方信息
    if (multiFileKey || multiSignatoryKey) this.multifileInfo({ multiFileKey, multiSignatoryKey })
    // 如果存在 【tplId】 字段说明是模板列表过来的。需要查询详情再推入 【fileList】 中
    if (tplId) {
      if ([0, '0'].includes(this.currentUser.userType)) {
        this.templateInfo(tplId)
      } else {
        this.tplInfo(tplId)
      }
      // this.tplInfo(tplId)
    }
    this.getUserJurisdiction();
    this.getAndSetTime();
  },
  filters: {
    eclipse (value) {
      if (!value) return "";
      let maxNum = 23;
      value = value + "";
      return value.length > maxNum ? value.substr(0, maxNum) + "..." : value;
    }
  },
  mounted () {
    this.boxHeight = document.body.clientHeight - 60 + "px";
    this.leftCSideHeight =
      document.body.getBoundingClientRect().height - 100 + "px";
    this.windowHeight = document.body.getBoundingClientRect().height;
    this.getTelList();
    this.queryUserHasVideoPackage();
    const { multiSignatoryKey } = this.$route.query,
      authUser = this.$store.getters.authUser,
      account = authUser.mobileMash || authUser.emailMask;
    if (!multiSignatoryKey) {
      this.signatoryJson[0].account = account;
      this.signatoryJson[0].signatoryUserType = authUser.userType;
      this.signatoryJson[0].identityType = authUser.identityType
        ? authUser.identityType
        : null;
      // 第一次加载
      this.getUserInfoBySelectTargetId({ account, selectIndex: 0, type: true });
    }
    if (localStorage.getItem("APPLY_GUIDE_SIGN") !== "guide") {
      this.guideSignApply("signStep1");
    }
    // 钉钉环境调用接口
    if (isInDingTalk) this.getFlows();
    // 查询偏好设置
    this.getSettings()
  },
  watch: {
    currentUser: {
      handler (val) {
        // 企业
        this.signatoryJson[0].signatoryUserType =
          val.userType === 1 || val.corpUserId ? 1 : 0;
        this.handleSignUserType(this.signatoryJson[0], 0);
        this.chapterCheck = []
      },
      deep: true
    },
    "contractInfo.consumMode" (val) {
      if (val === 1) {
        this.contractInfo.serverCa = 1;
      }
    },
    checkedBatch (val) {
      if (val) {
        if (!this.batchArray.length) {
          this.signatoryJson.push({
            signOwner: "批量签署方",
            chapteJson: []
          });
        }
      } else {
        this.delSignList({ signOwner: "批量签署方" });
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 提交数据
          // 获取到上传的文件及附件。保存到vux中到协同页面
          const phoneList = this.dynamicValidateForm.domains.map(item => {
            return { mobile: item.mobile, name: item.name };
          });
          const mobiles = phoneList.map(item => {
            return item.mobile
          })
          let set = new Set(mobiles);
          if (set.size !== mobiles.length) return this.$message.error('请不要输入重复手机号码');
          this.saveAndJump(phoneList)
          // this.resetForm(formName)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      const domains = this.dynamicValidateForm.domains;
      domains.forEach(ele => {
        ele.name = ''
      });
      this.$refs[formName].resetFields();
    },
    removeDomain (item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain () {
      const domains = this.dynamicValidateForm.domains;
      if (domains.length == 10) return this.$message.warning('最多邀请 10 人参与审阅')
      domains.push({
        mobile: "",
        name: '',
        r_mobile: [{ validator: mobile, trigger: "change" }],
        key: Date.now()
      });
    },
    /** 跳转到国际版 */
    linkFairsign(){
      const _current = this.currentUser;
      const {userType,emailAuth,emailMask,identityAuth} = _current;
      const personThrough = userType == 0 && emailAuth == 1 && emailMask;
      const canPassThrough = identityAuth == 1 && personThrough;
      if(!canPassThrough){
        this.toInternational()
        return
      }
      ApiMethods.InternationalAPI.fairLogin().then(res=>{
        if(!res.success) return this.$message.error(res.description)
        window.open(res.data,'_blank')
      })
    },
    // 跳转国际版逻辑
    toInternational(){
      const _current = this.currentUser;
      const {userType,emailAuth,emailMask,identityAuth} = _current;
      if(userType === 0 && emailAuth != 1 && !emailMask) {
          this.$confirm('请先完成邮箱绑定再跳转！是否前往绑定？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({path: '/tpl/accountInfo'})
          }).catch(() => {
          })
        }else{
          ApiMethods.InternationalAPI.fairLogin().then(res=>{
            if(!res.success) return this.$message.error(res.description)
            window.open(res.data,'_blank')
          })
        }
    },
    /** 校验码设置 */
    checkCodeChange(val,item,i){
      if(val){
        this.setIndex = i;
        this.formInItem = Object.assign(this.formInItem, item);
        this.accessSetVisi=true;
      }else{
        item.accessCode = '';
      }
    },
    /**
     * 跳转偏好设置页面
     */
    turnPref () {
      let current = this.currentUser, MAIN = this.$store.getters.allAuthUser.accountInfoVO,
        entP = {
          path: "/console/account",
          query: { type: '6', account: '111' }
          // 为了兼容控制台layouts中的判断，这里无其他作用
        }, person = { path: "/tpl/Preferences" };
      if (current.corpUserId) {
        setCurrentUser(MAIN).finally(() => {
          this.$store.dispatch("setIgnoreChangePage", false);
          const _current = this.currentUser;
          const route = _current.userType === 0 ? person : entP
          let routeUrl = this.$router.resolve(route);
          this.$nextTick(() => {
            window.open(routeUrl.href, "_blank");
          })
        });
      } else {
        const route = current.userType === 0 ? person : entP
        let routeUrl = this.$router.resolve(route);
        console.log('current', current);
        window.open(routeUrl.href, "_blank");
      }
    },
    /** 查询偏好设置(如果有，将对应设置设值为偏好值) */
    getSettings () {
      this.loadingStart()
      ApiMethods.PreferenceSettingsAPI.getPreferences().then(res => {
        if (!res.success) return this.$message.error(res.description);
        if (res.data) {
          const { presFlag, qifengFlag, perQifengFlag, perSealFlag, timeFlag, waterFlag, waterSetting } = res.data;
          this.contractInfo.needPresSign = presFlag
          this.qiFengSign.enterpriseSign = qifengFlag || 0
          this.qiFengSign.personSign = perQifengFlag || 0
          this.personImgSign = perSealFlag
          this.contractInfo.hideSignDate = timeFlag
          if (!!waterFlag) {
            const water = JSON.parse(waterSetting);
            water.switch = true
            if (water.floatAlpha <= 1) water.floatAlpha = water.floatAlpha * 100
            this.waterConfig = { ...water }
          }
          this.qifengChange()
        }
      }).finally(() => { this.loadingClose() })
    },
    /** 设置骑缝章 */
    settingQIFENG () {
      const CVIEW = this.$refs.contractView;
      const QIFENGCOM = CVIEW.$refs.qifengCom
      QIFENGCOM.scrollRight()
    },
    imgShowFn (i) {
      let url = convertDetailToShow({
        docHash: this.contractInfoTemporary.docHash,
        ts: this.contractInfoTemporary.ts,
        sign: this.contractInfoTemporary.sign,
        items: this.contractInfoTemporary.items,
        targetId: this.contractInfoTemporary.targetId,
        fileType: 3,
        fix: "png",
        num: i - 1
      })
      return url;
    },
    // 设置骑缝章 start
    /** 更新章位置 */
    updateQifeng ({ offY, y, cindex }) {
      this.qifengChapList.forEach((t, i) => {
        if (t.cindex == cindex) {
          const _offY = offY < 1 ? offY : 0.9999
          this.$set(this.qifengChapList[i], 'offsetY', _offY)
          t.imageHeight = y;
        }
      });
    },
    /** 删除骑缝章 */
    delQifeng (cindex) {
      this.qifengChapList = this.qifengChapList.filter(t => cindex !== t.cindex);
    },
    // 设置骑缝章 end
    /** 签署方是否含有发起方 */
    isMine () {
      const mine = this.signatoryJson.filter((sign) => sign.sameCorpUser)
      return mine.length ? true : false
    },
    /** 选择签章 */
    selectChap (chap) {
      // 没有值就选中，反之取消选中
      const have = this.chapterCheck.some((id) => id === chap.corpSealId)
      if (!have) {
        this.chapterCheck.push(chap.corpSealId)
        return
      }
      this.chapterCheck.forEach((id, i) => {
        if (chap.corpSealId === id) {
          this.chapterCheck.splice(i, 1)
        }
      })
    },
    /** 获取章列表 */
    getChapterList () {
      ApiCorpMethods.SealController.listSeals().then(res => {
        if (res.success) {
          if (res.data) {
            this.defalutChapter = res.data[0] || {};
            let list = res.data || null;
            list.forEach(t => {
              t.signUrl = fileOperShow(t.sealFile);
            });
            this.chapterList = list;
            if (list.length) {
              this.chapterCheck.push(list[0].corpSealId)
            }
          } else {
            this.chapterList = [];
          }
        }
      });
    },
    /** 查看章审批详情 */
    computeInfo (obj) {
      let nameList = [], list = [];
      if (isInDingTalk) {
        // 钉钉流程 flowType 1:顺序审（多层，每层一个），2：会审（单层，一层多个
        const { nodes } = obj.flowParam;
        nodes && nodes.forEach((node) => {
          nameList.push(...(node.userApproveUsers.map(user => user.name)))
        })
        list = nameList.map(name => {
          return { partyName: name };
        });
      } else {
        const keyStr = obj.orderFlag ? "->" : "、"
        nameList = obj.allPartName.split(keyStr);
        list = nameList.map(name => {
          return { partyName: name };
        });
      }
      return list;
    },
    //通讯录选择签署方切换
    tabClick () {
      if (this.activeTabSigner !== 'default') {
        this.clickHandleMyCorpSearch();
        this.getDepartmentList();
      }
    },
    idCardNoShowFn (item) {
      item.idCardNoShow = true;
    },
    // * 协同编辑【1406】
    // 完成审阅
    finishCooperate ({ fileList, enclosureFilesList }) {
      this.collaborationType = false; //切换到发起
      this.fileList = fileList;
      this.enclosureFilesList = enclosureFilesList
      this.cooperate = false
    },
    // 邀请审阅
    inviteReview () {
      let docFileT = this.fileList.some(item => {
        return item.tplName ?
          (item.tplName.endsWith('.doc') || item.tplName.endsWith('.docx')) :
          (item.fileName.endsWith('.doc') || item.fileName.endsWith('.docx'));
      })
      if (this.fileList.length && docFileT) {
        this.cooperVisi = !this.cooperVisi;
      } else {
        this.$message.warning("请先上传doc或docx格式的文件！");
      }
    },
    // 无感保存草稿并跳转协同编辑
    saveAndJump (phoneList) {
      this.sendContractToCreate(true, phoneList);
    },
    // * 协同编辑【1406】 end
    saveAsDraft (status) {
      this.isSaveAsDraft = true;
      this.sendContractToCreate(status)
    },
    // * 钉钉环境使用 start
    /** 创建预审批流 */
    createPreApproved (paramInfo) {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        _this = this;
      const data = {
        corpId: info.dingTalkCorpId,
        dingTalkUserId: info.dingTalkUserId,
        ...paramInfo
      };
      if (this.checkedBatch) return this.contractIsSaveToDraf(data)
      console.log("data", data);
      // return false;
      dingtalkApi.precreate(data).then(res => {
        console.log("预审批流创建流程", res);
        if (!res.success && res.code !== '18001') return _this.$message.error(res.description);
        if (res.code === '18001') {
          return _this.$confirm(`
            <p>${res.description}</p>
            <p style="color:#ec1c1c">
              （如您选择的是同步钉钉组织架构模式，请在钉钉组织架构中维护部门主管信息，若选择的是自行管理组织架构，
              请在企业控制台-组织及权限菜单，维护部门主管信息）
            </p>
          `, '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '添加审批人',
            cancelButtonText: '跳过主管审批',
            dangerouslyUseHTMLString: true
          }).then(() => {
             // 添加审批人
            this.chooseApproval(paramInfo)
          }).catch((type) => {
            // 跳过审批
            if(type === 'cancel'){
              _this.createPreApproved({...paramInfo,ignoreGroupManager:1})
            }
          })
        }
        // 预审批流程创建完成后发起合同，发起成功创建审批流
        const { dingTalkCorpId, dingTalkUserId } = JSON.parse(
          sessionStorage.getItem("dingloginInfo")
        );
        const params = {
          dingTalkWorkFlowId: res.data,
          dingTalkCorpId,
          dingTalkUserId
        };
        this.contractIsSaveToDraf(params);
      });
    },
    /** 发起时选择审批人 */
    chooseApproval(paramInfo){
      const corpId = sessionStorage.getItem("corpId");
      dd.complexChoose({
        maxUsers: 1,
        corpId,
        multiple: false,
        pickedUsers: [],
        disabledUsers: [],
        responseUserOnly: true,
        success: res => {
          if(res.selectedCount > 0){
            const user = res.users[0];
            const _params = {...paramInfo,userSelectManagerId:user.emplId}
            // 选择成功后重新发起
            this.createPreApproved(_params)
          }
        },
      }).catch((err) => { console.log("catch_err:", err) });
    },
    // 获取审批人信息
    getFlowUserInfo () {
      let nodes = [],
        _this = this;
      let info = {};
      // 自主选择
      if (this.flowType === this.flowTypes[1]) {
        _this.menbers.forEach(item => {
          //  拿到每层的人列表
          const userList = item.menber;
          let userApproveUsers = [];
          userList.forEach(elem => {
            userApproveUsers.push({
              name: elem.name,
              userId: elem.emplId
            });
          });
          if (userApproveUsers.length > 0) nodes.push({ userApproveUsers });
        });
        // 这里 nodes 是 选择审批人用的判断
        console.log("nodes", nodes);
        if (nodes && nodes.length == 0) {
          _this.$message.error("请选择审批人员");
          return false;
        }
      }
      if (this.flowType === this.flowTypes[0]) {
        const flowArr = this.flowSelect
        nodes = flowArr.length ? flowArr[0].nodes : [];
      }
      info = {
        ccUsers: [],
        nodes
      };
      return info;
    },

    // 立即发起
    async sendWithDingTalk (saveToDraftBox) {
      const flowInfo = await this.getFlowUserInfo();
      if (!flowInfo) return;
      if (this.checkedBatch) {
        if (this.batchArray.length === 0) {
          this.$message.warning("请添加批量签署方");
          return false;
        }
      }
      if (this.fileList.length === 0) {
        return this.$message.warning("请先上传需要签署的文件！");
      }
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        // if (this.$refs['referenceSignerForm'] && this.$refs['referenceSignerForm'].length > 0) {
        //   this.$refs['referenceSignerForm'][this.selectIndex].clearValidate();
        // }
      }
      // 验证填写信息
      this.$refs.contForm.validate(valid => {
        if (valid) {
          if (
            !this.contractInfo.contractName ||
            this.contractInfo.contractName === ""
          )
            return this.$message.warning("请输入主题名称");
          if (this.contractInfo.contractName.length > 100)
            return this.$message.warning("主题名称不能超过一百个字符");
          if (
            parseInt(this.contractInfo.needVideoSign) === 1 &&
            this.signatoryJson.length !== 2
          )
            return this.$message.error("视频签只允许有两个手动签署方");
          let validChild = true;
          // 验证 签署方form表单列表
          let rulesTab = this.$refs.contractListTab;
          if (rulesTab) {
            rulesTab.forEach(t => {
              if (t.validate) {
                t.validate(() => { });
              }
            });
            try {
              rulesTab.forEach(t => {
                if (t.fields) {
                  const fields = t.fields;
                  if (fields) {
                    fields.forEach(element => {
                      if (
                        element.prop !== "" &&
                        element.validateState === "error"
                      ) {
                        throw new Error("validFails");
                      }
                    });
                  }
                }
              });
            } catch (error) {
              validChild = false;
            }
          }

          // 验证批量签署方form表单列表
          let validChildBatch = true;
          let contractBatchListTab = this.$refs.contractBatchListTab;
          if (contractBatchListTab) {
            contractBatchListTab.forEach(t => {
              t.validate(() => { });
            });
            try {
              contractBatchListTab.forEach(t => {
                const fields = t.fields;
                if (fields) {
                  fields.forEach(element => {
                    if (
                      element.prop !== "" &&
                      element.validateState === "error"
                    ) {
                      throw new Error("validFails");
                    }
                  });
                }
              });
            } catch (error) {
              validChildBatch = false;
            }
          }
          if (!validChild || !validChildBatch)
            return this.$message.error("请检查签署方信息！");
          this.isSaveToDraftBox = saveToDraftBox;

          // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
          // 签署方式企业用户且没有证件号
          this.entCreditJson = {};
          this.entCreditArr = [];
          this.entNameArr = [];
          let queryCreditcodeParam = [];
          // 二要素验证变量
          this.userIdentityInfoArr = [];
          let userIdentityInfoParam = []; // 存放需要进行二要素的数组
          this.signatoryJson.forEach(t => {
            // 企业用户且没有证件号
            if (
              parseInt(t.signatoryUserType) === 1 &&
              t.name &&
              !t.identityNo
            ) {
              queryCreditcodeParam.push(t.name);
            }

            // 个人信息-姓名身份证二要素验证
            if (
              parseInt(t.signatoryUserType) === 0 &&
              t.name &&
              t.identityNo &&
              t.identityNo.indexOf("***") === -1
            ) {
              // 是个人且有姓名身份证号码，且身份证号码未加密（手动输入的）
              userIdentityInfoParam.push({
                name: t.name,
                identityNo: t.identityNo
              });
            }
          });

          if (
            (queryCreditcodeParam && queryCreditcodeParam.length) ||
            (userIdentityInfoParam && userIdentityInfoParam.length)
          ) {
            // 查询企业执照号，验证个人信息
            let arr = [];
            if (queryCreditcodeParam && queryCreditcodeParam.length) {
              // 查询企业执照号并将查询到的企业赋值
              arr.push(this.queryEntIDByEntName(queryCreditcodeParam));
            }
            if (userIdentityInfoParam && userIdentityInfoParam.length) {
              // 二要素验证，身份信息不正确的予以提示
              arr.push(this.twoElementsVerify(userIdentityInfoParam));
            }
            Promise.all(arr).then(res => {
              if (res && res.length) {
                for (let i = 0; i < res.length; i++) {
                  let smt = res[i];
                  if (smt && !smt.sus) {
                    this.visibleCredit = true; // 显示签署方信息提示弹窗
                    return false; // 中止后面的操作
                  }
                }
                this.createPreApproved(flowInfo); // 创建预审批流
              }
            });
          } else {
            // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《
            this.createPreApproved(flowInfo); // 创建预审批流
          }
        } else {
          console.error("验证不通过.");
        }
      });
    },
    // 选择的审批流程
    flowSelectChange (flow) {
      // console.log('flow',flow);
      this.flowSelect = flow;
      const ccUser = flow[0].webCCUsers
      ccUser.forEach(user => {
        user.corpUserIdSec = user.corpUserIdApplySign
      })
      this.arrayCopior = ccUser
    },
    // 删除层级
    delLeven (i) {
      this.menbers.splice(i, 1);
    },
    // 删除审批人
    delUser (leven, user) {
      const mens = this.menbers[leven].menber;
      mens.forEach((item, i) => {
        if (item.emplId === user.emplId) {
          mens.splice(i, 1);
        }
      });
    },
    // 添加审批层级
    addLeven () {
      let len = this.menbers.length;
      this.menbers.push({ appleven: ++len, menber: [] });
    },
    // 鉴权 + 选人
    chooseMenber ({ index: i, isManager }) {
      if (isManager) return this.addManager(i)
      const corpId = sessionStorage.getItem("corpId");
      const len = this.menbers.length;
      let max = 1,
        users = [];
      if (len > 1) max = 1;
      if (len === 1) max = 20;
      this.menbers.forEach(item => {
        const mens = item.menber;
        const menIds = mens.map(elem => {
          return elem.emplId;
        });
        users.push(...menIds);
      });
      dd.complexChoose({
        maxUsers: max,
        corpId,
        multiple: len > 1 ? false : true,
        pickedUsers: len === 1 ? users : [],
        disabledUsers: [],
        responseUserOnly: true,
        success: res => {
          console.log('res_choose', res);
          let _menber = this.menbers[i].menber
          const _newMen = _menber.filter(item => item.emplId === '-1')
          this.menbers[i].menber = [..._newMen, ...res.users];
        },
      }).catch((err) => { console.log("catch_err:", err) });
    },
    /** 添加直属部门主管 */
    addManager (i) {
      const _men = this.menbers[i].menber;
      const haveAss = _men.some(item => item.emplId === '-1')
      if (haveAss) return this.$message.error('审批人不能重复')
      this.menbers[i].menber.push({ name: '部门直属主管', emplId: '-1' })
    },
    getFlows () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      // status 启用状态 0:启用，1：禁用
      dingtalkApi
        .workflowList({
          corpId: info.dingTalkCorpId,
          dingTalkUserId: info.dingTalkUserId,
          status: 0
        })
        .then(res => {
          console.log("dingRes", res);
          if (!res.success) this.$message.error(res.description);
          this.flowList = res.data;
        });
    },
    // * 钉钉环境使用 end
    templateInfo (tplId) {
      ApiMethods.TemplateController.personDetailByID(tplId).then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        const { files } = res.data.context;
        const name = files[0].fileName;
        let _file = {
          fileName: name,
          fileType: 1,
          tempFile: files[0].tempFile || "",
          items: files[0].items || "",
          sort: null,
          sourceFile: { ...files[0].sourceFile, fileName: name },
          fileOperVO: {
            docHash: files[0].docHash || "",
            extendsLocation: "",
            fileName: name,
            fileType: 3,
            sign: files[0].sign,
            targetId: files[0].targetId,
            targetIdForPreview: "",
            ts: files[0].ts
          }
        };
        // this.fileList.push(_file);
        //
        this.officePDFInfo(_file.sourceFile);
      });
    },
    //
    tplInfo (tplId) {
      ApiMethods.TemplateController.advanceVDetailByID(tplId).then(res => {
        if (!res.success)
          return this.$message.error(res.description || this.$tip);
        const { files } = res.data.context;
        const name = files[0].fileName;
        let _file = {
          fileName: name,
          fileType: 1,
          tempFile: files[0].tempFile || "",
          items: files[0].items || "",
          sort: null,
          sourceFile: { ...files[0].sourceFile, fileName: name },
          fileOperVO: {
            docHash: files[0].docHash || "",
            extendsLocation: "",
            fileName: name,
            fileType: 3,
            sign: files[0].sign,
            targetId: files[0].targetId,
            targetIdForPreview: "",
            ts: files[0].ts
          }
        };
        // this.fileList.push(_file);
        //
        this.officePDFInfo(_file.sourceFile);
      });
    },
    multifileInfo ({ multiFileKey, multiSignatoryKey }) {
      //*  23/05/15  如果存在 【 multiFileKey 】字段需要获取到合同文件信息再需要获取到 PDF文件数据
      //*  23/07/27  如果存在 【 multiSignatoryKey 】字段需要获取到合同文件的签署方信息
      this.loadingStart();
      ApiMethods.UserTagController.multiFileKeyFiles({
        multiFileKey: multiFileKey || null,
        multiSignatoryKey: multiSignatoryKey || null
      })
        .then(res => {
          if (res.success) {
            const { file, attach, signatorys, backUrl } = res.data;
            // 合同发起回调地址
            if (backUrl) this.contractBackUrl = backUrl;
            // 添加；回显签署方
            // if(signatorys) this.signatoryJson = signatorys
            if (signatorys && signatorys.constructor === Array) {
              signatorys.forEach((item, i) => {
                if (i > 0) {
                  // 默认有一个签署方需要将默认签署方排除
                  //固定签署方传个'api'区分api发起的，因为都要去设置AuthLevel这个值，api取返回的默认值，而模板发起是没有默认值的。防止模板没有默认值和api默认没值相冲突
                  this.addSignerListByUrl(item, 'api');
                } else {
                  const firstSign = this.signatoryJson[0],
                    { mobile, email, fullName, userType, identityCard, saasAuthLevel } = item;
                  firstSign.account = userType === 0 ? mobile : email;
                  firstSign.name = fullName;
                  firstSign.userType = userType;
                  firstSign.signatoryUserType = userType;
                  firstSign.identityNo = identityCard ? identityCard : "";
                  firstSign.disabled = "disabled";
                  firstSign.authLevel = saasAuthLevel || null;
                  firstSign.showNoticePhone = mobile || false;
                  firstSign.mobile = mobile || "";
                  this.isSaveDisable = false;
                }
              });
            }
            // 添加；回显文件
            file &&
              file.forEach((item, i) => {
                let sufixIndex = item.fileName.lastIndexOf(".");
                let file_name = item.fileName.slice(sufixIndex + 1);
                if (file_name === "pdf") {
                  let _file = {
                    fileName: item.fileName,
                    fileType: 1,
                    tempFile: item.tempFile || "",
                    items: item.items || "",
                    sort: null,
                    sourceFile: item,
                    fileOperVO: {
                      docHash: item.docHash || "",
                      extendsLocation: "",
                      fileName: item.fileName,
                      fileType: 3,
                      sign: item.sign,
                      targetId: item.targetId,
                      targetIdForPreview: "",
                      ts: item.ts
                    }
                  };
                  this.fileList.push(_file);
                } else {
                  console.log("添加回显item", item);
                  let fileInfo = { ...item };
                  fileInfo.fileName = item.fileName.slice(0, sufixIndex);
                  this.coverPDFInfo(fileInfo);
                }
              });
            attach &&
              attach.forEach((att, k) => {
                let attFile = {
                  fileName: att.fileName,
                  fileType: 2,
                  sort: k,
                  fileOperVO: {
                    ...att
                  }
                };
                this.enclosureFilesList.push(attFile);
              });
          } else {
            this.$message.error(res.description);
          }
        })
        .finally(() => {
          this.loadingClose();
        });
    },
    darfInfo ({ contractDraftId, contractName }) {
      //* 22/10/21 如果是合同起草页面发起，需要获取到PDF文件数据
      this.loadingStart();
      ApiMethods.AIDocSmart.draftApplySign({
        draftId: contractDraftId
      }).then(res => {
        if (res.success) {
          const { data } = res;
          this.coverPDFInfo({ fileName: contractName, ...data });
        } else {
          this.$message.error(res.description);
        }
      });
    },
    auditIdInfo (auditId) {
      //*  22/10/21  如果是合同审核页面过来发起.获取到合同文件信息再需要获取到PDF文件数据
      this.loadingStart();
      ApiMethods.AIDocSmart.auditApplySign({ auditId }).then(res => {
        if (res.success) {
          const { data } = res;
          this.coverPDFInfo({ fileName: data.fileName, ...data.ifileOperVO });
        } else {
          this.$message.error(res.description);
        }
      });
    },
    // 调用loading并获取原文件
    saveLoading (sourceFile, index) {
      const _this = this;
      _this.loadingStart();
      ApiMethods.onlyOfficeAPI.foreSave(sourceFile).then(res => {
        if (!res.success) return _this.$message.error("网络异常，请重试");
        setTimeout(() => {
          // this.loadingClose();
          _this.editedFile(sourceFile, index);
        }, 5 * 1000);
      });
    },
    // 获取office编辑后的文件
    editedFile (sourceFile, index) {
      ApiMethods.onlyOfficeAPI.officeFile(sourceFile).then(res => {
        if (!res.success) return this.$message.error("网络异常，请重试");
        this.officePDFInfo(res.data, index);
      });
    },
    // onlyoffice 编辑
    InOnlyOffice (file, index) {
      const sourFile = file.sourceFile;
      this.chapteJson = [];
      this.loadingStart();
      ApiMethods.onlyOfficeAPI
        .getOfficeConfig(sourFile)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          const { data } = res,
            { sourceFile } = file;
          this.editor = {
            editorConfig: Object.assign(
              { width: "100%", height: "100%" },
              data
            ),
            sourceFile,
            fileIndex: index
          };
          this.showofficeEditor = true;
        })
        .finally(() => {
          this.loadingClose();
        });
    },
    // 判断文件是否是doc类型
    beWord (fileName) {
      let filesuffix = "";
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      return filesuffix === "doc" || filesuffix === "docx";
    },
    // 固定签署方弹窗
    async regularlistPush (visi) {
      const tempList = this.fileList.filter(item => item.isTpl);
      const list = await this.mapList(tempList);
      await Promise.all(list).then(resList => {
        let signerList = [];
        resList.forEach(item => {
          // 取出模板设置的固定签署方
          if (item.context) {
            const { signers } = item.context;
            if (signers && signers.length > 0) {
              let list = signers.filter(signer => signer.name);
              signerList.push(...list);
            }
          }
        });
        // 获取固定签署方 赋值
        if (visi) this.regularVisi = true;
        this.regularList = signerList;
      });
    },
    // 查询详情
    getInfo (item) {
      return new Promise((reslove, reject) => {
        try {
          const tplAPI =
            item.tplVersion === 2
              ? this.templateAPI.multiTpl2
              : this.templateAPI.templateInfo;
          tplAPI({ tplIdSec: item.tplIdSec }).then(res => {
            if (!res.success) {
              this.$message.error(res.description);
              reslove({ success: res.success });
            }
            reslove(res.data);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    mapList (list) {
      return list.map(item => {
        return this.getInfo(item);
      });
    },
    // 签署方更多设置
    moreSettingUp (item, i) {
      this.setIndex = i;
      this.formInItem = Object.assign(this.formInItem, item);
      // this.formInItem.needRead = item.needRead;
      // 个人类型(signLevel 没有值时) 默认选中手写签字
      // if (![0, 1].includes(item.signLevel) && item.signatoryUserType === 0) {
      //   this.formInItem.signLevel = 1;
      // }
      this.signSetVisi = !this.signSetVisi;
    },
    // 签署方更多设置弹窗确认
    PupConfirm (form) {
      if(!form) return this.closeSetPup()
      let param = {...this.formInItem, ...form};
      if (param) {
        // if(!!param.readTime) param.needRead = true;
        this.$set(this.signatoryJson, this.setIndex, param);
      }
      this.closeSetPup();
    },
    // 关闭签署方更多设置弹窗
    closeSetPup () {
      this.setIndex = null;
      this.formInItem = {
        authLevel: null,
        needRead: false,
        readTime: null,
        faceOrVideo: false,
        userType: 1,
        extraHandSign: null, // 企业情况下，经办人签字
        signLevel: null // (图形章，手写签字)
      };
      this.signSetVisi = false;
      this.accessSetVisi = false;
      this.readPupVisi = false;
    },
    hostChange (signNum) {
      const signer = this.signerList.filter(item => item.signOwner === signNum);
      this.signatoryJson.forEach((item, i) => {
        item.signOwner === signNum
          ? this.$set(this.signatoryJson[i], "videoSignUserType", 2)
          : this.$set(this.signatoryJson[i], "videoSignUserType", 1);
      });
      signer.length > 0
        ? this.host.push({ ...signer[0] })
        : this.host.splice(this.host.length - 1);
    },
    // 发起页面 的上一步
    backStep () {
      const list = this.fileList;
      const haveTpl = list.some(elem => elem.isTpl);
      this.fileList = this.fileList.filter(item => !item.isTpl);
      if (haveTpl) {
        this.fileList = this.copyTemp.concat(this.fileList);
        this.setTempVariable = true;
      }
      // 过滤出为签署方伪造的数据;通过 forge 分辨
      // const realList = this.signatoryJson.filter(item => !item.forge);
      // this.chapteJson = this.chapteJson.filter(item => !item.forge);
      // this.signatoryJson = realList;
      this.nextstep = false;
    },
    // 替换掉模板文件
    replaceFiles (list) {
      const tplList = this.fileList.filter(item =>
        item.hasOwnProperty("tplName")
      );
      // 1. 先过滤出非模板文件
      const fileType = this.fileList.filter(item =>
        item.hasOwnProperty("fileName")
      );
      if (tplList.length > 0) this.copyTemp = tplList;
      this.fileList = [...new Set(list.concat(fileType))];
      this.chapteJson = this.chapteJson.filter(item => !item.isTpl);
      // 2.关闭模板设置变量页面，进入下一步
      this.setTempVariable = false;
      this.openSign();
    },
    // 选择的模板
    activeTplItem (tplList) {
      const fileArr = this.fileList.filter(item => !item.isTpl);
      this.fileList = [...tplList, ...fileArr];
      this.fileList.forEach((elem, i) => {
        if (elem.useTo && elem.useTo === 1) {
          this.officePDFInfo(elem.sourceFile, i);
        }
      });
      if (!this.contractInfo.contractName) {
        this.contractInfo.contractName = tplList[0].tplName ? tplList[0].tplName : '';
      }
      // 获取到选择模板中的固定签署方
      this.regularlistPush();
    },
    checkChange (event, item, i) {
      if(item.needRead){
        // 关闭
        this.$set(this.signatoryJson[i], "needRead", false);
        this.$set(this.signatoryJson[i], "readTime", null);
      }else{
        // 打开
        this.setIndex = i;
        this.formInItem=this.signatoryJson[i]
        this.readPupVisi = true;
      }
      // this.$set(this.signatoryJson[i], "needRead", event);
      // this.$set(this.signatoryJson[i], "readTime", event ? 5 : null);
    },
    videoPartIn (val, item) {
      item.faceOrVideo = val ? 1 : null;
      if (!val) {
        if (item.videoSignUserType == 2) this.host = [];
        item.videoSignUserType = "";
      }
    },
    attiatChange (e, item) {
      console.log("attiatChange", e, item);
      if (e != 1) {
        if (item.videoSignUserType == 2) this.host = [];
        item.videoSignUserType = "";
      }
    },
    disOption (item) {
      /** 视频签署情况下，
       * 四个视频参与方且 item.videoSignUserType!== 2， 视频通话选项禁用。
       */
      const json_arr = this.signatoryJson.filter(item => item.faceOrVideo == 1);
      return item.faceOrVideo != 1 && json_arr.length >= 4 ? true : false;
    },
    /** tabs标签切换钩子函数 */
    tabHandleBefore (val, old) {
      const video = this.signTypes[1];
      const haveNotInLand = this.signatoryJson.some(signator => signator.signatoryUserType == 2);
      if (val == video && haveNotInLand) {
        this.$message.warning("视频签暂不支持非中国内地个人签约方！");
        this.activeTabsName = this.signTypes[0]
        return false
      }
      return true
    },
    /** 点击tabsItem事件 */
    handleTabsClick (e) {
      let isDis = 0,
        video = this.signTypes[1];
      if (e.name === video && this.checkedBatch) {
        this.delSignList({ signOwner: "批量签署方" });
        this.checkedBatch = null;
      }
      this.signatoryJson.forEach(item => {
        if (e.name === video) {
          ++isDis;
          this.contractInfo.ifOrder = false;
        }
        item.faceOrVideo = e.name === video && isDis <= 4 ? 1 : "";
      });
    },
    /**
     * 禁用逻辑判断
     * @param item 行数据
     * @param type 2 host（视频主持人）
     */
    logicOfDisabled (
      { videoSignUserType: key, account, signOwner, faceOrVideo } = item,
      type
    ) {
      const _this = this;
      // 对比 host 中选择的是否与当前签署方是同一人，账号（account）相同 并且 签署方次不同 也返回true
      let HDis = _this.host.some(
        elem => elem.account === account && elem.signOwner !== signOwner
      );
      // 如果 有选中视频主持人，当前数据 key !=2（不是主持人）返回true
      // 如果没有选中主持人，当前数据认证类型（faceOrVideo）若不是参与通话 faceOrVideo != 1 就禁用
      let typeRes = {
        2: () =>
          _this.host.length == 1 ? key !== 2 : faceOrVideo != 1 ? true : false
      };
      return HDis || typeRes[type]();
    },
    /** 视频通话角色记录
     * @param val checkbox val
     * @param item 当前操作的签署方
     * @param type 1 参与视频通话 2 视频主持人
     */
    typeChange (val, item, type) {
      item.videoSignUserType = val ? type : "";
      val
        ? this.host.push({ ...item, type })
        : this.host.splice(this.host.length - 1);
    },
    /** 是否显示 */
    isShow (type, item) {
      if (type == "btn") {
        return this.activeTabsName == this.signTypes[1]
          ? false
          : item.isNoticePhone && !item.showNoticePhone;
      } else {
        return this.activeTabsName == this.signTypes[1]
          ? happy.email.test(item.account)
          : item.showNoticePhone;
      }
    },
    upTemplate () {
      if (this.fileList.length === 30) return this.$message.warning('最多只能上传30个文件')
      this.templateUpVisi = true;
      // * 原模板发起跳转到模板列表页面
      // 企业 $router.push({ path: "/console/template" });
      // 个人 $router.push({ path: "/tpl/general" });
      // const accountInfoVO = this.$store.getters.allAuthUser.accountInfoVO;
      // const userType = accountInfoVO && accountInfoVO.userType == 0; // 登录账户类型为个人
      // const path = userType ? "/tpl/general" : "/console/template";
      // changeLgAccount().finally(() => {
      //   this.$router.push({ path });
      // });
    },
    /**
     * 骑缝章勾选change 判断是骑缝章的值
     * @value 0 不要企业和个人骑缝章（两个都不打钩） personSign==0 && enterpriseSign==0 【NOTQIFENG】判断
     * @value 1 企业和个人都有骑缝章（两个都打钩）personSign==1 && enterpriseSign==1【ALLFLAG】判断
     * @value 2 企业打钩个人不打钩 personSign==0 && enterpriseSign==1【ENTFLAG】判断
     * @value 3 企业不打钩个人打钩 personSign==1 && enterpriseSign==0【PERFLAG】判断
     * */
    qifengChange (val) {
      const
        { personSign, enterpriseSign } = this.qiFengSign,
        NOT = [undefined, 'undefined', null, 'null', 0, '0'],
        // 辅助函数
        isInvalid = (value) => NOT.includes(value);
      const
        /** 不要企业和个人骑缝章 */
        NOTQIFENG = isInvalid(personSign) && isInvalid(enterpriseSign),
        /** 企业和个人都有骑缝章 */
        ALLFLAG = personSign == 1 && enterpriseSign == 1,
        /** 企业打钩个人不打钩 */
        ENTFLAG = isInvalid(personSign) && enterpriseSign == 1,
        /** 企业不打钩个人打钩 */
        PERFLAG = personSign == 1 && isInvalid(enterpriseSign);
      if (NOTQIFENG) this.contractInfo.needQifengSign = 0;
      if (ALLFLAG) this.contractInfo.needQifengSign = 1;
      if (ENTFLAG) this.contractInfo.needQifengSign = 2;
      if (PERFLAG) this.contractInfo.needQifengSign = 3;
    },
    fileIcon (file) {
      let filesuffix = "tpl",
        fileName = file.fileName;
      if (fileName) {
        let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
        let namelength = fileName.length; //取到文件名长度
        filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      }
      if (!file.isTpl) {
        switch (filesuffix) {
          case "pdf":
            return this.PDFImg;
          case "jpg":
            return this.JPGImg;
          case "doc":
          case "docx":
            return this.DOCImg;
          case "xls":
          case "xlsx":
            return this.XLSImg;
          case "tpl":
            return this.TPLImg;
          default:
            // wps
            return this.WPSImg;
        }
      } else {
        const fix = filesuffix === 'doc' || filesuffix === 'docx'
        return fix ? this.DOCImg : this.TPLImg
      }
    },
    // 附属材料打开与关闭
    openTab () {
      this.drawerShow = !this.drawerShow;
      this.fileImgShow = this.drawerShow ? false : true;
    },
    // 968需求
    guideSignApplyCancel () {
      localStorage.setItem("APPLY_GUIDE_SIGN", "guide");
      let refs = this.$refs;
      refs[this.guideSignStep].$el.setAttribute("style", "");
      refs.guideBox.setAttribute("style", "");
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.guideSignStep = null;
    },
    guideSignApply (step) {
      if (!step) return;
      // this.guideSignStep = this.$route.query.multiFileKey ? null : step;
      this.$nextTick(() => {
        let refs = this.$refs;
        let objSetp, stepRect;
        let guidBox = refs.guideBox;
        switch (step) {
          case "signStep1":
            refs.signStep2.$el.setAttribute("style", "");
            objSetp = refs[step] ? refs[step].$el : '';
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "signStep2":
            refs.signStep1.$el.setAttribute("style", "");
            document.getElementById("signStep3").setAttribute("style", "");
            objSetp = refs[step].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "signStep3":
            refs.signStep2.$el.setAttribute("style", "");
            document.getElementById("signStep4").setAttribute("style", "");
            objSetp = refs[step].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "signStep4":
            refs.signStep3.$el.setAttribute("style", "");
            document.getElementById("signStep5").setAttribute("style", "");
            objSetp = refs[step].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "signStep5":
            refs.signStep4.$el.setAttribute("style", "");
            objSetp = refs[step].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          default:
            this.guideSignApplyCancel();
            objSetp = null;
            step = null;
            break;
        }
        stepRect = objSetp ? objSetp.getBoundingClientRect() : '';
        // 解决 getBoundingClientRect x,y兼容性
        let top = document.documentElement.scrollTop;
        if (stepRect.x === undefined || stepRect.y === undefined)
          return (this.guideSignStep = null);
        //top:${stepRect.y + top }px //下面的样式，暂时写死看看
        guidBox.setAttribute(
          "style",
          `width:${stepRect.width + 10}px;height:${stepRect.height +
          5}px;left:${stepRect.x - 5}px;top:${stepRect.y + top - 2}px`
        );
        objSetp.setAttribute("style", "position:relative; z-index: 490;");
        window.scrollTo({
          top:
            stepRect.top + top > parseInt(this.windowHeight / 2)
              ? stepRect.top + top - stepRect.height
              : 0,
          behavior: "smooth"
        });
      });
    },
    // 判断是否设签章
    goNextStep () {
      if (this.signatoryJson.length === 0) {
        return this.$message.warning("请至少添加一个签署方");
      }
      let chapArr = this.signatoryJson.map(sign => {
        return sign.signatoryFullName || sign.signOwner;
      });
      this.chapteJson.forEach(chap => {
        chapArr.splice(chapArr.indexOf(chap.qsInfo || chap.signOwner), 1);
      });
      this.chap = chapArr;
      if (this.chap.length === 0) {
        // this.nextStep()
      } else {
        this.signDialog = true;
      }
    },
    guideApplyCancel () {
      localStorage.setItem("APPLY_GUIDE", "guide");
      let refs = this.$refs;
      refs[this.guideStep].$el.setAttribute("style", "");
      this.guideStep = null;
    },
    guideApply (step) {
      if (!step) return;
      this.guideStep = step;
      this.$nextTick(() => {
        let refs = this.$refs;
        let objSetp, stepRect;
        let guidBox = refs.guideBox;
        switch (step) {
          case "step1":
            objSetp = refs[step] ? refs[step].$el : undefined;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "step2":
            refs.step1.$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          case "step3":
            refs.step2.$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            if (!objSetp) {
              if (refs[step]) {
                refs[step].$el = document.getElementById(step);
              }
              objSetp = document.getElementById(step);
            }
            break;
          default:
            this.guideApplyCancel();
            objSetp = null;
            step = null;
            break;
        }
        stepRect = objSetp ? objSetp.getBoundingClientRect() : '';
        // 解决 getBoundingClientRect x,y兼容性
        let { x, y } = stepRect;
        if (x === undefined || y === undefined) return (this.guideStep = null);
        objSetp.setAttribute("style", "position:relative; z-index: 10000;");
        guidBox.setAttribute(
          "style",
          `width:${stepRect.width + 10}px;height:${stepRect.height +
          10}px;left:${x - 5}px;top:${y - 5}px;`
        );
      });
    },
    // 校验经办人签字
    checkForge () {
      const handle = this.newSignJson.filter(item => item.forge);
      const filterChapte = this.chapteJson.filter(cha => cha.forge);
      // 已设置经办人签章位置小于 经办人签章个数一定是没有设置
      return filterChapte.length < handle.length;
    },
    // 签章位置设置发起
    sendContractToCreateNow (status) {
      if (!this.checkSignerHasSignature()) {
        return this.$message.warning("每个签署方，至少设置 1 个签章位置!");
      } else if (!this.checkFilesHasSignature()) {
        return this.$message.warning("请确认每份文件至少设置有 1 个签署位置!");
      } else if (this.checkForge()) {
        const handle = this.newSignJson.filter(item => item.forge);
        const filterChapte = this.chapteJson.filter(cha => cha.forge);
        for (const hand of handle) {
          const have = filterChapte.some(
            FCha => FCha.signOwner === hand.signOwner
          );
          if (!have) {
            return this.$message.warning(
              `“${hand.name}”经办人签字位置未设置，至少需要设置一个签章位置`
            );
          }
        }
      } else {
        isInDingTalk
          ? this.sendWithDingTalk(status)
          : this.sendContractToCreate(status);
      }
    },
    // 通过applyId获取草稿箱合同信息
    async getDraftContractInfoByApplyId (applyId) {
      this.loadingStart();
      let isCorpDraft = !!this.$route.query.isCorp || false;
      let draftRes = {};
      try {
        if (isCorpDraft) {
          draftRes = await getMultipleCorpDraftInfoByApplyId(applyId);
        } else {
          draftRes = await getMultipleDraftInfoByApplyId(applyId);
        }
        this.loadingClose();
        let data = draftRes.data;
        // 判断属于哪个发起的草稿
        if (data.userId) {
          let index = this.totalAccountList.findIndex(
            val => val.userId === data.userId
          );
          let user = this.totalAccountList[index];
          setCurrentUser(user).finally(() => {
            this.$store.dispatch("setIgnoreChangePage", false);
            this.getUserJurisdiction();
          });
          this.accountNameTab = user.corpName || user.name || user.username;
        }
        if (data.corpId) {
          let index = this.totalAccountList.findIndex(
            val => val.corpId === data.corpId
          );
          let user = this.totalAccountList[index];
          setCurrentUser(user).finally(() => {
            this.$store.dispatch("setIgnoreChangePage", false);
            this.getUserJurisdiction();
          });
          this.accountNameTab = user.corpName || user.name || user.username;
        }
        this.contractInfo.contractName = data.contractName;
        this.contractInfo.applyIdSec = data.applyIdSec || "";
        this.contractInfo.serverCa = data.serverCa || 1;
        this.contractInfo.overDate = data.overDate || "";
        this.contractInfo.ifOrder = data.ifOrder;
        this.contractInfo.carbonCopy = data.carbonCopy;
        this.contractInfo.consumMode = data.consumMode || 0;
        this.contractInfo.needQifengSign = data.needQifengSign;
        this.contractInfo.needVideoSign = data.needVideoSign || 0;
        this.contractInfo.hideSignDate = data.hideSignDate;
        this.chapteJson = data.draftChapteJson;
        this.filesAndAttach({ files: data.files, draftType: data.draftType });
        this.handleBatchSigners(data.batchSigners);
        this.handleSigners(data.signers);
        let sign = {
          signOwner: "批量签署方",
          chapteJson: []
        };
        if (data.batchSigners.length > 0) {
          this.checkedBatch = 11; // 因为设置了watch监听。就不在这里 push 批量签署方
          if (data.ifOrder) {
            this.signatoryJson.splice(data.batchSignOrder - 1, 0, sign);
          }
          // else {
          //   this.signatoryJson.push(sign);
          // }
        }
      } catch (err) {
        this.loadingClose();
        console.error("查找合同信息  " + JSON.stringify(err));
        this.$message.warning(err.description || "没有找到合同信息");
      }
    },
    // 草稿箱文件和附件分离
    filesAndAttach ({ files, draftType }) {
      let filesList = files.filter(v => v.fileType === 1);
      let enclosureFilesList = files.filter(v => v.fileType === 2);
      // 文件排序
      filesList.sort((a, b) => {
        return a.sort - b.sort;
      });
      if (draftType === 1) {
        // 将源文件暴露出来
        filesList.forEach(file => {
          this.coverPDFInfo({ fileName: file.fileName, ...file.sourceFile });
        });
      } else {
        this.fileList = filesList;
      }
      this.enclosureFilesList = enclosureFilesList;
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo (param) {
      console.log("param", param);
      this.loadingStart("正在加载合同信息");
      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();
          this.contractInfoTemporary = {
            docHash: data.docHash,
            ts: param.ts,
            sign: param.sign,
            items: parseInt(data.items),
            targetId: param.targetId
          };
          this.fileImgName = param.fileName;
          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },
    // 正常签署方转换
    handleSigners (signOS) {
      this.signatoryJson = [];
      signOS.forEach((t, i) => {
        // 甲乙丙状态
        let signOwner = signerDataList[i].signOwner;
        signerDataList[i].ischecked = true;
        // 签署人
        let signatory = {
          account: t.account,
          authLevel: t.authLevel ? 11 : null,
          identityNo: t.identityType != 23 ? t.identityNo : '',
          signLevel: t.signLevel || null,
          userType: t.userType || 0,
          chapteJson: t.chapteJson || [],
          mobile: t.mobile || "",
          name: t.name || "",
          corpUser: t.corpUser || "",
          corpUserStatus: false,
          canSelectArray: [],
          canSelectArrayIndex: 0,
          signatoryUserType: t.userType || 0,
          ischange: 0,
          signOwner: signOwner,
          disabled: t.identityType === 23 ? 'disabled' : '',
          openUserTab: false,
          isEncrypt: false,
          isNoticePhone: false,
          showNoticePhone: false,
          idCardNoShow: false,
          extraHandSign: null, // 经办人签字
        };
        // 签署人状态判断
        if (t.identityNo) {
          signatory.disabled = "disabled";
          signatory.isEncrypt = true;
          signatory.ischange = 1;
        } else {
          signatory.disabled = "";
          signatory.isEncrypt = false;
          signatory.ischange = 0;
        }
        this.signatoryJson.push(signatory);
      });
    },
    // 批量签署方转换
    handleBatchSigners (signOS) {
      this.batchArray = [];
      signOS.forEach(t => {
        // 签署人
        let signatory = {
          account: t.account,
          authLevel: t.authLevel ? 11 : null,
          identityNo: t.identityNo,
          signLevel: t.signLevel || null,
          userType: t.userType || 0,
          chapteJson: t.chapteJson || [],
          name: t.name || "",
          canSelectArray: [],
          canSelectArrayIndex: 0,
          signatoryUserType: t.userType || 0,
          ischange: 0,
          disabled: "",
          openUserTab: false,
          isEncrypt: false
        };
        this.batchArray.push(signatory);
      });
    },
    // 903需求新增
    // 获取附件后缀
    getEnclosureSuffix (item) {
      if (item && item.fileOperVO && item.fileName) {
        let arr = item.fileName.split(".");
        return arr[arr.length - 1];
      }
      return "";
    },
    // 附件下载
    downloadAttatchFile (param) {
      if (!param || param === "null" || param === "false")
        return "javascript:void(0)";
      if (param.fileName === "blob") {
        param.fileName = "attachment.png";
        param.fix = ".png";
      }
      let VO = param.fileOperVO;
      const files = {
        fileName: param.fileName,
        fileSize: VO.fileSize,
        fileType: VO.fileType,
        sign: VO.sign,
        targetId: VO.targetId,
        ts: VO.ts
      };
      return getFindFileDownload(files);
    },
    // 附件是否是图片
    isImg (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      let arr = ["PNG", "GIF", "JPG", "JPEG"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否是视频
    isVideo (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['MP4','RMVB','MKV','AVI']
      let arr = ["MP4", "WEBM", "OGG"];
      // let arr = ['MP4']
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 附件是否文档
    isDoc (item) {
      let str = this.getEnclosureSuffix(item).toLocaleUpperCase();
      // let arr = ['DOCX','DOC','PDF','XLS','XLSX']
      let arr = ["PDF"];
      if (arr.indexOf(str) > -1) {
        return true;
      }
      return false;
    },
    // 预览图片或者视频
    previewVideOrImg (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosure = true;
      // 刷新预览弹窗，更新
      this.isRefresh = false;
      this.$nextTick(() => {
        this.isRefresh = true;
      });
    },
    // 执行预览图片视频关闭后参数回传
    onSetViewFilesToImgDialogData (data) {
      this.visibleShowEnclosure = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 预览文档
    previewDoc (item) {
      let files = {
        id: item.fileOperVO.targetId,
        file: {
          fileType: item.fileOperVO.fileType,
          sign: item.fileOperVO.sign,
          targetId: item.fileOperVO.targetId,
          ts: item.fileOperVO.ts,
          fileName: item.fileName
        }
      };
      this.enclosurePreviewNumItem = files;
      this.visibleShowEnclosureDoc = true;
    },
    // 执行预览PDF关闭后参数回传
    onSetViewFilesToDocDialogData (data) {
      this.visibleShowEnclosureDoc = data.visibleShow;
      this.enclosurePreviewNumItem = data.obj;
    },
    // 切换文件展示合同
    chooseFile (file, i) {
      const { fileOperVO: VO } = file;
      const fileVO = VO ? VO : file;
      if (this.checkAct === i) return;
      this.contractList = {};
      this.convertContractToInfo(fileVO);
      this.checkAct = i;
    },
    // 处理 模板文件
    handleTPL () {
      if (!this.signatoryJson.length) {
        return this.$message.warning('请添加签署方')
      }
      this.qifengChange()
      if (this.copyTemp.length > 0) {
        this.copyTemp = this.fileList.filter(item => item.isTpl);
      }
      this.openSign('showApproveToast');
      // 处理模板 end
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    // 发起时进入下一步前校验
    nextCheck () {
      if (this.fileList.length < 1)
        return this.$message.warning("请先上传需要签署的文件！");
      // 验证填写信息
      if (!this.signlinktime) return this.$message.warning("签署截止日期不能为空")
      if (
        this.activeTabsName === this.signTypes[1] &&
        !this.contractInfo.videoSignStartTime
      )
        return this.$message.warning("请选择开始时间");
      if (
        this.isGroup &&
        !this.checkedBatch &&
        this.hasApplyApproval === true
      ) {
        if (
          !isInDingTalk && this.approvalFlowList.length > 0 &&
          this.approvalFlowSelect === undefined
        ) {
          // saas环境
          return this.$message.error("请选择审批流程");
        }
      }
      if (this.checkedBatch) {
        if (this.batchArray.length === 0) {
          return this.$message.warning("请添加批量签署方");
        }
      }
      if (this.activeTabsName == this.signTypes[1]) {
        let haveVideo = this.signatoryJson.filter(
          item => item.faceOrVideo == 1
        );
        if (haveVideo.length < 2)
          return this.$message.warning("请至少选择两个视频通话参与方");
        // if (this.host.length == 0)
        if (!this.videoAnchor) return this.$message.warning("请选择视频主持人");
      }
      if (
        !this.contractInfo.contractName ||
        this.contractInfo.contractName === ""
      )
        return this.$message.warning("请输入主题名称");
      if (this.contractInfo.contractName.length > 100)
        return this.$message.warning("主题名称不能超过一百个字符");
      if (
        parseInt(this.contractInfo.needVideoSign) === 1 &&
        this.signatoryJson.length !== 2
      )
        return this.$message.error("视频签只允许有两个手动签署方");
      if (
        isInDingTalk && !this.checkedBatch &&
        this.flowType === this.flowTypes[0] &&
        this.flowSelect.length === 0
      )
        // 钉钉环境
        return this.$message.error("请选择审批流程");
      if (
        isInDingTalk &&
        this.flowType === this.flowTypes[1] &&
        this.flowSelect.length === 0
      ) {
        let nodes = [];
        this.menbers.forEach(item => {
          //  拿到每层的人列表
          const userList = item.menber;
          let userApproveUsers = [];
          userList.forEach(elem => {
            userApproveUsers.push({
              name: elem.name,
              userId: elem.emplId
            });
          });
          if (userApproveUsers.length > 0) nodes.push({ userApproveUsers });
        });
        // 这里 nodes 是 选择审批人用的判断
        if (nodes && nodes.length == 0)
          return this.$message.error("请选择审批人员");
      }
      this.contractInfo.newNeedVideoSign =
        this.activeTabsName == this.signTypes[1] ? 1 : 0;
      this.signatoryJson.forEach(item => {
        if (item.faceOrVideo == 1 && item.videoSignUserType != 2) {
          item.videoSignUserType = item.faceOrVideo;
        }
        // 将签署设置中的 个人图形章 推入每一个 个人签署方 signLevel 字段中
        if (item.signatoryUserType === 0 && !item.forge) {
          // 【signLevel】 个人图形章，签署方个人  0 ->图形章 1->手写章
          // 【personImgSign】 是否使用图形章 1 使用 0不使用
          item.signLevel = this.personImgSign ? 0 : 1;
        }
      });
      let validChild = true;
      let rulesTab = this.$refs.contractListTab;
      if (rulesTab) {
        rulesTab.forEach(t => {
          if (t.validate) {
            t.validate(() => { });
          }
        });
        try {
          rulesTab.forEach(t => {
            if (t.fields) {
              const fields = t.fields;
              if (fields) {
                fields.forEach(element => {
                  if (
                    element.prop !== "" &&
                    element.validateState === "error"
                  ) {
                    throw new Error("validFails");
                  }
                });
              }
            }
          });
        } catch (error) {
          validChild = false;
        }
      }
      // 验证批量签署方form表单列表
      let validChildBatch = true;
      let contractBatchListTab = this.$refs.contractBatchListTab;
      if (contractBatchListTab) {
        contractBatchListTab.forEach(t => {
          t.validate(() => { });
        });
        try {
          contractBatchListTab.forEach(t => {
            const fields = t.fields;
            if (fields) {
              fields.forEach(element => {
                if (element.prop !== "" && element.validateState === "error") {
                  throw new Error("validFails");
                }
              });
            }
          });
        } catch (error) {
          validChildBatch = false;
        }
      }
      if (!validChild || !validChildBatch)
        return this.$message.error("请检查签署方信息！");
    },
    // 设置签章位置
    openSign (type) {
      this.$refs.contForm.validate(async valid => {
        if (valid) {
          // 校验事件
          const checkedRes = await this.nextCheck();
          // checkedRes 为undefined || false 就往下执行。有结果就 return
          if (checkedRes) return false;
          //审批提示弹窗
          let uc = this.$store.getters.currentAuthUser.corpUserId;
          await this.openSignStepFn()
          // 24-03-12 此提示隐藏
          // if (type === 'showApproveToast' && uc && this.approvalFlowSelect) {
          //   let kk = '近期'
          //   this.$confirm(`<p style="color:#666666">
          //       合同发起时审批及合同盖章时审批功能将在${kk}转为付费功能，届时每发起一次审批流程需支付100积分，您也可购买包年套餐，感谢您对君子签的支持！
          //       <span style="color:#F56C6C"></span></p>`, '提示', {
          //     distinguishCancelAndClose: true,
          //     confirmButtonText: '关闭',
          //     cancelButtonText: '取消',
          //     dangerouslyUseHTMLString: true,
          //     showCancelButton: false
          //   }).then(() => {
          //     this.openSignStepFn();
          //   }).catch(() => { })
          // } else {
          //   await this.openSignStepFn();
          // }
        }
      });
    },
    async openSignStepFn () {
      const VO = this.fileList[0];
      const fileInfo = VO.fileOperVO ? VO.fileOperVO : VO;
      const hasTemp = this.fileList.some(item =>
        item.hasOwnProperty("tplName")
      );
      if (hasTemp) {
        this.setTempVariable = true;
        return false;
      }
      await this.HandlingSet();
      this.currentInfo = { page: 1, url: "" };
      this.contractList = {};
      this.convertContractToInfo(fileInfo);
      this.checkAct = 0;
      this.nextstep = true;
      // 设置骑缝章位置 start
      const { personSign, enterpriseSign } = this.qiFengSign
      // 除去经办人
      this.qifengChapList = JSON.parse(JSON.stringify(this.newSignJson)).filter((qifeng, i) => !qifeng.forge)
      // userType string 用户类型 0个人 1企业
      if (!personSign && !enterpriseSign) this.qifengChapList = []
      if (personSign && !enterpriseSign) this.qifengChapList = this.qifengChapList.filter((qifeng, i) => qifeng.userType === 0)
      if (!personSign && enterpriseSign) this.qifengChapList = this.qifengChapList.filter((qifeng, i) => qifeng.userType === 1)
      this.qifengChapList.forEach((item, i) => {
        const molecule = i + 1, len = this.qifengChapList.length;
        // 假设A4纸的高度
        const paperWidth = 1; // in mm
        // 计算每个章的间隔
        const interval = 1 / (len + 1); // 加 1 是因为我们需要在章之间有间隔
        // 计算每个章的位置
        // 使用等差数列的原理计算位置
        const position = molecule * interval;
        // 将百分比位置转换为相对于纸张具体位置
        item.offsetY = parseFloat(position * paperWidth).toFixed(4);
        item.cindex = molecule
      })
      // this.$nextTick(()=>{
      //   this.$refs.contractView.qifengMounted()
      // })
      // 设置骑缝章位置 end
      let applyGuide = localStorage.getItem("APPLY_GUIDE");
      if (
        ![null, "null", undefined, "undefined", ""].includes(applyGuide) &&
        applyGuide !== "guide"
      ) {
        this.$nextTick(() => {
          this.guideApply("step1");
        });
      }
    },
    /**
     * 创建实际签章列表（经办人签字需要生成一个章）
     */
    HandlingSet () {
      // 遍历签署方。如果签署方设置了经办人签字就伪造一个个人类型的签字章
      let newJson = [];
      this.signatoryJson.forEach(item => {
        newJson.push(item);
        // 项目中成员账号不支持手写签字，入口隐藏。项目支持后放开，原逻辑不变
        // item.extraHandSign === 1 需要经办人签字
        if (item.extraHandSign === 1) {
          let itemJson = JSON.parse(JSON.stringify(item));
          itemJson.forge = 1; // forge 辅助变量 标记这是经办人签字用的章
          itemJson.signatoryUserType = 0;
          newJson.push(itemJson);
        }
      });
      this.newSignJson = newJson;
    },
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".list-pages .listDetail")[val - 1];
      if (dom) {
        document.querySelectorAll(".list-pages")[0].scrollTop = dom.offsetTop;
      }
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    // 按页数获取合同
    getContractDetailByNum (num) {
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }
      this.currentInfo = {
        page: num,
        url: convertDetailToShow({
          docHash: this.contractInfoTemporary.docHash,
          ts: this.contractInfoTemporary.ts,
          sign: this.contractInfoTemporary.sign,
          items: this.contractInfoTemporary.items,
          targetId: this.contractInfoTemporary.targetId,
          fileType: 3,
          fix: "png",
          num: num - 1
        })
      };
      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    changeSmallMap (val) {
      this.deviationSmallMap = val;
    },
    // 获取当前主体下的一些权限操作
    // 删除签署方
    delSignList: function (sign) {
      if (sign.signOwner === "批量签署方") {
        if (this.batchArray.length > 0) {
          this.$confirm("数据将被清空，确定删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              this.batchArray = [];
              this.checkedBatch = null;
              let index = this.chapteJson.findIndex(
                s => s.signOwner === "批量签署方"
              );
              if (index !== -1) this.chapteJson.splice(index, 1);
              let importBatchFile = this.$refs["importBatchFile"];
              if (importBatchFile) {
                importBatchFile.value = "";
              }
              for (let i = 0; i < signerDataList.length; i++) {
                if (signerDataList[i].signOwner === sign.signOwner) {
                  signerDataList[i].ischecked = false;
                }
              }
              this.signatoryJson = this.signatoryJson.filter(
                t => t.signOwner !== sign.signOwner
              );
            })
            .catch(err => {
              this.checkedBatch = 11;
              console.warn(err);
            });
        } else {
          this.batchArray = [];
          this.checkedBatch = null;
          let index = this.chapteJson.findIndex(
            s => s.signOwner === "批量签署方"
          );
          if (index !== -1) this.chapteJson.splice(index, 1);
          let importBatchFile = this.$refs["importBatchFile"];
          if (importBatchFile) {
            importBatchFile.value = "";
          }
          for (let i = 0; i < signerDataList.length; i++) {
            if (signerDataList[i].signOwner === sign.signOwner) {
              signerDataList[i].ischecked = false;
            }
          }
          this.signatoryJson = this.signatoryJson.filter(
            t => t.signOwner !== sign.signOwner
          );
        }
      } else {
        // 如果是视频签署，需要判断是否有选择视频签署角色
        if (
          this.activeTabsName == this.signTypes[1] &&
          sign.videoSignUserType == 1
        )
          this.host.splice(this.host.length - 1);
        let index = this.chapteJson.findIndex(
          s => s.signOwner === sign.signOwner
        );
        if (index !== -1) this.chapteJson.splice(index, 1);
        // 查找是否有经办人签字而伪造的数据
        let forgeIndex = this.chapteJson.findIndex(
          s => s.signOwner === sign.signOwner && s.forge === 1
        );
        if (forgeIndex !== -1) this.chapteJson.splice(forgeIndex, 1);
        for (let i = 0; i < signerDataList.length; i++) {
          if (signerDataList[i].signOwner === sign.signOwner) {
            signerDataList[i].ischecked = false;
          }
        }
        this.signatoryJson = this.signatoryJson.filter(
          t => t.signOwner !== sign.signOwner
        );
      }
    },
    // 添加签署方
    async addSignerList () {
      if (this.signatoryJson.length === 10) {
        return this.$message.warning("最多不能超过10个签署方");
      }
      let videos = this.signatoryJson.filter(item => item.faceOrVideo == 1);
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].ischecked === false) {
          this.signatoryJson.push({
            faceOrVideo:
              this.activeTabsName == this.signTypes[1] && videos.length < 4
                ? 1
                : "",
            signOwner: signerDataList[i].signOwner,
            account: "",
            name: "",
            signatoryUserType: 0,
            authLevel: 11, //又改回11    2012-12
            userType: 0,
            readTime: null,
            corpUserStatus: false,
            chapteJson: [],
            videoSignUserType: "", // 视频签署，签署方类型，1: 参与者，2: 主持者
            // 新增集团账户 数组
            canSelectArray: [],
            canSelectArrayIndex: 0,
            signLevel: null,
            identityNo: "",
            ischange: 0,
            disabled: "",
            openUserTab: false,
            isEncrypt: false,
            isNoticePhone: false,
            showNoticePhone: false,
            idCardNoShow: false,
            mobile: "",
            extraHandSign: null, // 经办人签字
          });
          console.log("this.signatoryJson", this.signatoryJson);
          return (signerDataList[i].ischecked = true);
        }
      }
    },
    // 通过url字段参数添加签署方
    addSignerListByUrl (item, isApi) {
      if (this.signatoryJson.length === 10) {
        return this.$message.warning("最多不能超过10个签署方");
      }
      const {
        fullName,
        identityCard,
        identityType,
        mobile,
        email,
        userType,
        saasAuthLevel,
      } = item;
      let videos = this.signatoryJson.filter(item => item.faceOrVideo == 1);
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].ischecked === false) {
          this.signatoryJson.push({
            faceOrVideo:
              this.activeTabsName == this.signTypes[1] && videos.length < 4
                ? 1
                : "",
            signOwner: signerDataList[i].signOwner,
            // account: mobile ? mobile : email, //这里和第一个签约方的取值条件不一样，不知道为啥，改成下面那种一样的
            account: userType === 0 ? mobile : email,
            name: fullName,
            userType: userType,
            signatoryUserType: userType,
            //authLevel: 11,  873 需求修改，此前默认人脸认证 ，此后取消这个逻辑
            authLevel: isApi ? (saasAuthLevel || null) : item.userType === 0 ? 11 : null, //又改回11    2012-12
            readTime: null,
            corpUserStatus: false,
            chapteJson: [],
            videoSignUserType: "", // 视频签署，签署方类型，1: 参与者，2: 主持者
            // 新增集团账户 数组
            canSelectArray: [],
            canSelectArrayIndex: 0,
            signLevel: null,
            identityNo: identityCard ? identityCard : "",
            ischange: 0,
            disabled: identityCard ? "disabled" : "",
            openUserTab: false,
            isEncrypt: false,
            isNoticePhone: false,
            showNoticePhone: mobile || false,
            idCardNoShow: false,
            mobile: mobile || "",
            identityType,
            extraHandSign: null, // 经办人签字
          });
          // console.log("this.signatoryJson", this.signatoryJson);
          return (signerDataList[i].ischecked = true);
        }
      }
    },
    // 模板中选择固定签署方添加签署方
    regularAdd (list) {
      list.forEach((item, i) => {
        const signner = {
          fullName: item.name,
          identityCard: item.userType === 0 ? item.identityNo : null,
          mobile: item.userType === 0 ? item.emailOrMobile : null,
          email: item.userType === 1 ? item.emailOrMobile : null,
          userType: item.userType
        };
        const needPush = this.signatoryJson.some(
          sign => sign.account === item.emailOrMobile
        );
        //固定签署方传个'template'区分api发起的，因为都要去设置AuthLevel这个值，api取返回的默认值，而模板发起是没有默认值的。防止模板没有默认值和api默认没值相冲突
        !needPush && this.addSignerListByUrl(signner, 'template');
      });
    },
    draggingMove (evt, originalEvent) {
      console.log(originalEvent); //鼠标位置
    },
    getUserJurisdiction () {
      let v = this.$store.getters.currentAuthUser;
      if (v && v.corpUserId) {
        this.isGroup = true;
        this.activeTabOrganizationName = v.corpName;
        this.accountNameTab = v.corpName;
        // 集团账户情况下，需判断当前账户所在部门是否设置了审批流
        this.approvalFlowSelect = undefined;
        this.approvalFlowList = [];
        this.flows = [];
        this.arrayCopior = [];
        this.hasApprovalFlow();
        this.getChapterList()
        // if (this.isGroup) {
        //   this.getDepartmentList();
        // }
      } else {
        this.isGroup = false;
        this.hasApplyApproval = false;
        this.activeTabOrganizationName = "我的组织";
        this.accountNameTab = v.name;
        this.department = [];
        this.approvalFlowSelect = undefined;
        this.approvalFlowList = [];
        this.flows = [];
        this.arrayCopior = [];
      }
    },
    // 显示全部用户
    showMoreUser () {
      this.showAllUser = !this.showAllUser;
    },
    codeAccount (user) {
      console.log("user", user);
      if (this.showAllUser) {
        this.showAllUser = false;
      }
      setCurrentUser(user).finally(() => {
        this.$store.dispatch("setIgnoreChangePage", false);
        this.getUserJurisdiction();
      });
      this.accountNameTab = user.corpName || user.name || user.username;
    },
    //默认选中（企业第一个）
    chooseEnterpriseFn (user) {
      if (!user) {
        return false;
      }
      //当有缓存的时候是不需要设置默认的， 切换的时候也不需要设置默认
      if (!this.$store.getters.currentAuthUser.corpUserId && !this.enterpriseTabChange) {
        setCurrentUser(user).finally(() => {
          this.$store.dispatch("setIgnoreChangePage", false);
          this.getUserJurisdiction();
        });
        this.accountNameTab = user.corpName || user.name || user.username;
      }
    },
    changeAccount (user, e) {
      // console.log('user',user);
      // console.log('currentUser',this.currentUser);
      if (this.currentUser.corpUserId === user.corpUserId) return false
      this.enterpriseTabChange = true;
      const tab = this.$refs.tab;
      const tabitem = this.$refs.tabitem;
      const winWidth = window.innerWidth;
      const liList = e.target;
      if (user.corpName && this.$store.getters.authUser.identityAuth === -1) {
        this.authDialog = true;
        return;
      }
      this.$confirm("确定要切换至其它发起主体吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (liList) {
            const liLeft = liList.offsetLeft;
            const liWidth = liList.offsetWidth;
            const liCenter = (winWidth - liWidth) / 2;
            const liTarget = liLeft - liCenter;
            const ulWidth = tabitem.offsetWidth;
            if (this.showAllUser) {
              this.showAllUser = false;
            }
            setCurrentUser(user).finally(() => {
              this.$store.dispatch("setIgnoreChangePage", false);
              this.getUserJurisdiction();
            });
            this.accountNameTab = user.corpName || user.name || user.username;
            if (liTarget < 0) {
              tab.scrollLeft = 0;
              return;
            }
            if (liTarget < winWidth - ulWidth) {
              tab.scrollLeft = -(winWidth - ulWidth) + liWidth;
              return;
            }
            tab.scrollLeft = liTarget;
          }
        })
        .catch(err => err);
    },
    // 获取文件后缀
    fileSuffix (fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },
    fileOnError (err) {
      console.log(err);
      this.loadingClose();
    },
    fileOnSuccess () {
      // this.loadingClose()
    },
    // 选取文件超过数量提示
    fileHandleExceed (files, fileList) {
      let num = files.length + fileList.length;
      if (num > 30) {
        return this.$message.error(
          `最多只能上传30个文件`
          // `当前限制选择 30 个文件，本次选择了 ${files.length} 个文件，共选择了 ${num} 个文件`
        );
      }
    },
    // 新增多文件上传
    fileOnBeforeUpload (file) {
      const
        /** 文件限制大小 */
        fileSize = 60,
        /** 文件个数限制 */
        fileNum = 30;
      if (this.fileList.length >= fileNum) {
        return this.$message.error("当前可上传的文件不能超过30个！");
      }
      const re = new RegExp("(.doc|.docx)$", "i");
      const SuitableSize = file.size / 1024 / 1024 < fileSize;
      if (!re.test(file.name)) {
        return this.$message.error(
          "文件格式只能是doc/docx的文件"
        );
      }
      if (!SuitableSize) {
        return this.$message.error(`上传文件大小不能超过 ${fileSize}M!`);
      }
      this.loadingStart("文件上传中~");
      uploadFileAndConvertInfo({
        file: file,
        fileType: 1,
        fileName: file.name,
        saveSourceFile: 1
      })
        .then(data => {
          const resInfo = {
            fileName: data.fileName,
            sourceFile: data.sourceFile,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: data.fileName,
              fileSize: data.file.size,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            },
            tempFile: data.tempFile,
            fileType: 1,
            items: data.items,
            sort: null
          };
          console.log("resInfo", resInfo);
          this.fileList.push(resInfo);
          if (
            this.contractInfo.contractName === "" &&
            this.fileList[0].fileName
          ) {
            let str = this.fileList[0].fileName;
            let index = str.lastIndexOf(".");
            str = str.substring(0, index);
            this.contractInfo.contractName = str;
          }
          this.loadingClose();
        })
        .catch(err => {
          console.log("err", err);
          this.loadingClose();
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 新增附件文件上传
    enclosureFilesBeforeUpload (file) {
      // console.log("this.enclosureFilesList", this.enclosureFilesList);
      if (this.enclosureFilesList.length >= 30) {
        return this.$message.error("当前可上传的文件不能超过30个！");
      }
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isLt20M) {
        return this.$message.error("上传文件大小不能超过 20M!");
      }
      this.loadingStart("文件上传中~");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          const resInfo = {
            fileName: data.file.name,
            fileOperVO: {
              fileName: data.file.name,
              fileSize: data.file.size,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              ts: data.tempFile.ts
            },
            tempFile: data.tempFile,
            fileType: 2,
            sort: 0
          };
          this.enclosureFilesList.push(resInfo);
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    enclosureFilesError (err) {
      console.log(err);
      this.loadingClose();
    },
    enclosureFilesHandleExceed (files, fileList) {
      return this.$message.error(
        `当前限制选择 30 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 删除已上传的附件
    delEnclosureFiles (index) {
      console.log("删除已上传的附件", this.enclosureFilesList);
      this.enclosureFilesList &&
        this.enclosureFilesList.length &&
        this.enclosureFilesList.splice(index, 1);
    },
    // 删除已上传的文件
    removeFile (index, file) {
      this.fileList.splice(index, 1);
      if (this.chapteJson.length > 0) {
        this.chapteJson.forEach((c, i) => {
          if (c.targetId === file.fileOperVO.targetId) {
            delete this.chapteJson[i];
          }
        });
        this.chapteJson = this.chapteJson.filter(x => x !== undefined);
      }
      if (this.fileList.length) {
        this.contractInfo.contractName = this.fileList[0].fileName;
      } else {
        this.contractInfo.contractName = '';
      }
    },
    // 903需求结束
    //获取系统时间，并默认签署链接失效时间为三天后
    getAndSetTime () {
      ApiMethods.SysController.getDate().then(res => {
        if (res.success) {
          let a = res.data;
          a = a.substr(0, a.lastIndexOf(":"));
          a = a.replace(/\-/g, "/");
          let three = new Date(a).getTime() + 3 * 24 * 60 * 60 * 1000;
          let ft = moment(new Date(three)).format("YYYY-MM-DD");
          this.signlinktime = ft;
        }
      });
    },

    pickTime (val) {
      if (val) {
        let a = moment(val).format("YYYY-MM-DD");
        this.signlinktime = a;
      }
    },

    // 判断集团账户是否有审批流
    hasApprovalFlow () {
      // 查询发起审批流
      let params = {};
      params.itemPage = 1;
      params.pageSize = 100;
      params.flowType = 0; // 流程类型 0审批流程 1用章流程
      ApiCorpMethods.CorpAuditContractController.pageFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.approvalFlowList = res.data;
            if (this.approvalFlowList.length > 0) {
              this.hasApplyApproval = true;
            } else {
              this.hasApplyApproval = false;
            }
          } else {
            this.hasApplyApproval = false;
            this.$message.error(res.description || "查询审批流程数据失败");
          }
        })
        .catch(error => {
          this.hasApplyApproval = false;
          this.$message.error(error.description || "查询审批流程数据失败");
        });
    },

    handleChangeApprovalFlow (val) {
      let params = {};
      params.flowId = val;
      ApiCorpMethods.CorpAuditContractController.preFlowInst(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              // flow
              if (data.partyList) {
                this.flows = data.partyList;
              } else {
                this.flows = [];
              }
              this.arrayCopior = [];
              if (data.copyToList) {
                (data.copyToList || []).forEach(i => {
                  i.hideRemove = true;
                  this.arrayCopior.push(i);
                });
              }
              if (data.orderFlag === 1) {
                this.flows.forEach((element, index) => {
                  if (this.flows.length - 1 !== index) {
                    element.hiddenArrow = true;
                  } else {
                    element.hiddenArrow = false;
                  }
                });
              } else {
                this.flows.forEach((element, index) => {
                  element.hiddenArrow = false;
                });
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 限制签章个数30个
    limitSignCount (signOwner) {
      let v = 0;
      for (let index = 0; index < this.chapteJson.length; index++) {
        const element = this.chapteJson[index];
        if (element.signOwner === signOwner) {
          v++;
        }
      }
      return v;
    },
    dragQZStart (ev) {
      console.log("drag Start");
    },
    /**
     * 20200521新增拖动功能需求
     * 添加签章-拖动
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    dragQZEnd (ev, signOwner, index) {
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector(".cont-box").getBoundingClientRect();
      // let widX = signOwner.userType ? 178 : 100;
      // let heiX = signOwner.userType ? 170 : 80;
      let widX = signOwner.userType ? 208 : 115;
      let heiX = signOwner.userType ? 230 : 101;
      let caechetW = this.$refs["contractView"].scaleToVal(widX); // 签章宽高-签章更改这里也需要更改
      let caechetH = this.$refs["contractView"].scaleToVal(heiX); // 签章宽高-签章更改这里也需要更改
      let delBtnHeight = 7; // 删除按钮超出部分高度-签章更改这里也需要更改
      let sx = ev.pageX || ev.screenX;
      // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
      let sy =
        ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight);
      let left = sx - contBoxLeft - caechetW / 2; // 鼠标距离合同左侧距离-二分之一签章宽度
      let top = sy - contBoxTop + caechetH / 2; // 鼠标距离合同顶部距离+二分之一签章高度
      let boundaryValue = this.$refs["contractView"].scaleToVal(35); // 合同的最小边界值
      // 获取合同id
      // 当前文件targetId
      const targetId = this.contractInfoTemporary.targetId;
      if (top < 120) {
        top = 111 + boundaryValue;
      }
      if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }

      if (left < boundaryValue) {
        left = boundaryValue;
      }
      if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // 获取合同图片的宽高 （用于计算距离的比例）
      // let imgBox = document.querySelector('.cont-box>img');
      // let imgWidth = imgBox.naturalWidth || imgBox.width;
      // let imgHeight = imgBox.naturalHeight || imgBox.height;
      let imgWidth = this.deviationSmallMap.width;
      let imgHeight = this.deviationSmallMap.height;

      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner.signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let v = this.limitSignCount(signOwner.signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }
          left = this.$refs["contractView"].scaleToShow(left);
          top = this.$refs["contractView"].scaleToShow(top);
          caechetW = this.$refs["contractView"].scaleToShow(caechetW);
          caechetH = this.$refs["contractView"].scaleToShow(caechetH);
          let chapte = {
            targetId: targetId,
            offsetX: parseFloat((left / imgWidth).toFixed(4)), // 统一使用真实值计算
            offsetY: parseFloat((top / imgHeight).toFixed(4)),
            cindex: len,
            signOwner: signOwner.signOwner,
            qsInfo: signOwner.name, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
            url: url,
            page: this.currentInfo.page - 1,
            imageHeight: caechetH,
            signatoryUserType: signOwner.signatoryUserType,
            userType: signOwner.userType,
            isTpl: this.fileList[this.checkAct].isTpl ? true : false
          };
          if (signOwner.forge) {
            chapte.forge = signOwner.forge;
            chapte.sealLevel = 2;
          }
          this.chapteJson.push(chapte);
          console.log("添加签章成功：", this.chapteJson, 6666);
          return this.listChapteJsonCindex();
        }
      }
    },

    /** 添加签章
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    handleAddChapter (signOwner, index) {
      // 当前文件targetId
      const targetId = this.contractInfoTemporary.targetId;
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner.signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let userType = signOwner.userType;
          let v = this.limitSignCount(signOwner.signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }
          this.computeSignImageSize(url, image => {
            let {
              x,
              y,
              imageHeight,
              isNotPy
            } = this.computeClientCenterPosition(image, userType);
            let chapte = {
              // offsetX: !isNotPy? x + 0.03 * this.chapteJson.length : x, // 合同放大不偏移
              // offsetY: !isNotPy? y + 0.03 * this.chapteJson.length : y, // 合同放大不偏移
              offsetX: x + 0.03 * this.chapteJson.length, // 合同放大不偏移
              offsetY: y + 0.03 * this.chapteJson.length, // 合同放大不偏移
              cindex: len,
              signOwner: signOwner.signOwner,
              qsInfo: signOwner.name, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
              url: url,
              page: this.currentInfo.page - 1,
              imageHeight: imageHeight,
              signatoryUserType: signOwner.signatoryUserType,
              targetId: targetId,
              userType: userType,
              isTpl: this.fileList[this.checkAct].isTpl ? true : false
            };
            if (signOwner.forge) {
              chapte.forge = signOwner.forge;
              chapte.sealLevel = 2;
            }
            this.chapteJson.push(chapte);
            console.log("添加签章成功：", this.chapteJson, 7777);
            return this.listChapteJsonCindex();
          });
        }
      }
    },
    // 获取签章图片宽高
    computeSignImageSize (url, callback) {
      let image = new Image();
      image.src = url;
      image.onload = () => {
        callback(image);
      };
    },
    // 计算可视区中心位置
    computeClientCenterPosition (image, userType) {
      let imageWidth = 0,
        imageHeight = 0;
      if (image) {
        if (userType) {
          imageWidth = 178; // 改版后的章
          imageHeight = 170; // 改版后的章
        } else {
          // imageWidth = image.width || image.clientWidth || image.naturalWidth; // 之前的章
          // imageHeight = image.height || image.clientHeight || image.naturalHeight; // 之前的章
          imageWidth = 100; // 改版后的章
          imageHeight = 80; // 改版后的章
        }
        /*********
         *
         *
         *         // imageWidth = image.width || image.clientWidth || image.naturalWidth; // 之前的章
         // imageHeight = image.height || image.clientHeight || image.naturalHeight; // 之前的章
         imageWidth = 178; // 改版后的章
         imageHeight = 170; // 改版后的章
         * 此处是以前的就逻辑，最初是 110 * 110
         * 暂时更改未178 * 170看看效果
         *
         *
         * ***********/
      }
      // 可视区宽高
      // 加入缩放因子计算
      let fx;
      let fy;
      let isNotPy = false;
      let scaleToShow = this.$refs["contractView"].scaleToShow;
      let scaleToVal = this.$refs["contractView"].scaleToVal;
      let domView = this.$refs["contractView"].$el;
      // console.log(this.deviationSmallMap,[domView])
      if (scaleToVal(this.deviationSmallMap.width) <= domView.clientWidth) {
        // 能显示完全时
        let left = (this.deviationSmallMap.clientWidth - imageWidth) / 2;
        let top = (this.deviationSmallMap.clientHeight - imageHeight) / 2;
        fx = this.deviationSmallMap.left + left;
        fy = this.deviationSmallMap.top + top + imageHeight;
      } else {
        // 不显示完全时
        isNotPy = true; // 放大时不偏移，不然找不到位置
        let marinLeft = 0; // 左侧间隙值
        if (domView.clientWidth > this.deviationSmallMap.width) {
          marinLeft = domView.clientWidth - this.deviationSmallMap.width;
        }
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollLeft =
          domView.scrollLeft +
          (domView.clientWidth - scaleToVal(imageWidth)) / 2 -
          scaleToVal(marinLeft / 2);
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollTop =
          domView.scrollTop +
          (domView.clientHeight - scaleToVal(imageHeight)) / 2;

        fx = scrollLeft; // 缩放后的值
        fy = scrollTop + scaleToVal(imageHeight); // 缩放后的值
        fx = scaleToShow(fx); // 真实值
        fy = scaleToShow(fy); // 真实值
      }

      return {
        x: parseFloat((fx / this.deviationSmallMap.width).toFixed(2)),
        y: parseFloat((fy / this.deviationSmallMap.height).toFixed(2)),
        imageHeight: imageHeight,
        isNotPy // 新增变量，是否在原有位置偏移（只有合同放大时才不偏移）
      };
    },
    // 批量签署方 修改签署人类型
    handleSignBatchUserType (signator, index) {
      signator.account = "";
      signator.name = "";
      signator.identityNo = "";
      this.getBatchUserInfoBySelectTargetId(signator.account, index);
    },
    changBatchUserShowNoticePhone (selectIndex) {
      let _showNoticePhone = !this.batchArray[selectIndex].showNoticePhone;
      let text = _showNoticePhone ? "添加" : "删除";
      this.$message(`${text}通知手机号`);
      this.$set(
        this.batchArray[selectIndex],
        `showNoticePhone`,
        _showNoticePhone
      );
      this.$set(this.batchArray[selectIndex], `mobile`, null);
    },
    // 批量签署方根据用户从table选择的签署人查询信息
    getBatchUserInfoBySelectTargetId (account, selectIndex) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }
      // 清空验证信息
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }
      if (account) {
        this.tableSignorSelectRowTargetID = account;
      }
      if (!account || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        postFindByEmailOrMphon({ targetId }).then(data => {
          if (data.data) {
            this.fillBatchSignorData(data.data);
          } else {
            this.fillBatchSignorData([]);
          }
        });
      } else {
        this.fillBatchSignorData([]);
      }
    },
    // 查询到结果后重新赋值
    fillBatchSignorData (canSelectArray) {
      let signor = undefined;
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });
      signor.errorMsg = "";
      this.$set(this.batchArray[this.selectIndex], `errorMsg`, "");
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractBatchListTab"][this.selectIndex].validateField(
            "account"
          );
        });
      }
      if (canSelectArray.length === 0) {
        signor.name = "";
        signor.identityNo = "";

        signor.ischange = 0;
        signor.disabled = "";
        signor.userType = signor.signatoryUserType;
        signor.identityType = null;

        if (happy.email.test(signor.account)) {
          signor.isNoticePhone = true;
          if (signor.mobile) {
            signor.showNoticePhone = true;
          } else {
            signor.showNoticePhone = false;
          }
        } else {
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.mobile = "";
        }
      } else {
        let isEmptySignor = false;
        if (signor.signatoryUserType === 1) {
          canSelectArray = canSelectArray.filter(item => item.userType === 1);
          if (
            happy.mobile.test(signor.account) &&
            canSelectArray.length === 0
          ) {
            isEmptySignor = true;
            signor.showNoticePhone = false;
            signor.mobile = "";
            signor.identityType = null;
          }
          if (happy.email.test(signor.account)) {
            signor.isNoticePhone = true;
            if (signor.mobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
            signor.identityType = null;
          }
        } else {
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.mobile = "";
          signor.identityType = null;
          canSelectArray = canSelectArray.filter(item => item.userType === 0);
          if (canSelectArray.length === 0) {
            isEmptySignor = true;
          }
        }
        if (isEmptySignor) {
          signor.name = "";
          signor.identityNo = "";

          signor.ischange = 0;
          signor.disabled = "";
          signor.userType = signor.signatoryUserType;
          signor.identityType = null;
        } else {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              signor.canSelectArrayIndex = index;
              signor.corpUserStatus = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.name = v.name;
          signor.identityNo =
            v.userType === 0 ? v.identityCard : v.businessLicense;

          signor.ischange = signor.identityNo ? 1 : 0;
          signor.disabled = signor.identityNo ? "disabled" : '';
          signor.userType = v.userType;
          signor.identityType = v.cardType || null;
          signor.corpUser = v.corpUser
          signor.corpUserStatus = !!v.corpUser
          // signor.
          // if (signor.corpUserStatus) {
          //   signor.userType = 0;
          // } else {
          //   signor.userType = v.userType;
          // }
        }
      }
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
          console.log("signor", signor);
          // this.$set(this.batchArray[this.selectIndex], `errorMsg`, "");
        }
      });
      this.getIsSaveDisable();
    },
    getIsSaveDisable () {
      let _isSaveDisable1 = false,
        _isSaveDisable2 = false,
        _isSaveDisable = false;
      this.signatoryJson.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable1 = true;
        }
      });
      this.batchArray.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable2 = true;
        }
      });
      if (_isSaveDisable1 || _isSaveDisable2) {
        _isSaveDisable = true;
      }
      this.isSaveDisable = _isSaveDisable;
    },
    // 批量签署方添加
    batchAdd () {
      if (this.batchArray.length === 100) {
        this.$message.info("单独签署方上限为100个");
        return;
      }
      this.batchArray.push({
        account: "",
        name: "",
        identityNo: "",
        signatoryUserType: 0,
        signLevel: null,
        authLevel: null,
        userType: 0,
        chapteJson: [],
        // 新增集团账户 数组
        canSelectArray: [],
        canSelectArrayIndex: 0,
        ischange: 0,
        disabled: "",
        openUserTab: false,
        isEncrypt: false
      });
    },
    // 批量导入
    batchImport () {
      let importBatchFile = this.$refs["importBatchFile"];
      if (importBatchFile) {
        importBatchFile.value = "";
      }
      if (this.batchArray.length > 0) {
        this.$confirm("导入前将清空当前批量签署方, 是否继续导入", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.batchArray = [];
            if (this.$refs["importBatchFile"]) {
              this.$refs["importBatchFile"].click();
            }
          })
          .catch(() => { });
      } else {
        if (this.$refs["importBatchFile"]) {
          this.$refs["importBatchFile"].click();
        }
      }
    },
    batchFileChange () {
      this.batchLoading = true;
      let importBatchFile = this.$refs["importBatchFile"];
      let files = importBatchFile.files;
      if (files.length > 0) {
        let file = files[0];
        let name = file.name;
        let suffix = name.substring(name.lastIndexOf("."));
        if (suffix === ".xlsx" || suffix === ".xls") {
          let params = new FormData();
          params.append("excel ", file);
          ApiCorpMethods.BatchContractController.uploadBatch(params)
            .then(res => {
              if (res.success) {
                let data = res.data;
                this.batchArray = [];
                if (data) {
                  for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    if (this.batchArray.length === 100) {
                      break;
                    }
                    let signor = {
                      account: "",
                      name: "",
                      signatoryUserType: 0,
                      authLevel: null,
                      userType: 0,
                      chapteJson: [],
                      // 新增集团账户 数组
                      canSelectArray: [],
                      canSelectArrayIndex: 0,
                      signLevel: null,
                      identityNo: "",
                      ischange: 0,
                      disabled: "",
                      openUserTab: false,
                      isEncrypt: false
                    };

                    let targetId = element.targetId;
                    signor.account = targetId;
                    let isPhone = false;
                    if (/^\d{11}$/.test(targetId)) {
                      isPhone = true;
                    }

                    // 初始化额外发送手机号
                    signor.isNoticePhone = false;
                    signor.showNoticePhone = false;
                    signor.mobile = "";

                    signor.name = element.name;
                    signor.identityNo = element.idNo;
                    let userType = isPhone ? 0 : 1;
                    // 以前的判断企业和个人
                    // signor.identityNo = userType === 0 ? element.idNo : '';

                    signor.signatoryUserType = userType;

                    signor.userType = userType;

                    //只有人脸
                    signor.authLevel = element.authLevel ? 11 : null;

                    this.batchArray.push(signor);
                  }

                  if (data.length > 100) {
                    this.$confirm(
                      `成功导入${this.batchArray.length}条，剩余${data.length -
                      this.batchArray.length}条未被导入(批量签署方上限100)`,
                      "系统提示",
                      {
                        confirmButtonText: "确定",
                        type: "warning",
                        showCancelButton: false
                      }
                    )
                      .then(() => { })
                      .catch(() => { });
                  } else {
                    this.$confirm(
                      `共导入${this.batchArray.length}条数据`,
                      "系统提示",
                      {
                        confirmButtonText: "确定",
                        type: "warning",
                        showCancelButton: false
                      }
                    )
                      .then(() => { })
                      .catch(() => { });
                  }
                  this.batchLoading = false;
                }
              } else {
                this.batchLoading = false;
                this.$message.error(res.description || "导入文件失败.");
              }
            })
            .catch(error => {
              this.$message.error(error.description || "导入文件失败.");
              this.batchLoading = false;
            });
        } else {
          this.$message.warning("文件格式不正确.");
          this.batchLoading = false;
        }
      } else {
        this.batchLoading = false;
      }
    },
    // 批量删除全部
    batchClearAll () {
      this.$confirm("是否删除所有已添加的批量签署方？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchArray = [];
          let importBatchFile = this.$refs["importBatchFile"];
          if (importBatchFile) {
            importBatchFile.value = "";
          }
          this.$message.success('操作成功！')
        })
        .catch(err => err);
    },
    // 批量删除
    batchClear (index) {
      if (this.batchArray[index]) {
        this.batchArray.splice(index, 1);
      }
    },
    // 下载模板
    downloadTemplate () {
      let www =
      GlobalConfig.domain.junziqianWebOp + "/batch-template.xlsx";
      if (isInDingTalk) {
        dd.downloadFile({
          url: www,
          success: (res) => {
            const { filePath } = res;
          },
          fail: () => { },
          complete: () => { },
        });
      } else {
        window.open(www);
      }
    },
    // 查找批量签署方的index
    findSignatoryJsonBatchIndex () {
      let index = undefined;
      if (this.signatoryJson) {
        this.signatoryJson.forEach((element, i) => {
          if (element.signOwner === "批量签署方") {
            index = i;
          }
        });
      }
      return index;
    },
    /**
     * 20200521新增功能
     * 签署方名称改变时，更新页面中签章对应的签署方名称
     * @signOwner 签署方一二三，根据signOwner找到对应的签章更新
     * @name 需要更改的签署方名称
     * */
    changeQSNameInQZ (signOwner, name) {
      this.chapteJson.map(item => {
        if (item.signOwner === signOwner) {
          item.qsInfo = name; // 更改显示的签署方姓名
        }
      });
    },
    // 集团账户选择触发事件
    handleSelectCorpAccount (value, item) {
      const mine = this.signatoryJson.filter((sign) => sign.sameCorpUser)
      if (!mine.length) {
        this.chapterCheck = []
      } else {
        const len = this.chapterList.length;
        if (len) this.chapterCheck.push(this.chapterList[0].corpSealId)
      }
      if (value === "ManualInput") {
        // 新需求，新增手动输入
        item.name = "";
        item.identityNo = "";
        item.ischange = 0;
        item.disabled = "";
        item.userType = 0;
        item.corpUser = "";
        item.corpUserStatus = false;
        item.signatoryUserType = 1;
        item.ManualInput = true; // 标志启用手动输入
      } else {
        let v = item.canSelectArray[value];
        console.log('canSelectItem', v);
        if (v.corpUser) {
          item.corpUserStatus = true;
          item.corpUser = v.corpUser;
          item.userType = 0;
          item.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
        } else {
          item.corpUserStatus = false;
          item.userType = v.userType;
          item.corpUser = "";
        }

        item.signatoryUserType = v.userType;
        item.name = v.name;
        item.identityNo = v.businessLicense || v.identityCard;
        if (item.signatoryUserType === 1) {
          item.identityNo = "";
        } else {
          item.identityNo = v.identityCard;
        }
        item.ischange = item.identityNo ? 1 : 0;
        item.disabled = item.identityNo ? "disabled" : '';
      }

      this.changeQSNameInQZ(item.signOwner, item.name); // 签署方名称改变时，更新页面中签章对应的签署方名称
    },
    // 选择通讯录和我的组织里面的人 确认按钮事件
    handleClickSelectSignorOk () {
      // 判无
      const corpLen = this.tableListMyCorp.length, telLen = this.telList.length
      if (corpLen === 0 && telLen === 0) return this.showTel = false
      if ((corpLen || telLen) && !this.tableSignorSelectRow) return this.$message.warning('请先选择签署方')
      // 判无
      if (this.activeTabSigner !== "default") {
        this.tableSignorSelectRow = undefined;
      }

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 复制以前的代码 怕报错
      /*********************************** */
      this.showTel = false;
      this.telPageInfo.accountNo = null;
      this.telPageInfo.name = null;
      this.telPageInfo.idNo = null;
      this.telPageInfo.itemPage = 1;
      // return openUserTab to false
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[
          this.selectIndex
        ].account = this.tableSignorSelectRowTargetID;
        // this.signatoryJson[this.selectIndex].openUserTab = false
      }

      /*********************************** */
      this.getUserInfoBySelectTargetId({ account: this.tableSignorSelectRowTargetID, selectIndex: this.selectIndex, type: true });
    },
    /** 根据用户从table选择的签署人查询信息
     *  @param account 签署人邮箱/phone
     *  @param selectIndex 下标（签署人列表下标）
     *  @param type 是否改变签署人类型
    */
    async getUserInfoBySelectTargetId (obj) {
      const { account, selectIndex, type } = obj
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }

      // 清空验证信息
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      }

      if (account) {
        this.tableSignorSelectRowTargetID = account;
      }
      if (!account || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        const { corpUserId } = this.currentUser, params = { targetId }
        // 是成员账号就传corpUserId
        if (corpUserId) params.corpUserId = corpUserId
        postFindByEmailOrMphon(params)
          .then(data => {
            if (data.data) {
              this.fillSignorData(data.data, type);
            } else {
              this.fillSignorData([], type);
            }
          })
          .catch(err => {
            this.$message.error(err.description);
          });
      } else {
        this.fillSignorData([], type);
      }
    },
    changShowNoticePhone (selectIndex) {
      let _showNoticePhone = !this.signatoryJson[selectIndex].showNoticePhone;
      this.$set(
        this.signatoryJson[selectIndex],
        `showNoticePhone`,
        _showNoticePhone
      );
      this.$set(this.signatoryJson[selectIndex], `mobile`, null);
    },
    // 查询到结果后重新赋值
    fillSignorData (canSelectArray, type) {
      let signor = undefined;
      // 只有一个身份直接判断是否需要前往国际版
      if(canSelectArray.length === 1 && canSelectArray[0].registerScene && canSelectArray[0].registerScene === 310){
        return this.$message.warning('当前账号属于国际版，请前往国际版进行发起')
      }
      // 判断查询账号是否只是非内陆账号(【canSelectArray】只有一条数据即只有一个身份，且含有cardType字段以及userType 为个人 0)
      const notInland = canSelectArray.length === 1 && canSelectArray[0].cardType === 2 && canSelectArray[0].userType === 0
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          if (notInland) element.signatoryUserType = 2
          signor = element;
        }
      });
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractListTab"][this.selectIndex].validateField(
            "account"
          );
        });
      }
      signor.errorMsg = "";
      this.$set(this.signatoryJson[this.selectIndex], `errorMsg`, "");
      if (canSelectArray.length === 0) {
        // 按照以前老版本改
        if (this.tableSignorSelectRow) {
          // 有值 说明是通讯录点击的行数据
          // businessLicense: "155454526254523"	证件号
          // enterpriseName: "15545"	签署方名称
          // mobileOrChild: "13896918730"	联系方式
          let targetId = this.tableSignorSelectRow.mobileOrChild;
          let isPhone = false;
          if (happy.mobile.test(targetId)) {
            isPhone = true;
          }
          signor.name = this.tableSignorSelectRow.enterpriseName;
          let userType = isPhone ? 0 : 1;
          signor.identityNo =
            userType === 0
              ? this.tableSignorSelectRow.identityCard
              : this.tableSignorSelectRow.businessLicense;
          signor.signatoryUserType = userType;
          signor.ischange = signor.identityNo ? 1 : 0;
          signor.disabled = signor.identityNo ? "disabled" : '';
          signor.userType = userType;
          signor.identityType = this.tableSignorSelectRow.cardType || null;

          // 通讯录选择的时候隐藏清空额外短信通知手机号
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.mobile = "";
        } else {
          // 没有值
          // 下面这是清空的

          // name: 签署方名称, identityNo: 证件号, childUserName: 企业联系, signatoryMobile: 个人联系
          signor.name = "";
          signor.identityNo = "";
          // signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.userType = signor.signatoryUserType;
          // findByEmailOrMphone数据请求没有数据的时候，emailOrPhone是邮箱就显示额外短信通知手机号
          if (happy.email.test(signor.account)) {
            signor.isNoticePhone = true;
            if (signor.mobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.mobile = "";
          }
          signor.identityType = null;
        }
      } else {
        // 是否允许改变签署人类型
        if (type) {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              // signor.corpUser = element.corpUser || ''
              signor.canSelectArrayIndex = index;
              signor.corpUserStatus = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.name = v.name;
          signor.identityNo =
            v.userType === 0 ? v.identityCard : v.businessLicense;
          signor.signatoryUserType = current.registerScene === NonChinaLand && v.userType == 0 ? 2 : v.userType;
          signor.corpUser = v.corpUser || "";
          signor.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
          if (signor.signatoryUserType === 1) {
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            // emailOrPhone是邮箱就显示额外短信通知手机号
            if (happy.email.test(signor.account)) {
              signor.isNoticePhone = true;
              if (signor.mobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.mobile = "";
            }
          } else {
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.mobile = "";
          }
          // canSelectArray改变需要更新canSelectArrayIndex
          let rindex = canSelectArray.findIndex(
            element => element.corpId && element.corpId === corpId
          );
          signor.canSelectArrayIndex = rindex >= 0 ? rindex : 0; // 没有默认选中第一个

          signor.ischange = signor.identityNo ? 1 : 0;
          signor.disabled = signor.identityNo ? "disabled" : '';
          signor.userType = v.userType;
          signor.identityType = v.cardType || null;
          signor.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
          // if (signor.corpUserStatus) {
          //   signor.userType = 0;
          // } else {
          //   signor.userType = v.userType;
          // }
        } else {
          let isEmptySignor = false;
          if (signor.signatoryUserType === 1) {
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            if (
              happy.mobile.test(signor.account) &&
              canSelectArray.length === 0
            ) {
              isEmptySignor = true;
              signor.showNoticePhone = false;
              signor.mobile = "";
            }
            if (happy.email.test(signor.account)) {
              signor.isNoticePhone = true;
              if (signor.mobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.mobile = "";
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            if (canSelectArray.length === 0) {
              isEmptySignor = true;
            }
          }
          if (isEmptySignor) {
            signor.name = "";
            signor.identityNo = "";

            signor.ischange = 0;
            signor.disabled = "";
            signor.userType = signor.userType;
            signor.identityType = null;
          } else {
            let current = this.$store.getters.currentAuthUser;
            let corpId = "";
            if (current) {
              corpId = current.corpId;
            }
            // 默认选择第一个
            signor.canSelectArrayIndex = 0;
            canSelectArray.forEach((element, index) => {
              if (element.corpId && element.corpId === corpId) {
                // signor.corpUser = element.corpUser || ''
                signor.canSelectArrayIndex = index;
                signor.corpUserStatus = true;
              }
            });
            let v = canSelectArray[signor.canSelectArrayIndex];
            if (!v) return
            signor.name = v.name;
            signor.corpUser = v.corpUser || "";
            signor.identityNo =
              v.userType === 0 ? v.identityCard : v.businessLicense;
            if (happy.email.test(signor.account)) {
              signor.isNoticePhone = true;
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.mobile = "";
            }

            signor.ischange = signor.identityNo ? 1 : 0;
            signor.disabled = signor.identityNo ? "disabled" : '';
            signor.userType = v.userType;
            signor.identityType = v.cardType || null;
            signor.sameCorpUser = v.sameCorpUser ? v.sameCorpUser : null
            // if (signor.corpUserStatus) {
            //   signor.userType = 0;
            // } else {
            //   signor.userType = v.userType;
            // }
          }
        }
      }

      signor.ManualInput = false; // 重置手动输入
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      // signator.signatoryUserType == 1 为企业时，去除人脸识别默认选中。为个人时，人脸默认选中
      if (signor.signatoryUserType == 1) signor.authLevel = null;
      if (signor.signatoryUserType == 0) signor.authLevel = 11;
      this.getIsSaveDisable();
      this.tableSignorSelectRow = undefined;
      this.changeQSNameInQZ(signor.signOwner, signor.name);
    },
    // 我的组织 选择签署人 点击事件
    handleRowClickMyCorp (row, event, column) {
      if (row) {
        this.tableSignorSelectRow = row;
        this.tableSignorSelectRowTargetID = row.targetId;
      } else {
        this.tableSignorSelectRow = undefined;
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 我的组织 查询签署人
    clickHandleMyCorpSearch () {
      this.queryToolMyCorp('signUser');
    },
    /** 重置搜索 */
    restCorp () {
      this.myCorpModel = {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 名称
        corpGroupId: "" // 部门ID
      }
    },
    // 查询我的组织 签署人列表
    async queryToolMyCorp (type) {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRows = [];
      // if (!this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      let res = ''
      try {
        if (type === 'signUser') {
          res = await ApiCorpMethods.CorpCommonController.userGetCorpUser({
            ...this.myCorpModel,
            corpUserId: this.activeTabSigner,
          })
        } else {
          res = await ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        }
        this.myCorpModel.loading = false;
        if (res.code === "0") {
          this.tableListMyCorp = res.data;
          this.myCorpModel.total = res.total;
          // 抄送人选中回显
          if (this.visibleAuditAndCopy) {
            this.$nextTick(() => {
              this.tableListMyCorp.forEach((item, i) => {
                this.arrayCopior.forEach(user => {
                  if (item.targetId === user.targetId) {
                    this.$refs.multipleTable.toggleRowSelection(this.tableListMyCorp[i], true);
                    this.tableAuditAndCopySelectRows.push(item)
                  }
                })
              })
            })
          }

          if (res.total === 0) {
            this.myCorpModel.emptyText = "暂无数据";
          }
        } else {
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(res.description);
        }
      } catch (err) {
        this.myCorpModel.loading = false;
        this.tableListMyCorp = [];
        this.myCorpModel.total = 0;
        this.myCorpModel.emptyText = err.description;
        this.$message.error(err.description);
      };
    },
    handleSizeChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      // 【signUser】 传参是因为个人主体查询成员企业通讯录调用的接口不同
      this.queryToolMyCorp(this.activeTabSigner !== 'default' ? 'signUser' : '');
    },
    handleCurrentChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = val;
      // 【signUser】 传参是因为个人主体查询成员企业通讯录调用的接口不同
      this.queryToolMyCorp(this.activeTabSigner !== 'default' ? 'signUser' : '');
    },
    // 移除抄送人
    handleClickRemoveArrayCopior (index) {
      this.arrayCopior.splice(index, 1);
      // this.$refs.multipleTable.toggleRowSelection(this.tableListMyCorp[index], false);
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyer () {
      this.auditAndCopyTitle = "添加抄送人";
      // 清空
      this.auditAndCopyModel.keyword = "";
      this.visibleAuditAndCopy = true;
      this.$nextTick(() => {
        this.tableAuditAndCopySelectRows = []
        this.$refs.multipleTable.clearSelection();
        this.clickHandleAuditorOrCopyerSearch();
        this.queryToolMyCorp();
      })
    },
    // 查询按钮
    clickHandleAuditorOrCopyerSearch () {
      this.auditAndCopyTitle = "添加抄送人";
      this.queryToolAuditAndCopy();
    },
    // 查询审批人 抄送人列表
    queryToolAuditAndCopy () {
      this.auditAndCopyModel.loading = true;
      this.tableAuditAndCopySelectRows = [];
      if (this.auditAndCopyModel.keyword) {
        this.auditAndCopyModel.targetId = this.auditAndCopyModel.keyword;
        ApiCorpMethods.CorpCommonController.listCorpUser(this.auditAndCopyModel)
          .then(res => {
            this.auditAndCopyModel.loading = false;
            if (res.code === "0") {
              this.tableListAuditAndCopy = res.data;
              this.auditAndCopyModel.total = res.total;
              if (res.total === 0) {
                this.auditAndCopyModel.emptyText = "暂无数据";
              }
            } else {
              this.tableListAuditAndCopy = [];
              this.auditAndCopyModel.total = 0;
              this.auditAndCopyModel.emptyText = res.description;
              this.$message.error(res.description);
            }
          })
          .catch(error => {
            this.auditAndCopyModel.loading = false;
            this.tableListAuditAndCopy = [];
            this.auditAndCopyModel.total = 0;
            this.auditAndCopyModel.emptyText = res.description;
            this.$message.error(err.description);
          });
      } else {
        this.auditAndCopyModel.loading = false;
        this.tableListAuditAndCopy = [];
        this.auditAndCopyModel.total = 0;
        this.auditAndCopyModel.emptyText = "请输入组织内部签署方名称或账号";
      }
    },
    // 添加审批人抄送人table row click event
    handleRowClickAuditAndCopy (row, column, event) {
      // 根据id判断当前点击的是否被选中
      const selected = this.tableAuditAndCopySelectRows.some(item => item.targetId === row.targetId)
      if (!selected) {
        // 选择
        this.tableAuditAndCopySelectRows.push(row)
        this.$refs.multipleTable.toggleRowSelection(row, true);
      } else {
        // 取消
        // 取消后剩余选中的
        this.tableAuditAndCopySelectRows = this.tableAuditAndCopySelectRows.filter((item) => item.targetId !== row.targetId)
        this.$refs.multipleTable.toggleRowSelection(row, false);
      }
    },
    handleSelectionChange (select) {
      this.tableAuditAndCopySelectRows = select
    },
    // 添加审批人或者抄送人
    clickHandleAddAuditorOrCopyerSubmit () {
      // 抄送人
      this.auditAndCopyTitle = "添加抄送人";
      if (this.tableAuditAndCopySelectRows.length === 0) {
        this.$message.error("请选择抄送人");
        return;
      } else {
        const ROWS = JSON.parse(JSON.stringify(this.tableAuditAndCopySelectRows))
        const _ROWS = [];
        ROWS.map(item => {
          const have = this.arrayCopior.some(select => item.targetId === select.targetId)
          if (!have) _ROWS.push(item)
        })
        // const selected = this.tableAuditAndCopySelectRows.some(item => item.targetId === row.targetId)
        if (_ROWS.length > 0) this.arrayCopior.push(...JSON.parse(JSON.stringify(_ROWS)))
        this.visibleAuditAndCopy = false
      }
    },

    validContractName: function () {
      if (this.contractInfo.contractName.length > 100) {
        return this.$message.warning("合同名称不能超过一百个字符");
      }
    },
    // 输入input合同跳页
    handleContractPageClick () {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    // 查询用户是否有视频签署套餐
    queryUserHasVideoPackage () {
      VideoSign.hasVideoPackage()
        .then(({ data }) => {
          this.hasVideoPackage = data;
        })
        .catch(err => {
          this.hasVideoPackage = false;
        });
    },
    // 取消合同发起或保存
    handleDelSendContract () {
      this.signatoryJson.forEach(t => {
        var entName = t.name;
        if (this.entNameArr.indexOf(entName) !== -1) {
          t.identityNo = "";
        }
      });
      this.entCreditArr = [];
      this.entCreditJson = {};
      this.entNameArr = [];
      this.userIdentityInfoArr = [];
      this.visibleCredit = false;
    },
    // 合同提交发送 发起或保存到草稿箱saveToDraftBox 0发起 1保存
    sendContractToCreate (saveToDraftBox, phoneList = null) {
      // 集团账户 如果有审批流程 需要添加审批流程
      if (
        this.isGroup &&
        !this.checkedBatch &&
        this.hasApplyApproval === true && !phoneList
      ) {
        if (
          !isInDingTalk && this.approvalFlowList.length > 0 &&
          this.approvalFlowSelect === undefined
        ) {
          // saas 环境
          this.$message.error("请选择审批流程");
          return;
        }
      }
      if (this.checkedBatch) {
        if (this.batchArray.length === 0) {
          this.$message.warning("请添加批量签署方");
          return false;
        }
      }
      if (this.fileList.length === 0) {
        return this.$message.warning("请先上传需要签署的文件！");
      }
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        // if (this.$refs['referenceSignerForm'] && this.$refs['referenceSignerForm'].length > 0) {
        //   this.$refs['referenceSignerForm'][this.selectIndex].clearValidate();
        // }
      }
      // 验证填写信息
      this.$refs.contForm.validate(valid => {
        if (valid) {
          if (
            !this.contractInfo.contractName ||
            this.contractInfo.contractName === ""
          )
            return this.$message.warning("请输入主题名称");
          if (this.contractInfo.contractName.length > 100)
            return this.$message.warning("主题名称不能超过一百个字符");
          if (
            parseInt(this.contractInfo.needVideoSign) === 1 &&
            this.signatoryJson.length !== 2
          )
            return this.$message.error("视频签只允许有两个手动签署方");
          let validChild = true;
          // 验证 签署方form表单列表
          let rulesTab = this.$refs.contractListTab;
          if (rulesTab) {
            rulesTab.forEach(t => {
              if (t.validate) {
                t.validate(() => { });
              }
            });
            try {
              rulesTab.forEach(t => {
                if (t.fields) {
                  const fields = t.fields;
                  if (fields) {
                    fields.forEach(element => {
                      if (
                        element.prop !== "" &&
                        element.validateState === "error"
                      ) {
                        throw new Error("validFails");
                      }
                    });
                  }
                }
              });
            } catch (error) {
              validChild = false;
            }
          }

          // 验证批量签署方form表单列表
          let validChildBatch = true;
          let contractBatchListTab = this.$refs.contractBatchListTab;
          if (contractBatchListTab) {
            contractBatchListTab.forEach(t => {
              t.validate(() => { });
            });
            try {
              contractBatchListTab.forEach(t => {
                const fields = t.fields;
                if (fields) {
                  fields.forEach(element => {
                    if (
                      element.prop !== "" &&
                      element.validateState === "error"
                    ) {
                      throw new Error("validFails");
                    }
                  });
                }
              });
            } catch (error) {
              validChildBatch = false;
            }
          }
          if (!validChild || !validChildBatch)
            return this.$message.error("请检查签署方信息！");
          this.isSaveToDraftBox = saveToDraftBox;

          // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
          // 签署方式企业用户且没有证件号
          this.entCreditJson = {};
          this.entCreditArr = [];
          this.entNameArr = [];
          let queryCreditcodeParam = [];
          // 二要素验证变量
          this.userIdentityInfoArr = [];
          let userIdentityInfoParam = []; // 存放需要进行二要素的数组
          this.signatoryJson.forEach(t => {
            // 企业用户且没有证件号
            if (
              parseInt(t.signatoryUserType) === 1 &&
              t.name &&
              !t.identityNo
            ) {
              queryCreditcodeParam.push(t.name);
            }

            // 个人信息-姓名身份证二要素验证
            if (
              parseInt(t.signatoryUserType) === 0 &&
              t.name &&
              t.identityNo &&
              t.identityNo.indexOf("***") === -1
            ) {
              // 是个人且有姓名身份证号码，且身份证号码未加密（手动输入的）
              userIdentityInfoParam.push({
                name: t.name,
                identityNo: t.identityNo
              });
            }
          });

          if (
            (queryCreditcodeParam && queryCreditcodeParam.length) ||
            (userIdentityInfoParam && userIdentityInfoParam.length)
          ) {
            // 查询企业执照号，验证个人信息
            let arr = [];
            if (queryCreditcodeParam && queryCreditcodeParam.length) {
              // 查询企业执照号并将查询到的企业赋值
              arr.push(this.queryEntIDByEntName(queryCreditcodeParam));
            }
            if (userIdentityInfoParam && userIdentityInfoParam.length) {
              // 二要素验证，身份信息不正确的予以提示
              arr.push(this.twoElementsVerify(userIdentityInfoParam));
            }
            Promise.all(arr).then(res => {
              if (res && res.length) {
                for (let i = 0; i < res.length; i++) {
                  let smt = res[i];
                  if (smt && !smt.sus) {
                    this.visibleCredit = true; // 显示签署方信息提示弹窗
                    return false; // 中止后面的操作
                  }
                }
                this.contractIsSaveToDraf(null, phoneList); // 信息无误
              }
            });
          } else {
            // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《
            this.contractIsSaveToDraf(null, phoneList); // 信息无误
          }
        } else {
          console.error("验证不通过.");
        }
      });
    },

    // 通过企业名称去查询企业的证件号
    queryEntIDByEntName (entNameArr) {
      this.entNameArr = entNameArr;
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryCreditCodeByEntName(entNameArr)
          .then(res => {
            this.loadingClose();
            if (res) {
              this.entCreditArr = [];
              this.entCreditJson = res;
              this.signatoryJson.forEach(t => {
                var entName = t.name;
                if (entNameArr.indexOf(entName) !== -1) {
                  if (res[entName]) {
                    t.identityNo = res[entName];
                  } else {
                    this.entCreditArr.push(entName);
                  }
                }
              });

              if (this.entCreditArr.length) {
                resolve({ sus: false }); // 显示签署方信息提示弹窗
              } else {
                resolve({ sus: true }); // 继续发起
              }
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log(
              "通过企业名称去查询企业的证件号： " + JSON.stringify(err)
            );
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },

    // 通过姓名身份证进行二要素验证
    twoElementsVerify (userInfoArr) {
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryUserValidateByNameIDnum(userInfoArr)
          .then(res => {
            this.loadingClose();
            if (res && res.length) {
              this.userIdentityInfoArr = res;
              resolve({ sus: false }); // 显示签署方信息提示弹窗
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log("身份证二要素验证： " + JSON.stringify(err));
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },

    // 手动输入证件号后提交合同
    async addContractById () {
      this.visibleCredit = false;
      this.signatoryJson.forEach(t => {
        if (this.entCreditJson[t.name]) {
          t.identityNo = this.entCreditJson[t.name];
        }
      });
      const flowInfo = await this.getFlowUserInfo();
      isInDingTalk && flowInfo ? this.createPreApproved(flowInfo) :
        this.contractIsSaveToDraf();
    },
    // 判断每个签署方至少有一个签章位置
    checkSignerHasSignature () {
      let arr = [];
      this.signatoryJson.forEach(sign => {
        let index = this.chapteJson.findIndex(
          v => v.signOwner === sign.signOwner && !v.forge
        );
        arr.push(index);
      });
      let arrIndex = arr.findIndex(i => i === -1);
      if (arrIndex !== -1) {
        return false;
      } else {
        return true;
      }
    },
    // 判断每份文件方至少有一个签章位置
    checkFilesHasSignature () {
      let arr = [];
      this.fileList.forEach(file => {
        let index = this.chapteJson.findIndex(v => {
          const VO = file.fileOperVO;
          const targetId = VO ? VO.targetId : file.targetId;
          return v.targetId === targetId;
        });
        arr.push(index);
      });
      let arrIndex = arr.findIndex(i => i === -1);
      if (arrIndex !== -1) {
        return false;
      } else {
        return true;
      }
    },
    /** 合同是否保存到草稿箱 */
    // dingFlow 钉钉才会用到的参数。不要与原saas混合
    // 协同编辑 noninductive 有参数说明不用弹窗提示保存草稿
    contractIsSaveToDraf (dingFlow, phoneList) {
      if (this.isSaveToDraftBox) {
        if (phoneList && phoneList.length > 0) {
          this.postSendOrSave(1, null, phoneList);
          return false;
        }
        const haveTpl = this.fileList.some(item => item.isTpl),
          allTpl = this.fileList.every(item => item.isTpl),
          contitle =
            "本次发起流程中包含模板合同，存为草稿无法保存模板，是否继续？",
          message =
            haveTpl && !allTpl ? contitle : "你确定需要保存至草稿箱吗？";
        if (allTpl) return this.$message.error("合同模板无法存为草稿");
        this.$confirm(message, "系统提示", {
          showCancelButton: true,
          showConfirmButton: true,
          type: "warning"
        })
          .then(() => {
            this.postSendOrSave(true, dingFlow);
          })
          .catch(() => {
            this.handleDelSendContract();
          });
      } else {
        this.$confirm(`确定以 “${this.accountNameTab}”主体发起本次签署吗？`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.postSendOrSave(false, dingFlow);
          })
          .catch(err => err);
      }
    },
    // 提交合同 发起或保存到草稿箱 saveToDraftBox 0发起 1保存
    postSendOrSave (saveToDraftBox, dingFlow, phoneList = null) {
      try {
        if (this.loading) return // 防抖
        this.loadingStart()
        this.contractInfo.newNeedVideoSign =
          this.activeTabsName == this.signTypes[1] ? 1 : 0;
        let param = { ...this.contractInfo },
          hh = new Date().getHours(),
          mm = new Date().getMinutes(),
          water = JSON.parse(JSON.stringify(this.waterConfig));
        if (water && water.floatAlpha && water.floatAlpha > 1) water.floatAlpha = water.floatAlpha / 100;
        if (water.switch) param.waterConfig = JSON.stringify(water); //水印
        const chapsLen = this.chapterCheck.length
        if (this.isMine() && chapsLen) param.createSignerSealIds = this.chapterCheck
        param.signExpire = this.signlinktime + " " + hh + ":" + mm + ":00";
        param.draftChapteJson = saveToDraftBox ? this.chapteJson : [];
        // 原来逻辑是选中不显示时间；【1863】需求之后，这里的逻辑改成了选中显示时间；所以取反
        param.hideSignDate = Number(!param.hideSignDate)
        if (phoneList && phoneList.length > 0) {
          param.draftType = 1; // 草稿类型
          param.coEditingUsers = phoneList; // 协作人电话列表
        }
        // if (isInDingTalk) {
        //   param.corpId = dingFlow.corpId
        //   param.dingTalkUserId = dingFlow.dingTalkUserId
        // }
        this.chapteJsonFilter();
        let _signatoryJson = JSON.parse(JSON.stringify(this.signatoryJson));
        _signatoryJson.forEach(i => {
          // if (i.faceOrVideo == 1 && i.videoSignUserType != 2) {
          //   i.videoSignUserType = i.faceOrVideo;
          // }
          if (i.faceOrVideo == 1 && i.videoSignUserType != 2) {
            i.videoSignUserType = i.faceOrVideo;
          }
          i.userType = i.corpUserStatus ? 0 : i.signatoryUserType === 0 ? 0 : 1;
          // * 没看明白上面的判断字段是出于什么目的。修复bug我就加了个判断
          if (i.userType != i.signatoryUserType) i.userType = i.signatoryUserType;
          // 【signatoryUserType】2 说明是非内陆个人 【userType】赋值个人 【identityType】赋值为 2 标识非大陆内陆
          if (i.signatoryUserType === 2) {
            i.userType = 0;
            i.identityType = 2
          }
          delete i.isNoticePhone;
          delete i.showNoticePhone;
          if (!i.mobile) {
            delete i.mobile;
          }
          delete i.errorMsg;
          // 添加骑缝章自定义位置
          if (this.qifengChapList.length > 0) {
            this.qifengChapList.forEach(qifeng => {
              if (qifeng.signOwner === i.signOwner) i.qiFengOffset = qifeng.offsetY
            })
          }
        });
        let _batchArray = [...this.batchArray];
        _batchArray.forEach(i => {
          if (i.faceOrVideo == 1 && i.videoSignUserType != 2) {
            i.videoSignUserType = i.faceOrVideo;
          }
          i.userType = i.corpUserStatus ? 0 : i.signatoryUserType === 0 ? 0 : 1;
          if (i.userType != i.signatoryUserType) i.userType = i.signatoryUserType;
          // 【signatoryUserType】2 说明是非内陆个人 【userType】赋值个人 【identityType】赋值为 2 标识非大陆内陆
          if (i.signatoryUserType === 2) {
            i.userType = 0;
            i.identityType = 2
          }
          delete i.isNoticePhone;
          delete i.showNoticePhone;
          if (!i.mobile) {
            delete i.mobile;
          }
          delete i.errorMsg;
        });
        param.signers = _signatoryJson.length ? _signatoryJson : null;
        param.saveToDraftBox = saveToDraftBox;
        let _files = JSON.parse(JSON.stringify(this.fileList));
        _files.map((v, i) => (v.sort = i));
        param.files = _files.concat(this.enclosureFilesList);
        if (saveToDraftBox) {
          // 保存到草稿箱过滤掉模板数据
          param.files = param.files.filter(item => !item.isTpl);
        }
        // console.log("param", param);
        this.loadingStart("正在上传数据");
        // 集团账户 添加审批流程
        if (this.isGroup) {
          // 集团账户批量发起没有审批和抄送人
          // 添加集团账户发起签署审批流程
          // 20200721去掉批量审批流程判断
          if (!this.checkedBatch) {
            param.flowId = this.approvalFlowSelect;
            // 添加审批人
            // 抄送人
            let carbonCopyJson = [];

            this.arrayCopior.forEach(element => {
              !element.hideRemove && carbonCopyJson.push(element.corpUserIdSec || element.corpUserIdApplySign);
            });

            param.carbonCopyJson = carbonCopyJson;
          }

          // 批量操作
          if (this.checkedBatch) {
            // 过滤 批量签署方
            let index = undefined;
            let batchChapteJson = null;
            if (this.signatoryJson) {
              let signatoryJsonCopy = JSON.parse(
                JSON.stringify(this.signatoryJson)
              );
              signatoryJsonCopy.forEach((element, i) => {
                if (element.signOwner === "批量签署方") {
                  index = i;
                  batchChapteJson = element.chapteJson;
                }
              });
              if (index !== undefined) {
                signatoryJsonCopy.splice(index, 1);
              }
              // 重新封装参数
              param.signers = signatoryJsonCopy.length ? signatoryJsonCopy : null;
            }

            // 重新封装批量签署方，填充信息
            _batchArray.forEach(element => {
              element.chapteJson = batchChapteJson;
              if (!element.childUserName && !element.signatoryMobile) {
                if (parseInt(element.signatoryUserType) === 1) {
                  element.childUserName = element.account;
                } else {
                  element.signatoryMobile = element.account;
                }
              }
            });

            // 判断未注册企业是否有证件号
            let noIdentityCardCompanyName = [];
            this.batchArray.forEach(element => {
              if (!element.identityNo) {
                noIdentityCardCompanyName.push(element.name);
              }
            });

            if (noIdentityCardCompanyName.length > 0) {
              let html = '<div style="max-height: 350px;overflow: auto">';
              noIdentityCardCompanyName.forEach(element => {
                html += "<strong>" + element + "</strong><br/>";
              });
              html +=
                "<p>以上企业没有对应营业执照号，请手动补全后重新导入.</p></div>";
              this.$alert(html, "系统提示", {
                dangerouslyUseHTMLString: true
              });
              this.loadingClose();
              return;
            }
            param.batchSigners = _batchArray.length ? _batchArray : null;
            if (index === undefined) {
              index = 0;
            }
            if (param.ifOrder) {
              param.batchSignOrder = index + 1;
            }
            // 集团账户不支持审批和抄送
            param.approveJson = null;
            param.carbonCopyJson = null;
            if (+param.flowId === 0) {
              delete param.flowId;
            }
            ApiCorpMethods.CorpApplyContractController.multipleCreate(
              Object.assign(param, { pay: 1 })
            )
              .then(res => {
                if (res.code === "0") {
                  console.log(res);
                  this.createdFinish(res.data, saveToDraftBox, true, param);
                } else {
                  this.loadingClose();
                  if (+res.code === 10806) {
                    this.$message.error("积分/套餐不足，请联系公司管理员");
                  } else {
                    this.$message.error(
                      res.description || "签署失败，请刷新后再试"
                    );
                  }
                }
              })
              .catch(err => {
                this.loadingClose();
                console.log("签署：" + JSON.stringify(err));
                this.$message.error(err.description || "签署失败，请刷新后再试");
              });
          } else {
            if (isInDingTalk) {
              const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
              param.dingTalkCorpId = info.dingTalkCorpId;
              param.dingTalkUserId = info.dingTalkUserId;
              // dingFlow 如果有这个参数，把参数带入进去。且发起完成后创建钉钉审批流
              if (dingFlow) {
                const { dingTalkWorkFlowId } = dingFlow;
                param.dingTalkWorkFlowId = dingTalkWorkFlowId;
              }
            }
            if (+param.flowId === 0) {
              delete param.flowId;
            }
            ApiCorpMethods.CorpApplyContractController.multipleCreate(
              Object.assign(param, { pay: 1 })
            )
              .then(res => {
                if (res.code === "0") {
                  if (isInDingTalk && dingFlow) {
                    // 如果是钉钉微应用使用。就在去创建审批流程再调用 【createdFinish】
                    this.craeteDingFlow(
                      res.data,
                      {
                        corpId: param.dingTalkCorpId,
                        dingTalkUserId: param.dingTalkUserId,
                        preWorkFlowId: dingFlow.dingTalkWorkFlowId
                      },
                      saveToDraftBox,
                      param,
                    );
                  } else {
                    // 原 saas 创建
                    this.createdFinish(res.data, saveToDraftBox, false, param);
                  }
                } else {
                  this.loadingClose();
                  if (+res.code === 10806) {
                    this.$message.error("积分/套餐不足，请联系公司管理员");
                  } else {
                    this.$message.error(
                      res.description || "签署失败，请刷新后再试"
                    );
                  }
                }
              })
              .catch(err => {
                console.log("err", err);
                this.loadingClose();
                console.log("签署：" + JSON.stringify(err));
                this.$message.error(err.description || "签署失败，请刷新后再试");
              });
          }
        } else {
          // 正常流程 个人发起
          // 批量操作
          if (this.checkedBatch) {
            // 过滤 批量签署方
            let index = undefined;
            let batchChapteJson = null;
            if (this.signatoryJson) {
              let signatoryJsonCopy = JSON.parse(
                JSON.stringify(this.signatoryJson)
              );
              signatoryJsonCopy.forEach((element, i) => {
                if (element.signOwner === "批量签署方") {
                  index = i;
                  batchChapteJson = element.chapteJson;
                }
              });
              if (index !== undefined) {
                signatoryJsonCopy.splice(index, 1);
              }
              // 重新封装参数
              param.signers = signatoryJsonCopy.length ? signatoryJsonCopy : null;
            }
            // 重新封装批量签署方，填充信息
            this.batchArray.forEach(element => {
              element.chapteJson = batchChapteJson;
              if (!element.childUserName && !element.signatoryMobile) {
                if (parseInt(element.signatoryUserType) === 1) {
                  element.childUserName = element.account;
                } else {
                  element.signatoryMobile = element.account;
                }
              }
            });

            // 判断未注册企业是否有证件号
            let noIdentityCardCompanyName = [];
            this.batchArray.forEach(element => {
              if (!element.identityNo) {
                noIdentityCardCompanyName.push(element.name);
              }
            });

            if (noIdentityCardCompanyName.length > 0) {
              let html = '<div style="max-height: 350px;overflow: auto">';
              noIdentityCardCompanyName.forEach(element => {
                html += "<strong>" + element + "</strong><br/>";
              });
              html +=
                "<p>以上企业没有对应营业执照号，请手动补全后重新导入.</p></div>";
              this.$alert(html, "系统提示", {
                dangerouslyUseHTMLString: true
              });
              this.loadingClose();
              return;
            }

            param.batchSigners = this.batchArray.length ? this.batchArray : null;
            if (index === undefined) {
              index = 0;
            }
            if (param.ifOrder) {
              param.batchSignOrder = index + 1;
            }
            let { multiFileKey } = this.$route.query;
            if (multiFileKey) param.multiFileKey = multiFileKey;
            if (+param.flowId === 0) {
              delete param.flowId;
            }
            postMultipleCreateApply(param)
              .then(res => {
                if (res.code === "0") {
                  this.createdFinish(res.data, saveToDraftBox, true, param);
                } else {
                  this.loadingClose();
                  this.$message.error(
                    res.description || "签署失败，请刷新后再试"
                  );
                }
              })
              .catch(err => {
                this.loadingClose();
                this.$message.error(err.description || "签署失败，请刷新后再试");
              });
          } else {
            let { multiFileKey } = this.$route.query;
            if (multiFileKey) param.multiFileKey = multiFileKey;
            if (+param.flowId === 0) {
              delete param.flowId;
            }
            postMultipleCreateApply(param)
              .then(({ data }) => {
                this.createdFinish(data, saveToDraftBox, false, param);
              })
              .catch(err => {
                this.loadingClose();
                this.$message.error(err.description || "签署失败，请刷新后再试");
              });
          }
        }
      } catch (error) {
        console.error('error', error);
      }
    },
    // 钉钉微应用发起完成后执行
    craeteDingFlow (params, dingInfo, saveToDraftBox, param) {
      // 创建钉钉审批流程
      const _this = this;
      dingtalkApi.contractCreate(dingInfo).then(res => {
        if (!res.success) return _this.$message.error(res.description);
        console.log("创建钉钉审批流程", res);
        _this.createdFinish(params, saveToDraftBox, {}, param);
      });
    },
    //判断发起后是待签还是待审
    signOrApproveListFn () {
      if (!this.$store.getters.currentAuthUser.corpUserId) {
        return '2' // 主体的待签
      } else {
        return '4'
      }
    },
    // 发起完成之后回掉函数
    createdFinish (data, saveToDraftBox, batch, param) {
      let arrproveList = this.signOrApproveListFn(param);
      const snapshotId = data.snapshotId || "";
      this.payInfoData = {
        batch: batch,
        param: param,
        recharge: data.recharge,
        snapshotId: snapshotId
      };
      this.loadingClose();
      if (
        param &&
        param.draftType == 1 && !this.isSaveAsDraft
      ) {
        this.cooperateInfo.draftCoEditingSec = data.draftCoEditingSec
        this.cooperate = true
        return false;
      }

      if (!data.needPay || data.needPay === "false") {
        // api发起的如果有【contractBackUrl】就跳转到对应页面
        if (this.contractBackUrl) {
          // const newUrl = "https://example.com/new-page?t=" + Date.now();
          // window.location.replace(newUrl);
          window.location.href = this.contractBackUrl;
        }
        //有审批的
        if (this.isGroup) {
          if (saveToDraftBox) {
            this.$router.push({
              path:
                "/corp/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
            });
          } else {
            let paths = "";
            if (param.dingTalkWorkFlowId) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else if (data.selfSign === 1) {
              paths = "/corp/signInfo/signList?signStatus=4";
            } else if (data.selfSign === 2) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else {
              // paths = "/corp/signInfo/applyList?notMeSign=1";
              paths = `/corp/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
            }
            this.$router.push({
              path: paths
            });
          }
        } else {
          if (saveToDraftBox) {
            this.$router.push({
              path: "/signInfo/applyList?signStatus=4&snapshotId=" + snapshotId
              // path: "/signInfo/signList?signStatus=2&snapshotId=" + snapshotId
            });
          } else {
            let paths = "";
            if (param.dingTalkWorkFlowId) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else if (data.selfSign === 1) {
              paths = "/signInfo/signList?signStatus=2";
            } else if (data.selfSign === 2) {
              paths = "/corp/signInfo/signList?signStatus=5";
            } else {
              // paths = "/signInfo/applyList?notMeSign=1";
              paths = `/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
            }
            this.$router.push({
              path: paths
            });
          }
        }
      } else {
        if (this.payInfoData.recharge) {
          this.$jzqService.pointRechargeTip(data); // 积分不足时的充值提示
        } else {
          this.priseInfo.cashierUrl = data.cashierUrl || "";
          // this.priseInfo.money = data.money;
          this.priseInfo.point = data.point;
          this.priseVisibleDialog = true;
          var moneyData = data.moneyData || false;
          if (moneyData) {
            var moneryArr = [];
            // 签署次数
            if (moneyData.applySign && moneyData.applySign.timesPackage) {
              moneryArr.push(`签署${moneyData.applySign.timesPackage}次`);
            }
            // 银行卡4要数次数
            if (moneyData.bankFour && moneyData.bankFour.timesPackage) {
              moneryArr.push(`四要素${moneyData.bankFour.timesPackage}次`);
            }
            // 3要数次数
            if (moneyData.bankThree && moneyData.bankThree.timesPackage) {
              moneryArr.push(`三要素${moneyData.bankThree.timesPackage}次`);
            }
            // 人脸次数
            if (moneyData.face && moneyData.face.timesPackage) {
              moneryArr.push(`人脸${moneyData.face.timesPackage}次`);
            }
            if (moneryArr && moneryArr.length > 0) {
              this.priseInfo.mealInfo = moneryArr.join("；");
            }
          }
        }
      }
      // 重置回状态
      this.isSaveAsDraft = false
    },

    // 签章列表整理
    chapteJsonFilter () {
      if (!this.chapteJson || !this.chapteJson.length) {
        // 将签章数据置为null
        this.signatoryJson.forEach(sign => {
          sign.chapteJson = null;
        });

        return (this.chapteJson = []);
      }
      let chaptes = {};
      let chaptePage = {};
      let param = [];
      // 按现在存在的联系人列表对签章列表分类
      this.signatoryJson.forEach(sign => {
        chaptes[sign.signOwner] = this.chapteJson.filter(
          item => item.signOwner === sign.signOwner
        );
      });
      // 根据上面的分类再按照page分类
      for (let key in chaptes) {
        chaptePage[key] = {};

        chaptes[key].forEach(chapt => {
          let page = "page_" + chapt.page;
          if (!chaptePage[key][page]) {
            chaptePage[key][page] = { page: chapt.page, chaptes: [chapt] };
          } else {
            chaptePage[key][page].chaptes.push(chapt);
          }
        });
      }
      for (let key in chaptePage) {
        param[key] = [];
        for (let key1 in chaptePage[key]) {
          param[key].push(chaptePage[key][key1]);
        }
      }
      // 将签章数据放入联系人列表
      this.signatoryJson.forEach(sign => {
        sign.chapteJson = param[sign.signOwner].length
          ? param[sign.signOwner]
          : null;
      });
    },
    // 根据cindex删除签章
    delChapteByCindex (cindex) {
      if (!this.chapteJson.length) return;

      this.chapteJson = this.chapteJson.filter(t => t.cindex != cindex);
      this.listChapteJsonCindex();
    },
    // 给签章列表添加cindex
    listChapteJsonCindex () {
      if (!this.chapteJson.length) return;
      for (let i = 0; i < this.chapteJson.length; i++) {
        this.chapteJson[i].cindex = i;
      }
    },
    // 前往支付
    toPay () {
      this.payDisabled = true;
      const param = Object.assign(this.payInfoData.param, { pay: 1 });
      let hh = new Date().getHours();
      let mm = new Date().getMinutes();
      param.signExpire = this.signlinktime + " " + hh + ":" + mm + ":00";
      let water = JSON.parse(JSON.stringify(this.waterConfig));
      if (water && water.floatAlpha && water.floatAlpha > 1) water.floatAlpha = water.floatAlpha / 100;
      if (water.switch) param.waterConfig = JSON.stringify(water); //水印
      if (this.payInfoData.batch) {
        // ApiCorpMethods.BatchContractController.batchCreate(param).then((res) => {
        let { multiFileKey } = this.$route.query;
        if (multiFileKey) param.multiFileKey = multiFileKey;
        if (+param.flowId === 0) {
          delete param.flowId;
        }
        let arrproveList = this.signOrApproveListFn(param);
        postMultipleCreateApply(param).then(res => {
          if (+res.code === 10806) {
            this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            this.payDisabled = false;
            return;
          }
          if (+res.code === 0) {
            this.$message.success("发起签署成功");
            if (this.isGroup) {
              let paths = "";
              if (res.data.selfSign === 1) {
                paths = "/corp/signInfo/signList?signStatus=4";
              } else if (res.data.selfSign === 2) {
                paths = "/corp/signInfo/signList?signStatus=5";
              } else {
                // paths = "/corp/signInfo/applyList?notMeSign=1";
                paths = `/corp/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
              }
              this.$router.push({ path: paths });
            } else {
              let paths = "";
              if (res.data.selfSign === 1) {
                paths = "/signInfo/signList?signStatus=2";
              } else if (res.data.selfSign === 2) {
                paths = "/corp/signInfo/signList?signStatus=5";
              } else {
                // paths = "/signInfo/applyList?notMeSign=1";
                paths = `/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
              }
              this.$router.push({ path: paths });
            }
            return;
          }
          this.$message.error(res.description || "支付失败");
          this.payDisabled = false;
        });
      } else {
        let { multiFileKey } = this.$route.query;
        if (multiFileKey) param.multiFileKey = multiFileKey;
        if (+param.flowId === 0) {
          delete param.flowId;
        }
        let arrproveList = this.signOrApproveListFn(param);
        postMultipleCreateApply(param)
          .then(res => {
            if (+res.code === 0) {
              this.$message.success("发起签署成功");
              if (this.isGroup) {
                let paths = "";
                if (res.data.selfSign === 1) {
                  paths = "/corp/signInfo/signList?signStatus=4";
                } else if (res.data.selfSign === 2) {
                  paths = "/corp/signInfo/signList?signStatus=5";
                } else {
                  // paths = "/corp/signInfo/applyList?notMeSign=1";
                  paths = `/corp/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
                }
                this.$router.push({ path: paths });
              } else {
                let paths = "";
                if (res.data.selfSign === 1) {
                  paths = "/signInfo/signList?signStatus=2";
                } else if (res.data.selfSign === 2) {
                  paths = "/corp/signInfo/signList?signStatus=5";
                } else {
                  // paths = "/signInfo/applyList?notMeSign=1";
                  paths = `/signInfo/signList?signStatus=${arrproveList}&mySendTo=1`;
                }
                this.$router.push({ path: paths });
              }
              return;
            }
            if (+res.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
              this.payDisabled = false;
            }
            this.$message.error(res.description || "支付失败");
            this.payDisabled = false;
          })
          .catch(err => {
            if (+err.code === 10806) {
              this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
            }
            this.payDisabled = false;
          });
      }
    },
    // 联系方式改变，或点击修改btn
    handleTargetIdChange (sign) {
      sign.disabled = "";
      sign.isEncrypt = false;
      sign.ischange = 0;
      sign.identityNo = "";
      if (!sign.canSelectArray || sign.canSelectArray.length === 0) {
        sign.name = "";
      }
    },

    // 数字证书切换
    handleChangeCa () {
      if (this.contractInfo.consumMode == 1) return;
    },
    // 重置
    reset () {
      this.telPageInfo = {
        itemPage: 1,
        pageSize: 6,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      };
      this.getTelList();
    },
    // 获取最近联系人
    getTelList () {
      postTelFindByPagedEnterpriseList(this.telPageInfo)
        .then(data => {
          this.telList = data.data;
          this.telPageInfo.itemPage = data.pageNum;
          this.telPageInfo.pageSize = data.pageSize;
          this.telPageInfo.total = data.total;
        })
        .catch(err => { });
    },
    // 获取本公司部门
    getDepartmentList () {
      // ApiCorpMethods.CorpCommonController.listGroup().then(res => {
      ApiCorpMethods.CorpCommonController.userGetCorpGroup({
        corpUserId: this.activeTabSigner
      }).then(res => {
        if (res.success) {
          this.department = res.data;
        }
      });
    },

    handleSizeChange (val) {
      this.telPageInfo.itemPage = 1;
      this.telPageInfo.pageSize = val;
      this.getTelList();
    },
    handleCurrentChange (val) {
      this.telPageInfo.itemPage = val;
      this.getTelList();
    },
    // 另外一边打开通讯录
    handleTelsClickOther: function (item, index) {
      item.openUserTab = true;
      this.selectIndex = index;
      this.getTelList();
      this.activeTabSigner = 'default'
      this.showTel = true;
      // 清空集团账户选择人列表
      this.myCorpModel.keyword = "";
      // if (this.isGroup) {
      //   this.clickHandleMyCorpSearch();
      // }
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[this.selectIndex].openUserTab = true;
      }
    },
    // 处理用户类型选择
    handleSignUserType (signator, index) {
      signator.authLevel = null;
      // signator.needRead = false; //关于切换类型后，强制阅读的图标bug
      signator.readTime = null;
      signator.faceOrVideo = false;
      signator.userType = 1;
      signator.extraHandSign = null;
      signator.signLevel = null; // 签字设置 (图形章，手写签字)
      // signator.signatoryUserType == 1 为企业时，去除人脸识别默认选中。为个人时，人脸默认选中
      if (signator.signatoryUserType == 1) signator.authLevel = null;
      if (signator.signatoryUserType == 0) signator.authLevel = 11;
      this.getUserInfoBySelectTargetId({ account: signator.account, selectIndex: index, type: false });
    },
    // 通讯录点击选中一行
    handleTelRowClickSelectRow (row, event, column) {
      if (row) {
        this.tableSignorSelectRow = row;
        this.tableSignorSelectRowTargetID = row.mobileOrChild;
      } else {
        this.tableSignorSelectRow = undefined;
        this.tableSignorSelectRowTargetID = "";
      }
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    showSignSet () {
      var _this = this;
    },
    // 是否需要人脸
    authLevelChange (e) {
      // console.log(this.signatoryJson[e]);
      // console.log(e,111111111)
      // if(!e) {
      //     this.authLevelShow = true
      // }
    },
    // office编辑后转换
    officePDFInfo (fileInfo, index) {
      // this.loadingStart();
      console.log("fileInfo", fileInfo);
      const { fileName, targetId, fileType } = fileInfo;
      ApiMethods.AIDocSmart.converToPDF({ ...fileInfo }).then(res => {
        const { data } = res;
        if (res.success) {
          const file = {
            fileName: fileName,
            fileType: 1,
            tempFile: data.tempFile,
            items: data.items,
            sort: null,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: fileName,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            },
            sourceFile: fileInfo
          };
          if (index >= 0) {
            this.$set(this.fileList, index, file);
          } else {
            this.fileList.push(file);
          }
          if (this.nextstep) this.openSign();
        } else {
          this.$message.error(res.description);
        }
        this.loadingClose();
      });
    },
    // 将从智能合同相关页面来的信息。获取到PDF信息
    coverPDFInfo (fileInfo) {
      this.loadingStart();
      console.log('fileInfo', fileInfo);
      const { fileName, targetId, fileType } = fileInfo;
      this.contractInfo.contractName = fileName;
      ApiMethods.AIDocSmart.converToPDF({ ...fileInfo }).then(res => {
        const { data } = res,
          file_name = `${fileName}.${targetId.substring(
            targetId.lastIndexOf(".") + 1,
            targetId.length
          )}`;
        if (res.success) {
          this.fileList.push({
            fileName: file_name,
            fileType: 1,
            tempFile: data.tempFile,
            sourceFile: fileInfo,
            items: data.items,
            sort: null,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: file_name,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            }
          });
        } else {
          this.$message.error(res.description);
        }
        this.loadingClose();
      });
    }
  },
  components: {
    ReadPup,
    accessPup,
    approvalProcess,
    ContractView,
    ToolTip,
    SingerForm,
    draggable,
    Flow,
    SignInfoTipsDialog,
    ViewFilesToDoc,
    ViewFilesToImg,
    waterMark,
    dialogPup,
    tplSetting,
    moreSetting,
    regularPup,
    editorPup,
    flowPath,
    selfSelection,
    cooperPup,
    toCreate
  },
  head: {
    title: "文件发起",
  },
  layout: "fullpage"
};
</script>
<style scoped lang="less">
@import url("./toCreate.less");
</style>



// WEBPACK FOOTER //
// pages/initiation/collaborationEdit.vue